// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReSharper disable once CssBrowserCompatibility */

.k-text-selection ::selection {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-block,
.k-panel {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-block > .k-header,
.k-panel > .k-header {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-content {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-hr { border-color: var(--dark-color-border); }

.k-dirty { border-color: var(--dark-color-error) var(--dark-color-error) transparent transparent; }

[dir="rtl"] .k-dirty,
.k-rtl .k-dirty { border-color: transparent transparent var(--dark-color-error) var(--dark-color-error); }

.k-placeholder-line { background-color: rgba(0, 0, 0, 0.1); }

.k-drop-hint-start,
.k-drop-hint-end { border-color: transparent; }

.k-drop-hint-line { background-color: var(--dark-color-primary); }

.k-drop-hint-h .k-drop-hint-start { border-left-color: var(--dark-color-primary); }

.k-drop-hint-h .k-drop-hint-end { border-right-color: var(--dark-color-primary); }

.k-drop-hint-v .k-drop-hint-start { border-top-color: var(--dark-color-primary); }

.k-drop-hint-v .k-drop-hint-end { border-bottom-color: var(--dark-color-primary); }

.k-drag-clue {
    background-color: var(--dark-color-primary);
    border-color: #207afd;
    color: var(--dark-color-base-text);
}

.k-reorder-cue::before, .k-reorder-cue::after { border: 3px solid transparent; }

.k-loading-color { background-color: var(--dark-color-component-bg); }

.k-i-loading { background-color: transparent; }

.k-i-loading::before,
.k-i-loading::after,
.k-loading-image::before,
.k-loading-image::after {
    background-color: transparent;
    border-bottom-color: transparent;
    border-top-color: transparent;
}

.k-i-loading::before,
.k-loading-image::before {
    border-color: currentColor;
    border-right-color: transparent !important;
}

.k-touch-scrollbar {
    background-color: #858585;
    border: 1px solid #8a8a8a;
}

.k-marquee-color {
    background-color: var(--dark-color-primary);
    border-color: #207afd;
    color: var(--dark-color-base-text);
}

.k-marquee-text { color: var(--dark-color-base-text); }

.k-pre > .k-code {
    background-color: transparent;
    border-color: transparent;
}

.k-body {
    background-color: var(--dark-color-body-bg);
    color: var(--dark-color-body-text);
}

.k-pre,
.k-code {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-border-primary { border-color: var(--dark-color-primary) !important; }

.k-border-secondary { border-color: var(--dark-color-secondary) !important; }

.k-border-tertiary { border-color: var(--dark-color-tertiary) !important; }

.k-border-info { border-color: var(--dark-color-info) !important; }

.k-border-success { border-color: var(--dark-color-success) !important; }

.k-border-warning { border-color: var(--dark-color-warning) !important; }

.k-border-error { border-color: var(--dark-color-error) !important; }

.k-border-dark { border-color: var(--dark-color-base-bg) !important; }

.k-border-light { border-color: #f8f9fa !important; }

.k-border-inverse { border-color: #f8f9fa !important; }

.k-text-base,
.k-color-base { color: var(--dark-color-base-text); }

.k-color-inherit { color: inherit; }

.k-text-primary,
.k-color-primary { color: var(--dark-color-primary) !important; }

.k-text-secondary,
.k-color-secondary { color: var(--dark-color-secondary) !important; }

.k-text-tertiary,
.k-color-tertiary { color: var(--dark-color-tertiary) !important; }

.k-text-info,
.k-color-info { color: var(--dark-color-info) !important; }

.k-text-success,
.k-color-success { color: var(--dark-color-success) !important; }

.k-text-warning,
.k-color-warning { color: var(--dark-color-warning) !important; }

.k-text-error,
.k-color-error { color: var(--dark-color-error) !important; }

.k-text-dark,
.k-color-dark { color: var(--dark-color-base-bg) !important; }

.k-text-light,
.k-color-light { color: #f8f9fa !important; }

.k-text-inverse,
.k-color-inverse { color: #f8f9fa !important; }

.k-bg-primary { background-color: var(--dark-color-primary) !important; }

.k-bg-secondary { background-color: var(--dark-color-secondary) !important; }

.k-bg-tertiary { background-color: var(--dark-color-tertiary) !important; }

.k-bg-info { background-color: var(--dark-color-info) !important; }

.k-bg-success { background-color: var(--dark-color-success) !important; }

.k-bg-warning { background-color: var(--dark-color-warning) !important; }

.k-bg-error { background-color: var(--dark-color-error) !important; }

.k-bg-dark { background-color: var(--dark-color-base-bg) !important; }

.k-bg-light { background-color: #f8f9fa !important; }

.k-bg-inverse { background-color: #f8f9fa !important; }

.k-state-primary {
    background-color: #cfe2ff;
    border-color: #bbd6fe;
    color: #073984;
}

.k-state-secondary {
    background-color: #e2e3e5;
    border-color: #d6d8db;
    color: #383d41;
}

.k-state-tertiary {
    background-color: #e2d9f3;
    border-color: #d7caee;
    color: #3a2264;
}

.k-state-info {
    background-color: #cff4fc;
    border-color: #bbf0fb;
    color: #07697d;
}

.k-state-success {
    background-color: #d1e7dd;
    border-color: #bfddcf;
    color: #0d462c;
}

.k-state-warning {
    background-color: #fff3cd;
    border-color: #ffeeba;
    color: #856404;
}

.k-state-error {
    background-color: #f8d7da;
    border-color: #f5c6cb;
    color: #721c24;
}

.k-state-dark {
    background-color: #d3d3d4;
    border-color: #c1c2c3;
    color: #111315;
}

.k-state-light {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-state-inverse {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-info-colored {
    background-color: #f0f9ff;
    border-color: #d0d9df;
    color: #50607f;
}

.k-success-colored {
    background-color: #f0fff0;
    border-color: #d0dfd0;
    color: #507f50;
}

.k-error-colored {
    background-color: #fff0f0;
    border-color: #dfd0d0;
    color: #7f5050;
}

.k-inset { box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.03), inset 0 4px 5px 0 rgba(0, 0, 0, 0.04); }

.k-messagebox-primary {
    background-color: #cfe2ff;
    border-color: #bbd6fe;
    color: #073984;
}

.k-messagebox-secondary {
    background-color: #e2e3e5;
    border-color: #d6d8db;
    color: #383d41;
}

.k-messagebox-tertiary {
    background-color: #e2d9f3;
    border-color: #d7caee;
    color: #3a2264;
}

.k-messagebox-info {
    background-color: #cff4fc;
    border-color: #bbf0fb;
    color: #07697d;
}

.k-messagebox-success {
    background-color: #d1e7dd;
    border-color: #bfddcf;
    color: #0d462c;
}

.k-messagebox-warning {
    background-color: #fff3cd;
    border-color: #ffeeba;
    color: #856404;
}

.k-messagebox-error {
    background-color: #f8d7da;
    border-color: #f5c6cb;
    color: #721c24;
}

.k-messagebox-dark {
    background-color: #d3d3d4;
    border-color: #c1c2c3;
    color: #111315;
}

.k-messagebox-light {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-messagebox-inverse {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-checkbox {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-secondary);
}

.k-checkbox:focus,
.k-checkbox.k-focus {
    border-color: #07377f;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-checkbox:indeterminate,
.k-checkbox.k-indeterminate {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-checkbox:checked,
.k-checkbox.k-checked {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-checkbox:checked:focus,
.k-checkbox.k-checked.k-focus {
    border-color: var(--dark-color-primary);
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-checkbox.k-invalid { border-color: var(--dark-color-error); }

.k-checkbox.k-invalid + .k-checkbox-label { color: var(--dark-color-error); }

.k-checkbox-wrap .k-ripple-blob { color: var(--dark-color-primary); }

.k-ripple-container .k-checkbox::after { background: var(--dark-color-primary); }

.k-list {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-list-group-sticky-header { border-color: inherit; }

.k-list-item:hover, .k-list-optionlabel:hover, .k-list-item.k-hover, .k-hover.k-list-optionlabel {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-list-item:focus, .k-list-optionlabel:focus, .k-list-item.k-focus, .k-focus.k-list-optionlabel { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-list-item.k-selected, .k-selected.k-list-optionlabel {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {
    background-color: #0c65e9;
    color: var(--dark-color-hovered-text);
}

.k-list-group-item { border-color: inherit; }

.k-list-item-group-label {
    background-color: var(--dark-color-base-text);
    color: #000000;
}

.k-no-data, .k-nodata { color: var(--dark-color-subtle-text); }

.k-listgroup {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-overlay { background-color: var(--dark-color-component-bg); }

.k-overlay-primary { background-color: var(--dark-color-primary); }

.k-overlay-secondary { background-color: var(--dark-color-secondary); }

.k-overlay-tertiary { background-color: var(--dark-color-tertiary); }

.k-overlay-info { background-color: var(--dark-color-info); }

.k-overlay-success { background-color: var(--dark-color-success); }

.k-overlay-warning { background-color: var(--dark-color-warning); }

.k-overlay-error { background-color: var(--dark-color-error); }

.k-overlay-dark { background-color: var(--dark-color-base-bg); }

.k-overlay-light { background-color: #f8f9fa; }

.k-overlay-inverse { background-color: #f8f9fa; }

.k-shadow { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }

.k-popup {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);
    color: var(--dark-color-component-text);
}

.k-badge-border-cutout { box-shadow: 0 0 0 2px #000000; }

.k-badge-solid.k-badge-primary {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-badge-solid.k-badge-secondary {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-badge-solid.k-badge-tertiary {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-badge-solid.k-badge-info {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-badge-solid.k-badge-success {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-badge-solid.k-badge-warning {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-badge-solid.k-badge-error {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-badge-solid.k-badge-dark {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-badge-solid.k-badge-light {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-badge-solid.k-badge-inverse {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-badge-outline {
    background-color: var(--dark-color-component-bg);
    border-color: currentColor;
}

.k-badge-outline.k-badge-primary { color: var(--dark-color-primary); }

.k-badge-outline.k-badge-secondary { color: var(--dark-color-secondary); }

.k-badge-outline.k-badge-tertiary { color: var(--dark-color-tertiary); }

.k-badge-outline.k-badge-info { color: var(--dark-color-info); }

.k-badge-outline.k-badge-success { color: var(--dark-color-success); }

.k-badge-outline.k-badge-warning { color: var(--dark-color-warning); }

.k-badge-outline.k-badge-error { color: var(--dark-color-error); }

.k-badge-outline.k-badge-dark { color: var(--dark-color-base-bg); }

.k-badge-outline.k-badge-light { color: #f8f9fa; }

.k-badge-outline.k-badge-inverse { color: #f8f9fa; }

.k-button-flat { border-color: transparent !important; }

.k-button-solid-base {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-button-solid-base:hover, .k-button-solid-base.k-hover {
    background-color: #454d55;
    border-color: #4b545c;
}

.k-button-solid-base:focus, .k-button-solid-base.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-button-solid-base:active, .k-button-solid-base.k-active {
    background-color: #4b545c;
    border-color: #515a63;
}

.k-button-solid-base.k-selected {
    background-color: #408cfd;
    border-color: #4c94fe;
    color: white;
}

.k-button-solid-primary {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {
    background-color: #3385fd;
    border-color: #408cfd;
}

.k-button-solid-primary:focus, .k-button-solid-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }

.k-button-solid-primary:active, .k-button-solid-primary.k-active {
    background-color: #408cfd;
    border-color: #4c94fe;
}

.k-button-solid-primary.k-selected {
    background-color: #408cfd;
    border-color: #4c94fe;
}

.k-button-solid-secondary {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {
    background-color: #7f8890;
    border-color: #868e96;
}

.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }

.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {
    background-color: #868e96;
    border-color: #8d959c;
}

.k-button-solid-secondary.k-selected {
    background-color: #868e96;
    border-color: #8d959c;
}

.k-button-solid-tertiary {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {
    background-color: #855fca;
    border-color: #8c68ce;
}

.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }

.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {
    background-color: #8c68ce;
    border-color: #9472d1;
}

.k-button-solid-tertiary.k-selected {
    background-color: #8c68ce;
    border-color: #9472d1;
}

.k-button-solid-info {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-button-solid-info:hover, .k-button-solid-info.k-hover {
    background-color: #2fd3f4;
    border-color: #3cd5f4;
}

.k-button-solid-info:focus, .k-button-solid-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }

.k-button-solid-info:active, .k-button-solid-info.k-active {
    background-color: #3cd5f4;
    border-color: #48d8f5;
}

.k-button-solid-info.k-selected {
    background-color: #3cd5f4;
    border-color: #48d8f5;
}

.k-button-solid-success {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-button-solid-success:hover, .k-button-solid-success.k-hover {
    background-color: #1fa768;
    border-color: #21b26f;
}

.k-button-solid-success:focus, .k-button-solid-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }

.k-button-solid-success:active, .k-button-solid-success.k-active {
    background-color: #21b26f;
    border-color: #23bd75;
}

.k-button-solid-success.k-selected {
    background-color: #21b26f;
    border-color: #23bd75;
}

.k-button-solid-warning {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {
    background-color: #ffcb2d;
    border-color: #ffce3a;
}

.k-button-solid-warning:focus, .k-button-solid-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }

.k-button-solid-warning:active, .k-button-solid-warning.k-active {
    background-color: #ffce3a;
    border-color: #ffd147;
}

.k-button-solid-warning.k-selected {
    background-color: #ffce3a;
    border-color: #ffd147;
}

.k-button-solid-error {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-button-solid-error:hover, .k-button-solid-error.k-hover {
    background-color: #e25663;
    border-color: #e4606d;
}

.k-button-solid-error:focus, .k-button-solid-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }

.k-button-solid-error:active, .k-button-solid-error.k-active {
    background-color: #e4606d;
    border-color: #e56b77;
}

.k-button-solid-error.k-selected {
    background-color: #e4606d;
    border-color: #e56b77;
}

.k-button-solid-dark {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {
    background-color: #32383e;
    border-color: #383f45;
}

.k-button-solid-dark:focus, .k-button-solid-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }

.k-button-solid-dark:active, .k-button-solid-dark.k-active {
    background-color: #383f45;
    border-color: #3d454c;
}

.k-button-solid-dark.k-selected {
    background-color: #383f45;
    border-color: #3d454c;
}

.k-button-solid-light {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-solid-light:hover, .k-button-solid-light.k-hover {
    background-color: white;
    border-color: white;
}

.k-button-solid-light:focus, .k-button-solid-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-solid-light:active, .k-button-solid-light.k-active {
    background-color: white;
    border-color: white;
}

.k-button-solid-light.k-selected {
    background-color: white;
    border-color: white;
}

.k-button-solid-inverse {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {
    background-color: white;
    border-color: white;
}

.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {
    background-color: white;
    border-color: white;
}

.k-button-solid-inverse.k-selected {
    background-color: white;
    border-color: white;
}

.k-button-outline-primary {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-primary);
}

.k-button-outline-primary:hover, .k-button-outline-primary.k-hover {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-button-outline-primary:focus, .k-button-outline-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }

.k-button-outline-primary:active, .k-button-outline-primary.k-active {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-button-outline-primary.k-selected {
    background-color: var(--dark-color-selected-bg);
    border-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-button-outline-secondary {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-secondary);
}

.k-button-outline-secondary:hover, .k-button-outline-secondary.k-hover {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-button-outline-secondary:focus, .k-button-outline-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }

.k-button-outline-secondary:active, .k-button-outline-secondary.k-active {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-button-outline-secondary.k-selected {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-button-outline-tertiary {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-tertiary);
}

.k-button-outline-tertiary:hover, .k-button-outline-tertiary.k-hover {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-button-outline-tertiary:focus, .k-button-outline-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }

.k-button-outline-tertiary:active, .k-button-outline-tertiary.k-active {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-button-outline-tertiary.k-selected {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-button-outline-info {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-info);
}

.k-button-outline-info:hover, .k-button-outline-info.k-hover {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-button-outline-info:focus, .k-button-outline-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }

.k-button-outline-info:active, .k-button-outline-info.k-active {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-button-outline-info.k-selected {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-button-outline-success {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-success);
}

.k-button-outline-success:hover, .k-button-outline-success.k-hover {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-button-outline-success:focus, .k-button-outline-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }

.k-button-outline-success:active, .k-button-outline-success.k-active {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-button-outline-success.k-selected {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-button-outline-warning {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-warning);
}

.k-button-outline-warning:hover, .k-button-outline-warning.k-hover {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-button-outline-warning:focus, .k-button-outline-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }

.k-button-outline-warning:active, .k-button-outline-warning.k-active {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-button-outline-warning.k-selected {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-button-outline-error {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-error);
}

.k-button-outline-error:hover, .k-button-outline-error.k-hover {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-button-outline-error:focus, .k-button-outline-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }

.k-button-outline-error:active, .k-button-outline-error.k-active {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-button-outline-error.k-selected {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-button-outline-dark {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-base-bg);
}

.k-button-outline-dark:hover, .k-button-outline-dark.k-hover {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-button-outline-dark:focus, .k-button-outline-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }

.k-button-outline-dark:active, .k-button-outline-dark.k-active {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-button-outline-dark.k-selected {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-button-outline-light {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: #f8f9fa;
}

.k-button-outline-light:hover, .k-button-outline-light.k-hover {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-light:focus, .k-button-outline-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-outline-light:active, .k-button-outline-light.k-active {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-light.k-selected {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-inverse {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: #f8f9fa;
}

.k-button-outline-inverse:hover, .k-button-outline-inverse.k-hover {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-inverse:focus, .k-button-outline-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-outline-inverse:active, .k-button-outline-inverse.k-active {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-inverse.k-selected {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-button-outline-base {
    background-color: transparent;
    border-color: currentColor;
    box-shadow: none;
    color: var(--dark-color-base-text);
}

.k-button-outline-base:hover, .k-button-outline-base.k-hover {
    background-color: #ffffff;
    border-color: #ffffff;
    color: black;
}

.k-button-outline-base:focus, .k-button-outline-base.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 255, 255, 0.5); }

.k-button-outline-base:active, .k-button-outline-base.k-active {
    background-color: #ffffff;
    border-color: #ffffff;
    color: black;
}

.k-button-outline-base.k-selected {
    background-color: #ffffff;
    border-color: #ffffff;
    color: black;
}

.k-button-flat-primary { color: var(--dark-color-primary); }

.k-button-flat-secondary { color: var(--dark-color-secondary); }

.k-button-flat-tertiary { color: var(--dark-color-tertiary); }

.k-button-flat-info { color: var(--dark-color-info); }

.k-button-flat-success { color: var(--dark-color-success); }

.k-button-flat-warning { color: var(--dark-color-warning); }

.k-button-flat-error { color: var(--dark-color-error); }

.k-button-flat-dark { color: var(--dark-color-base-bg); }

.k-button-flat-light { color: #f8f9fa; }

.k-button-flat-inverse { color: #f8f9fa; }

.k-button-flat-base { color: inherit; }

.k-button-link-primary { color: var(--dark-color-primary); }

.k-button-link-primary:hover, .k-button-link-primary.k-hover { color: #3485fd; }

.k-button-link-primary:focus, .k-button-link-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }

.k-button-link-primary:active, .k-button-link-primary.k-active { color: #3485fd; }

.k-button-link-primary.k-selected { color: #3485fd; }

.k-button-link-secondary { color: var(--dark-color-secondary); }

.k-button-link-secondary:hover, .k-button-link-secondary.k-hover { color: #848b92; }

.k-button-link-secondary:focus, .k-button-link-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }

.k-button-link-secondary:active, .k-button-link-secondary.k-active { color: #848b92; }

.k-button-link-secondary.k-selected { color: #848b92; }

.k-button-link-tertiary { color: var(--dark-color-tertiary); }

.k-button-link-tertiary:hover, .k-button-link-tertiary.k-hover { color: #8660cb; }

.k-button-link-tertiary:focus, .k-button-link-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }

.k-button-link-tertiary:active, .k-button-link-tertiary.k-active { color: #8660cb; }

.k-button-link-tertiary.k-selected { color: #8660cb; }

.k-button-link-info { color: var(--dark-color-info); }

.k-button-link-info:hover, .k-button-link-info.k-hover { color: #34d2f2; }

.k-button-link-info:focus, .k-button-link-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }

.k-button-link-info:active, .k-button-link-info.k-active { color: #34d2f2; }

.k-button-link-info.k-selected { color: #34d2f2; }

.k-button-link-success { color: var(--dark-color-success); }

.k-button-link-success:hover, .k-button-link-success.k-hover { color: #3e9a6f; }

.k-button-link-success:focus, .k-button-link-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }

.k-button-link-success:active, .k-button-link-success.k-active { color: #3e9a6f; }

.k-button-link-success.k-selected { color: #3e9a6f; }

.k-button-link-warning { color: var(--dark-color-warning); }

.k-button-link-warning:hover, .k-button-link-warning.k-hover { color: #ffcb2f; }

.k-button-link-warning:focus, .k-button-link-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }

.k-button-link-warning:active, .k-button-link-warning.k-active { color: #ffcb2f; }

.k-button-link-warning.k-selected { color: #ffcb2f; }

.k-button-link-error { color: var(--dark-color-error); }

.k-button-link-error:hover, .k-button-link-error.k-hover { color: #e25563; }

.k-button-link-error:focus, .k-button-link-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }

.k-button-link-error:active, .k-button-link-error.k-active { color: #e25563; }

.k-button-link-error.k-selected { color: #e25563; }

.k-button-link-dark { color: var(--dark-color-base-bg); }

.k-button-link-dark:hover, .k-button-link-dark.k-hover { color: #45484b; }

.k-button-link-dark:focus, .k-button-link-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }

.k-button-link-dark:active, .k-button-link-dark.k-active { color: #45484b; }

.k-button-link-dark.k-selected { color: #45484b; }

.k-button-link-light { color: #f8f9fa; }

.k-button-link-light:hover, .k-button-link-light.k-hover { color: #f9fafb; }

.k-button-link-light:focus, .k-button-link-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-link-light:active, .k-button-link-light.k-active { color: #f9fafb; }

.k-button-link-light.k-selected { color: #f9fafb; }

.k-button-link-inverse { color: #f8f9fa; }

.k-button-link-inverse:hover, .k-button-link-inverse.k-hover { color: #f9fafb; }

.k-button-link-inverse:focus, .k-button-link-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }

.k-button-link-inverse:active, .k-button-link-inverse.k-active { color: #f9fafb; }

.k-button-link-inverse.k-selected { color: #f9fafb; }

.k-button-link-base { color: var(--dark-color-base-text); }

.k-button-link-base:hover, .k-button-link-base.k-hover { color: white; }

.k-button-link-base:focus, .k-button-link-base.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 255, 255, 0.5); }

.k-button-link-base:active, .k-button-link-base.k-active { color: white; }

.k-button-link-base.k-selected { color: white; }

.k-button-clear-primary { color: var(--dark-color-primary); }

.k-button-clear-secondary { color: var(--dark-color-secondary); }

.k-button-clear-tertiary { color: var(--dark-color-tertiary); }

.k-button-clear-info { color: var(--dark-color-info); }

.k-button-clear-success { color: var(--dark-color-success); }

.k-button-clear-warning { color: var(--dark-color-warning); }

.k-button-clear-error { color: var(--dark-color-error); }

.k-button-clear-dark { color: var(--dark-color-base-bg); }

.k-button-clear-light { color: #f8f9fa; }

.k-button-clear-inverse { color: #f8f9fa; }

.k-button-clear-base { color: var(--dark-color-base-text); }

.k-split-button:focus,
.k-split-button.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-input::-webkit-input-placeholder, .k-picker::-webkit-input-placeholder { color: #ced4da; }

.k-input:-ms-input-placeholder, .k-picker:-ms-input-placeholder { color: #ced4da; }

.k-input::-ms-input-placeholder, .k-picker::-ms-input-placeholder { color: #ced4da; }

.k-input::placeholder,
.k-picker::placeholder { color: #ced4da; }

.k-input:-ms-input-placeholder,
.k-picker:-ms-input-placeholder { color: #ced4da; }

.k-input-inner::-webkit-input-placeholder { color: #ced4da; }

.k-input-inner:-ms-input-placeholder { color: #ced4da; }

.k-input-inner::-ms-input-placeholder { color: #ced4da; }

.k-input-inner::placeholder { color: #ced4da; }

.k-input-inner:-ms-input-placeholder { color: #ced4da; }

.k-picker .k-input-button {
    background: none;
    border-color: transparent;
    color: inherit;
}

.k-input {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: #dee2e6;
}

.k-input:focus, .k-input.k-focus {
    background-color: var(--dark-color-component-bg);
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    color: #dee2e6;
}

.k-input:focus-within {
    background-color: var(--dark-color-component-bg);
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    color: #dee2e6;
}

.k-input.k-invalid, .k-input.ng-invalid.ng-touched, .k-input.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }

.k-input.k-invalid .k-input-validation-icon, .k-input.ng-invalid.ng-touched .k-input-validation-icon, .k-input.ng-invalid.ng-dirty .k-input-validation-icon { color: var(--dark-color-error); }

.k-input.k-invalid:focus, .k-input.k-invalid.k-focus, .k-input.ng-invalid.ng-touched:focus, .k-input.ng-invalid.ng-touched.k-focus, .k-input.ng-invalid.ng-dirty:focus, .k-input.ng-invalid.ng-dirty.k-focus { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }

.k-input.k-invalid:focus-within, .k-input.ng-invalid.ng-touched:focus-within, .k-input.ng-invalid.ng-dirty:focus-within { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }

.k-picker {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-picker:hover, .k-picker.k-hover {
    background-color: #454d55;
    border-color: #4b545c;
}

.k-picker:focus, .k-picker.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-picker:focus-within { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-picker.k-invalid, .k-picker.ng-invalid.ng-touched, .k-picker.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }

.k-picker.k-invalid .k-input-validation-icon, .k-picker.ng-invalid.ng-touched .k-input-validation-icon, .k-picker.ng-invalid.ng-dirty .k-input-validation-icon { color: var(--dark-color-error); }

.k-picker.k-invalid:focus, .k-picker.k-invalid.k-focus, .k-picker.ng-invalid.ng-touched:focus, .k-picker.ng-invalid.ng-touched.k-focus, .k-picker.ng-invalid.ng-dirty:focus, .k-picker.ng-invalid.ng-dirty.k-focus { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }

.k-picker.k-invalid:focus-within, .k-picker.ng-invalid.ng-touched:focus-within, .k-picker.ng-invalid.ng-dirty:focus-within { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }

.k-table,
.k-data-table {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-table-thead,
.k-table-header,
.k-table-group-sticky-header {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-table-tfoot,
.k-table-footer {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-table-group-row {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-table-group-td > span {
    background-color: #ffffff;
    color: #000000;
}

.k-table-alt-row { background-color: rgba(255, 255, 255, 0.04); }

.k-table-tbody .k-table-row:hover,
.k-table-list .k-table-row:hover,
.k-table-tbody .k-table-row.k-hover,
.k-table-list .k-table-row.k-hover { background-color: rgba(255, 255, 255, 0.08); }

.k-table-tbody .k-table-row.k-focus,
.k-table-list .k-table-row.k-focus,
.k-table-tbody .k-table-td.k-focus,
.k-table-list .k-table-td.k-focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }

.k-table-tbody .k-table-row.k-selected,
.k-table-list .k-table-row.k-selected {
    background-color: rgba(13, 110, 253, 0.25);
    border-color: var(--dark-color-border);
    color: var(--dark-color-selected-text);
}

.k-avatar-solid-primary {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-avatar-solid-secondary {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-avatar-solid-tertiary {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    color: white;
}

.k-avatar-solid-info {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-avatar-solid-success {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-avatar-solid-warning {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-avatar-solid-error {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-avatar-solid-dark {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-avatar-solid-light {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-avatar-solid-inverse {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: black;
}

.k-avatar-outline { border-color: currentColor; }

.k-avatar-outline-primary { color: var(--dark-color-primary); }

.k-avatar-outline-secondary { color: var(--dark-color-secondary); }

.k-avatar-outline-tertiary { color: var(--dark-color-tertiary); }

.k-avatar-outline-info { color: var(--dark-color-info); }

.k-avatar-outline-success { color: var(--dark-color-success); }

.k-avatar-outline-warning { color: var(--dark-color-warning); }

.k-avatar-outline-error { color: var(--dark-color-error); }

.k-avatar-outline-dark { color: var(--dark-color-base-bg); }

.k-avatar-outline-light { color: #f8f9fa; }

.k-avatar-outline-inverse { color: #f8f9fa; }

.k-chip-solid-base {
    background-color: #141414;
    border-color: #4d4d4d;
    color: var(--dark-color-base-text);
}

.k-chip-solid-base:focus, .k-chip-solid-base.k-focus {
    background-color: #141414;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.16);
}

.k-chip-solid-base:hover, .k-chip-solid-base.k-hover { background-color: #292929; }

.k-chip-solid-base.k-selected { background-color: #3d3d3d; }

.k-chip-solid-error {
    background-color: #120406;
    border-color: #421015;
    color: var(--dark-color-error);
}

.k-chip-solid-error:focus, .k-chip-solid-error.k-focus {
    background-color: #120406;
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);
}

.k-chip-solid-error:hover, .k-chip-solid-error.k-hover { background-color: #23080b; }

.k-chip-solid-error.k-selected { background-color: #350d11; }

.k-chip-solid-info {
    background-color: #011013;
    border-color: #043d48;
    color: var(--dark-color-info);
}

.k-chip-solid-info:focus, .k-chip-solid-info.k-focus {
    background-color: #011013;
    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);
}

.k-chip-solid-info:hover, .k-chip-solid-info.k-hover { background-color: #022026; }

.k-chip-solid-info.k-selected { background-color: #03303a; }

.k-chip-solid-warning {
    background-color: #140f01;
    border-color: #4d3a02;
    color: var(--dark-color-warning);
}

.k-chip-solid-warning:focus, .k-chip-solid-warning.k-focus {
    background-color: #140f01;
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);
}

.k-chip-solid-warning:hover, .k-chip-solid-warning.k-hover { background-color: #291f01; }

.k-chip-solid-warning.k-selected { background-color: #3d2e02; }

.k-chip-solid-success {
    background-color: #020b07;
    border-color: #082919;
    color: var(--dark-color-success);
}

.k-chip-solid-success:focus, .k-chip-solid-success.k-focus {
    background-color: #020b07;
    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);
}

.k-chip-solid-success:hover, .k-chip-solid-success.k-hover { background-color: #04160d; }

.k-chip-solid-success.k-selected { background-color: #062014; }

.k-chip-outline-base {
    background-color: var(--dark-color-component-bg);
    border-color: #ffffff;
    color: var(--dark-color-component-text);
}

.k-chip-outline-base:focus, .k-chip-outline-base.k-focus { box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.16); }

.k-chip-outline-base:hover, .k-chip-outline-base.k-hover {
    background-color: #ffffff;
    color: black;
}

.k-chip-outline-base.k-selected {
    background-color: #ffffff;
    color: black;
}

.k-chip-outline-error {
    background-color: #ffffff;
    border-color: var(--dark-color-error);
    color: var(--dark-color-error);
}

.k-chip-outline-error:focus, .k-chip-outline-error.k-focus { box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16); }

.k-chip-outline-error:hover, .k-chip-outline-error.k-hover {
    background-color: var(--dark-color-error);
    color: white;
}

.k-chip-outline-error.k-selected {
    background-color: var(--dark-color-error);
    color: white;
}

.k-chip-outline-info {
    background-color: #ffffff;
    border-color: var(--dark-color-info);
    color: var(--dark-color-info);
}

.k-chip-outline-info:focus, .k-chip-outline-info.k-focus { box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16); }

.k-chip-outline-info:hover, .k-chip-outline-info.k-hover {
    background-color: var(--dark-color-info);
    color: white;
}

.k-chip-outline-info.k-selected {
    background-color: var(--dark-color-info);
    color: white;
}

.k-chip-outline-warning {
    background-color: #ffffff;
    border-color: var(--dark-color-warning);
    color: var(--dark-color-warning);
}

.k-chip-outline-warning:focus, .k-chip-outline-warning.k-focus { box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16); }

.k-chip-outline-warning:hover, .k-chip-outline-warning.k-hover {
    background-color: var(--dark-color-warning);
    color: black;
}

.k-chip-outline-warning.k-selected {
    background-color: var(--dark-color-warning);
    color: black;
}

.k-chip-outline-success {
    background-color: #ffffff;
    border-color: var(--dark-color-success);
    color: var(--dark-color-success);
}

.k-chip-outline-success:focus, .k-chip-outline-success.k-focus { box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16); }

.k-chip-outline-success:hover, .k-chip-outline-success.k-hover {
    background-color: var(--dark-color-success);
    color: white;
}

.k-chip-outline-success.k-selected {
    background-color: var(--dark-color-success);
    color: white;
}

.k-no-color .k-color-preview-mask::before { background-color: #ffffff; }

.k-color-preview { border-color: var(--dark-color-border); }

.k-color-preview:hover, .k-color-preview.k-hover { border-color: #444a4f; }

.k-loader-primary { color: var(--dark-color-primary); }

.k-loader-secondary { color: var(--dark-color-base-bg); }

.k-loader-tertiary { color: var(--dark-color-tertiary); }

.k-loader-info { color: var(--dark-color-info); }

.k-loader-success { color: var(--dark-color-success); }

.k-loader-warning { color: var(--dark-color-warning); }

.k-loader-error { color: var(--dark-color-error); }

.k-loader-dark { color: var(--dark-color-base-bg); }

.k-loader-light { color: #f8f9fa; }

.k-loader-inverse { color: #f8f9fa; }

.k-loader-container-panel {
    background-color: #ffffff;
    border-color: var(--dark-color-border);
}

.k-loader-container-inner .k-text-secondary { color: var(--dark-color-base-bg) !important; }

.k-skeleton { background-color: rgba(248, 249, 250, 0.2); }

.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave.k-skeleton::after { background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.04), transparent); }

.k-menu-vertical > .k-separator { border-color: var(--dark-color-border); }

.k-menu-group .k-separator { border-color: var(--dark-color-border); }

.k-menu:not(.k-context-menu) {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-menu:not(.k-context-menu) > .k-item { color: rgba(255, 255, 255, 0.5); }

.k-menu:not(.k-context-menu) > .k-item:hover, .k-menu:not(.k-context-menu) > .k-item.k-hover { color: rgba(255, 255, 255, 0.7); }

.k-menu:not(.k-context-menu) > .k-item:active, .k-menu:not(.k-context-menu) > .k-item.k-active { color: rgba(255, 255, 255, 0.9); }

.k-menu:not(.k-context-menu) > .k-item:focus, .k-menu:not(.k-context-menu) > .k-item.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-menu-group,
.k-menu.k-context-menu {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-menu-group .k-item > .k-link:hover, .k-menu-group .k-item > .k-link.k-hover,
.k-menu.k-context-menu .k-item > .k-link:hover,
.k-menu.k-context-menu .k-item > .k-link.k-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-menu-group .k-item > .k-link:active, .k-menu-group .k-item > .k-link.k-active, .k-menu-group .k-item > .k-link.k-selected,
.k-menu.k-context-menu .k-item > .k-link:active,
.k-menu.k-context-menu .k-item > .k-link.k-active,
.k-menu.k-context-menu .k-item > .k-link.k-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-menu-group .k-item:focus, .k-menu-group .k-item.k-focus,
.k-menu.k-context-menu .k-item:focus,
.k-menu.k-context-menu .k-item.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-menu-scroll-button {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: rgba(255, 255, 255, 0.5);
}

.k-menu-scroll-button:hover { color: rgba(255, 255, 255, 0.7); }

.k-toolbar {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-toolbar .k-separator { border-color: inherit; }

.k-overflow-container .k-button:hover, .k-overflow-container .k-button.k-hover {
    background: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-overflow-container .k-button:focus, .k-overflow-container .k-button.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-overflow-container .k-button:active, .k-overflow-container .k-button.k-active {
    background: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-overflow-container .k-button.k-selected {
    background: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-overflow-container .k-button:disabled, .k-overflow-container .k-button.k-disabled { color: inherit; }

.k-floating-toolbar,
.editorToolbarWindow.k-window-content {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-form,
.k-form-inline { color: var(--dark-color-base-text); }

.k-form .k-form-legend,
.k-form-inline .k-form-legend { border-color: var(--dark-color-border); }

.k-form .k-field-info,
.k-form-inline .k-field-info { color: var(--dark-color-subtle-text); }

.k-form .k-alert-error,
.k-form-inline .k-alert-error { color: var(--dark-color-error); }

.k-form-error,
.k-text-error,
.k-form-field-error .k-label { color: var(--dark-color-error); }

.k-form-separator { border-color: var(--dark-color-border); }

.k-tooltip-wrapper .k-tooltip { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }

.k-tooltip {
    background-color: #ffffff;
    border-color: #ffffff;
    color: black;
}

.k-tooltip .k-callout { color: var(--dark-color-base-text); }

.k-tooltip-primary {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-tooltip-primary .k-callout { color: var(--dark-color-primary); }

.k-tooltip-info {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    color: white;
}

.k-tooltip-info .k-callout { color: var(--dark-color-info); }

.k-tooltip-success {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: white;
}

.k-tooltip-success .k-callout { color: var(--dark-color-success); }

.k-tooltip-warning {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    color: black;
}

.k-tooltip-warning .k-callout { color: var(--dark-color-warning); }

.k-tooltip-error {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: white;
}

.k-tooltip-error .k-callout { color: var(--dark-color-error); }

.k-listbox .k-list-scroller {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-listbox .k-drop-hint { border-top-color: var(--dark-color-primary); }

.k-progressbar .k-item { border-color: transparent; }

.k-progressbar {
    background-color: #e9ecef;
    color: black;
}

.k-progressbar .k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-progressbar .k-item { border-color: #000000; }

.k-progressbar-indeterminate {
    background-color: #e9ecef;
    background-image: linear-gradient(45deg, #d6d9dc 25%, transparent 25%, transparent 50%, #d6d9dc 50%, #d6d9dc 75%, transparent 75%, transparent);
    color: black;
}

.k-radio {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-secondary);
}

.k-radio:focus,
.k-radio.k-state-focus {
    border-color: #07377f;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-radio.k-invalid,
.k-radio.k-state-invalid,
.k-radio.ng-invalid.ng-touched,
.k-radio.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }

.k-radio.k-invalid + .k-radio-label,
.k-radio.k-state-invalid + .k-radio-label,
.k-radio.ng-invalid.ng-touched + .k-radio-label,
.k-radio.ng-invalid.ng-dirty + .k-radio-label { color: var(--dark-color-error); }

.k-radio:checked,
.k-radio.k-checked {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-radio:checked:focus,
.k-radio.k-checked.k-state-focus {
    border-color: var(--dark-color-primary);
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-ripple-container .k-radio::after { background: var(--dark-color-primary); }

.k-slider .k-tick { background-color: transparent; }

.k-draghandle { background-color: transparent; }

.k-slider { color: var(--dark-color-base-text); }

.k-slider .k-slider-track { background-color: #e9ecef; }

.k-slider .k-slider-selection { background-color: var(--dark-color-selected-bg); }

.k-slider .k-draghandle {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    border-radius: 50%;
    color: white;
}

.k-slider .k-draghandle:hover {
    background-color: #3385fd;
    border-color: #408cfd;
    color: white;
}

.k-slider .k-draghandle:active, .k-slider .k-draghandle.k-pressed {
    background-color: #408cfd;
    border-color: #4c94fe;
    color: white;
}

.k-slider .k-draghandle:focus, .k-slider .k-draghandle.k-state-focused { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }

.k-slider.k-state-focused .k-draghandle { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }

.k-calendar-td { border-color: transparent; }

.k-calendar-infinite .k-calendar-view::after { box-shadow: 0 0 38px 19px #000000; }

.k-calendar-navigation::before, .k-calendar-navigation::after { box-shadow: 0 0 6em 3em var(--dark-color-base-bg); }

.k-calendar-navigation .k-content,
.k-calendar-navigation .k-calendar-content { background: transparent; }

.k-calendar {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-calendar .k-header {
    background-color: var(--dark-color-base-bg);
    border-color: inherit;
    box-shadow: none;
    color: var(--dark-color-base-text);
}

.k-calendar .k-nav-today { color: var(--dark-color-primary); }

.k-calendar .k-nav-today:hover, .k-calendar .k-nav-today.k-state-hover, .k-calendar .k-nav-today:focus, .k-calendar .k-nav-today.k-state-focus { color: var(--dark-color-link-hover-text); }

.k-calendar .k-calendar-th,
.k-calendar .k-calendar-caption,
.k-calendar .k-meta-header,
.k-calendar .k-month-header { color: var(--dark-color-subtle-text); }

.k-calendar .k-calendar-view .k-today .k-link { box-shadow: inset 0 0 0 1px var(--dark-color-link-text); }

.k-calendar .k-calendar-view .k-today.k-state-focused .k-link { box-shadow: inset 0 0 0 1px var(--dark-color-link-text), inset 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-calendar .k-other-month { color: var(--dark-color-subtle-text); }

.k-calendar .k-alt {
    background-color: transparent;
    color: var(--dark-color-subtle-text);
}

.k-calendar .k-calendar-td:hover .k-link,
.k-calendar .k-calendar-td.k-state-hover .k-link {
    background-color: var(--dark-color-hovered-bg);
    border-color: #444a4f;
    color: var(--dark-color-hovered-text);
}

.k-calendar .k-calendar-td.k-state-selected .k-link {
    background-color: var(--dark-color-link-text);
    border-color: #207afd;
    color: var(--dark-color-base-text);
}

.k-calendar .k-calendar-td.k-state-selected:hover .k-link,
.k-calendar .k-calendar-td.k-state-selected.k-state-hover .k-link {
    background-color: #1774fd;
    border-color: #33363a;
    color: var(--dark-color-base-text);
}

.k-calendar .k-calendar-td.k-state-focused .k-link,
.k-calendar .k-calendar-td.k-state-focus .k-link { box-shadow: inset 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }

.k-calendar .k-calendar-td.k-state-selected.k-state-focused .k-link,
.k-calendar .k-calendar-td.k-state-selected.k-state-focus .k-link { box-shadow: inset 0 0 0 2px rgba(76, 148, 254, 0.5); }

.k-calendar .k-calendar-navigation {
    background-color: var(--dark-color-base-bg);
    box-shadow: inset -1px 0 #495057;
    color: var(--dark-color-base-text);
}

.k-calendar .k-calendar-navigation li:hover,
.k-calendar .k-calendar-navigation li.k-state-hover { color: var(--dark-color-link-hover-text); }

.k-calendar .k-calendar-navigation-highlight {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-calendar[dir="rtl"] .k-calendar-navigation,
.k-rtl .k-calendar .k-calendar-navigation { box-shadow: inset 1px 0 #495057; }

.k-calendar.k-invalid, .k-calendar.k-invalid:hover, .k-calendar.k-state-invalid, .k-calendar.ng-invalid.ng-touched, .k-calendar.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }

.k-scheduler .k-calendar .k-other-month {
    background-color: transparent;
    color: var(--dark-color-subtle-text);
}

.k-calendar .k-range-start,
.k-calendar .k-range-end,
.k-calendar .k-range-mid { background-image: linear-gradient(transparent 1px, rgba(13, 110, 253, 0.25) 1px, rgba(13, 110, 253, 0.25) calc(100% - 1px), transparent calc(100% - 1px)); }

.k-ie .k-calendar .k-range-start, .k-ie
.k-calendar .k-range-end, .k-ie
.k-calendar .k-range-mid {
    background-color: rgba(13, 110, 253, 0.25);
    background-image: none;
}

.k-calendar .k-range-start.k-range-end {
    background-color: transparent;
    background-image: none;
}

.k-calendar .k-range-start .k-link,
.k-calendar .k-range-end .k-link { background-color: var(--dark-color-link-text); }

.k-calendar .k-range-start.k-state-active .k-link,
.k-calendar .k-range-end.k-state-active .k-link { box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, 0.2); }

.k-calendar .k-range-split-start::after {
    background-image: linear-gradient(to left, rgba(13, 110, 253, 0.25), transparent 100%);
    left: -5px;
    right: auto;
}

.k-calendar .k-range-split-end::after {
    background-image: linear-gradient(to right, rgba(13, 110, 253, 0.25), transparent 100%);
    left: auto;
    right: -5px;
}

.k-timeselector {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-time-header .k-time-now,
.k-time-selector-header .k-time-now { color: var(--dark-color-primary); }

.k-time-header .k-time-now:hover,
.k-time-selector-header .k-time-now:hover { color: var(--dark-color-link-hover-text); }

.k-time-list-wrapper .k-title { color: var(--dark-color-subtle-text); }

.k-time-list-wrapper.k-state-focused .k-title { color: var(--dark-color-hovered-text); }

.k-time-list-wrapper.k-state-focused::before, .k-time-list-wrapper.k-state-focused::after { background-color: rgba(0, 0, 0, 0.02); }

.k-time-list::before, .k-time-list::after { box-shadow: 0 0 3em 1.5em #000000; }

.k-time-list .k-item:hover { color: var(--dark-color-primary); }

.k-time-container { background: transparent; }

.k-time-highlight {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
}

.k-captcha {
    background-color: var(--dark-color-component-bg);
    border-color: #000000;
    color: #000000;
}

.k-colorpalette-tile:focus, .k-colorpalette-tile.k-state-focus, .k-colorpalette-tile.k-focus { box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.5); }

.k-colorpalette-tile:hover, .k-colorpalette-tile.k-state-hover, .k-colorpalette-tile.k-hover { box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.8); }

.k-colorpalette-tile.k-state-selected, .k-colorpalette-tile.k-state-selected:hover, .k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover { box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px white; }

.k-colorgradient {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-colorgradient:focus,
.k-colorgradient.k-state-focus,
.k-colorgradient.k-focus { border-color: #444a4f; }

.k-colorgradient-canvas .k-hsv-gradient { background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black), linear-gradient(to right, white, rgba(255, 255, 255, 0)); }

.k-colorgradient .k-draghandle {
    background-color: transparent;
    border-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.k-colorgradient .k-draghandle:focus, .k-colorgradient .k-draghandle.k-state-focus, .k-colorgradient .k-draghandle.k-focus {
    background-color: transparent;
    border-color: #ffffff;
    box-shadow: 0 1px 4px black;
}

.k-colorgradient .k-draghandle:active, .k-colorgradient .k-draghandle:hover, .k-colorgradient .k-draghandle.k-state-hover, .k-colorgradient .k-draghandle.k-hover {
    background-color: transparent;
    border-color: #ffffff;
    box-shadow: 0 1px 4px black;
}

.k-colorgradient-slider.k-hue-slider.k-slider-horizontal .k-slider-track { background: linear-gradient(to right, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }

.k-colorgradient-slider.k-hue-slider.k-slider-vertical .k-slider-track { background: linear-gradient(to top, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }

.k-colorgradient-input-label { color: var(--dark-color-subtle-text); }

.k-rtl .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track,
[dir="rtl"] .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track { background: linear-gradient(to left, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }

.k-coloreditor {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-coloreditor:focus,
.k-coloreditor.k-state-focus,
.k-coloreditor.k-focus { border-color: #444a4f; }

.k-treeview { color: var(--dark-color-base-text); }

.k-treeview-leaf:hover, .k-treeview-leaf.k-hover {
    background-color: var(--dark-color-hovered-bg);
    border-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-treeview-leaf:focus, .k-treeview-leaf.k-focus { box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15); }

.k-treeview-leaf.k-selected {
    background-color: var(--dark-color-selected-bg);
    border-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-treeview .k-treeview-load-more-button {
    background-color: transparent;
    color: var(--dark-color-primary);
}

.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover {
    background-color: transparent;
    color: var(--dark-color-link-hover-text);
}

.k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {
    background-color: transparent;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15);
    color: var(--dark-color-link-hover-text);
}

.k-rating { color: var(--dark-color-base-text); }

.k-rating:focus .k-rating-item > .k-icon, .k-rating.k-state-focused .k-rating-item > .k-icon { text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }

.k-rating:focus .k-rating-item.k-state-selected > .k-icon, .k-rating.k-state-focused .k-rating-item.k-state-selected > .k-icon { text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }

.k-rating-item { color: var(--dark-color-subtle-text); }

.k-rating-item.k-state-selected { color: var(--dark-color-selected-bg); }

.k-rating-item.k-state-selected:focus, .k-rating-item.k-state-selected.k-state-focused { color: var(--dark-color-selected-bg); }

.k-rating-item:hover, .k-rating-item.k-state-hover {
    color: var(--dark-color-primary);
    cursor: pointer;
}

.k-switch-off .k-switch-track {
    background-color: var(--dark-color-component-bg);
    border-color: #adb5bd;
}

.k-switch-off .k-switch-thumb { background-color: #adb5bd; }

.k-switch-off:focus .k-switch-track, .k-switch-off.k-focus .k-switch-track {
    border-color: #07377f;
    outline: 0.25rem solid rgba(13, 110, 253, 0.25);
}

.k-switch-off:disabled .k-switch-track, .k-switch-off.k-disabled .k-switch-track { background-color: var(--dark-color-kendo-button-bg); }

.k-switch-off .k-switch-label-on { color: transparent; }

.k-switch-on .k-switch-track {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
}

.k-switch-on .k-switch-thumb { background-color: white; }

.k-switch-on:focus .k-switch-track, .k-switch-on.k-focus .k-switch-track { outline: 0.25rem solid rgba(13, 110, 253, 0.25); }

.k-switch-on:disabled .k-switch-track, .k-switch-on.k-disabled .k-switch-track { background-color: #07377f; }

.k-switch-on .k-switch-label-off { color: transparent; }

.k-dropzone-inner {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-dropzone-inner > .k-icon,
.k-dropzone-inner .k-dropzone-icon { color: #5c5c5c; }

.k-dropzone-inner .k-dropzone-note { color: var(--dark-color-subtle-text); }

.k-external-dropzone-hover .k-icon,
.k-external-dropzone-hover .k-dropzone-icon { color: var(--dark-color-primary); }

.k-upload .k-dropzone { background-color: transparent; }

.k-upload {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-upload .k-dropzone {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-upload .k-dropzone.k-dropzone-hover, .k-upload .k-dropzone.k-dropzone-hovered { background-color: #25282c; }

.k-upload .k-dropzone .k-dropzone-hint { color: var(--dark-color-subtle-text); }

.k-upload .k-upload-files,
.k-upload .k-file { border-color: var(--dark-color-border); }

.k-upload .k-file.k-state-focused { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-upload .k-file .k-upload-action.k-state-focused { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-upload .k-upload-status { color: var(--dark-color-subtle-text); }

.k-upload .k-file-progress .k-file-name { color: var(--dark-color-base-text); }

.k-upload .k-file-progress .k-progress { background-color: var(--dark-color-info); }

.k-upload .k-file-success .k-progress { background-color: var(--dark-color-success); }

.k-upload .k-file-error .k-file-validation-message,
.k-upload .k-file-invalid .k-file-validation-message { color: var(--dark-color-error); }

.k-upload .k-file-error .k-progress,
.k-upload .k-file-invalid .k-progress { background-color: var(--dark-color-error); }

.k-upload .k-file-extension-wrapper,
.k-upload .k-multiple-files-extension-wrapper,
.k-upload .k-file-group-wrapper,
.k-upload .k-multiple-files-group-wrapper,
.k-upload .k-file-invalid-extension-wrapper,
.k-upload .k-multiple-files-invalid-extension-wrapper,
.k-upload .k-file-invalid-group-wrapper,
.k-upload .k-multiple-files-invalid-group-wrapper {
    border-color: var(--dark-color-subtle-text);
    color: var(--dark-color-subtle-text);
}

.k-upload .k-file-invalid-extension-wrapper,
.k-upload .k-multiple-files-invalid-extension-wrapper,
.k-upload .k-file-error .k-file-extension-wrapper,
.k-upload .k-file-invalid-group-wrapper,
.k-upload .k-multiple-files-invalid-group-wrapper,
.k-upload .k-file-error .k-file-group-wrapper { border-color: var(--dark-color-subtle-text); }

.k-upload .k-file-extension-wrapper::before,
.k-upload .k-multiple-files-extension-wrapper::before,
.k-upload .k-file-invalid-extension-wrapper::before,
.k-upload .k-multiple-files-invalid-extension-wrapper::before,
.k-upload .k-file-error .k-file-extension-wrapper::before {
    background-color: var(--dark-color-component-bg);
    border-color: transparent transparent var(--dark-color-subtle-text) var(--dark-color-subtle-text);
}

.k-upload .k-multiple-files-extension-wrapper::after,
.k-upload .k-multiple-files-invalid-extension-wrapper::after {
    border-left-color: var(--dark-color-subtle-text);
    border-top-color: var(--dark-color-subtle-text);
}

.k-upload .k-file-size,
.k-upload .k-file-validation-message,
.k-upload .k-file-information { color: var(--dark-color-subtle-text); }

.k-upload .k-multiple-files-wrapper .k-file-information { color: var(--dark-color-base-text); }

.k-upload.k-state-invalid, .k-upload.ng-invalid.ng-touched, .k-upload.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }

.k-appbar { box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16); }

.k-appbar-bottom { box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.16); }

.k-appbar-primary {
    background-color: var(--dark-color-primary);
    color: white;
}

.k-appbar-secondary {
    background-color: var(--dark-color-secondary);
    color: white;
}

.k-appbar-tertiary {
    background-color: var(--dark-color-tertiary);
    color: white;
}

.k-appbar-info {
    background-color: var(--dark-color-info);
    color: white;
}

.k-appbar-success {
    background-color: var(--dark-color-success);
    color: white;
}

.k-appbar-warning {
    background-color: var(--dark-color-warning);
    color: black;
}

.k-appbar-error {
    background-color: var(--dark-color-error);
    color: white;
}

.k-appbar-dark {
    background-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-appbar-light {
    background-color: #f8f9fa;
    color: black;
}

.k-appbar-inverse {
    background-color: #f8f9fa;
    color: black;
}

.k-fab {
    background-color: transparent;
    border-color: transparent;
}

.k-fab-solid-primary {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-primary);
}

.k-fab-solid-secondary {
    background-color: var(--dark-color-secondary);
    border-color: var(--dark-color-secondary);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-secondary);
}

.k-fab-solid-tertiary {
    background-color: var(--dark-color-tertiary);
    border-color: var(--dark-color-tertiary);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-tertiary);
}

.k-fab-solid-info {
    background-color: var(--dark-color-info);
    border-color: var(--dark-color-info);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-info);
}

.k-fab-solid-success {
    background-color: var(--dark-color-success);
    border-color: var(--dark-color-success);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-success);
}

.k-fab-solid-warning {
    background-color: var(--dark-color-warning);
    border-color: var(--dark-color-warning);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: black;
    outline: 1px solid var(--dark-color-warning);
}

.k-fab-solid-error {
    background-color: var(--dark-color-error);
    border-color: var(--dark-color-error);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid var(--dark-color-error);
}

.k-fab-solid-dark {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-base-bg);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: var(--dark-color-base-text);
    outline: 1px solid var(--dark-color-base-bg);
}

.k-fab-solid-light {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: black;
    outline: 1px solid #f8f9fa;
}

.k-fab-solid-inverse {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: black;
    outline: 1px solid #f8f9fa;
}

.k-hover.k-fab-solid-primary,
.k-fab-solid-primary:hover {
    background-color: #3385fd;
    border-color: #408cfd;
    color: white;
}

.k-hover.k-fab-solid-secondary,
.k-fab-solid-secondary:hover {
    background-color: #7f8890;
    border-color: #868e96;
    color: white;
}

.k-hover.k-fab-solid-tertiary,
.k-fab-solid-tertiary:hover {
    background-color: #855fca;
    border-color: #8c68ce;
    color: white;
}

.k-hover.k-fab-solid-info,
.k-fab-solid-info:hover {
    background-color: #2fd3f4;
    border-color: #3cd5f4;
    color: black;
}

.k-hover.k-fab-solid-success,
.k-fab-solid-success:hover {
    background-color: #1fa768;
    border-color: #21b26f;
    color: white;
}

.k-hover.k-fab-solid-warning,
.k-fab-solid-warning:hover {
    background-color: #ffcb2d;
    border-color: #ffce3a;
    color: black;
}

.k-hover.k-fab-solid-error,
.k-fab-solid-error:hover {
    background-color: #e25663;
    border-color: #e4606d;
    color: white;
}

.k-hover.k-fab-solid-dark,
.k-fab-solid-dark:hover {
    background-color: #32383e;
    border-color: #383f45;
    color: white;
}

.k-hover.k-fab-solid-light,
.k-fab-solid-light:hover {
    background-color: white;
    border-color: white;
    color: black;
}

.k-hover.k-fab-solid-inverse,
.k-fab-solid-inverse:hover {
    background-color: white;
    border-color: white;
    color: black;
}

.k-fab-solid-primary.k-focus,
.k-fab-solid-primary:focus { outline-color: rgba(13, 110, 253, 0.5); }

.k-fab-solid-secondary.k-focus,
.k-fab-solid-secondary:focus { outline-color: rgba(108, 117, 125, 0.5); }

.k-fab-solid-tertiary.k-focus,
.k-fab-solid-tertiary:focus { outline-color: rgba(111, 66, 193, 0.5); }

.k-fab-solid-info.k-focus,
.k-fab-solid-info:focus { outline-color: rgba(13, 202, 240, 0.5); }

.k-fab-solid-success.k-focus,
.k-fab-solid-success:focus { outline-color: rgba(25, 135, 84, 0.5); }

.k-fab-solid-warning.k-focus,
.k-fab-solid-warning:focus { outline-color: rgba(255, 193, 7, 0.5); }

.k-fab-solid-error.k-focus,
.k-fab-solid-error:focus { outline-color: rgba(220, 53, 69, 0.5); }

.k-fab-solid-dark.k-focus,
.k-fab-solid-dark:focus { outline-color: rgba(33, 37, 41, 0.5); }

.k-fab-solid-light.k-focus,
.k-fab-solid-light:focus { outline-color: rgba(248, 249, 250, 0.5); }

.k-fab-solid-inverse.k-focus,
.k-fab-solid-inverse:focus { outline-color: rgba(248, 249, 250, 0.5); }

.k-active.k-fab-solid-primary,
.k-selected.k-fab-solid-primary,
.k-fab-solid-primary:active {
    background-color: #408cfd;
    border-color: #4c94fe;
    color: white;
}

.k-active.k-fab-solid-secondary,
.k-selected.k-fab-solid-secondary,
.k-fab-solid-secondary:active {
    background-color: #868e96;
    border-color: #8d959c;
    color: white;
}

.k-active.k-fab-solid-tertiary,
.k-selected.k-fab-solid-tertiary,
.k-fab-solid-tertiary:active {
    background-color: #8c68ce;
    border-color: #9472d1;
    color: white;
}

.k-active.k-fab-solid-info,
.k-selected.k-fab-solid-info,
.k-fab-solid-info:active {
    background-color: #3cd5f4;
    border-color: #48d8f5;
    color: black;
}

.k-active.k-fab-solid-success,
.k-selected.k-fab-solid-success,
.k-fab-solid-success:active {
    background-color: #21b26f;
    border-color: #23bd75;
    color: white;
}

.k-active.k-fab-solid-warning,
.k-selected.k-fab-solid-warning,
.k-fab-solid-warning:active {
    background-color: #ffce3a;
    border-color: #ffd147;
    color: black;
}

.k-active.k-fab-solid-error,
.k-selected.k-fab-solid-error,
.k-fab-solid-error:active {
    background-color: #e4606d;
    border-color: #e56b77;
    color: white;
}

.k-active.k-fab-solid-dark,
.k-selected.k-fab-solid-dark,
.k-fab-solid-dark:active {
    background-color: #383f45;
    border-color: #3d454c;
    color: white;
}

.k-active.k-fab-solid-light,
.k-selected.k-fab-solid-light,
.k-fab-solid-light:active {
    background-color: white;
    border-color: white;
    color: black;
}

.k-active.k-fab-solid-inverse,
.k-selected.k-fab-solid-inverse,
.k-fab-solid-inverse:active {
    background-color: white;
    border-color: white;
    color: black;
}

.k-disabled.k-fab-solid-primary,
.k-fab-solid-primary:disabled {
    background-color: #0846a2;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-secondary,
.k-fab-solid-secondary:disabled {
    background-color: #454b50;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-tertiary,
.k-fab-solid-tertiary:disabled {
    background-color: #472a7c;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-info,
.k-fab-solid-info:disabled {
    background-color: #08819a;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-success,
.k-fab-solid-success:disabled {
    background-color: #105636;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-warning,
.k-fab-solid-warning:disabled {
    background-color: #a37c04;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: black;
}

.k-disabled.k-fab-solid-error,
.k-fab-solid-error:disabled {
    background-color: #8d222c;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-dark,
.k-fab-solid-dark:disabled {
    background-color: #15181a;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #999999;
}

.k-disabled.k-fab-solid-light,
.k-fab-solid-light:disabled {
    background-color: #9f9fa0;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: black;
}

.k-disabled.k-fab-solid-inverse,
.k-fab-solid-inverse:disabled {
    background-color: #9f9fa0;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: black;
}

.k-fab-item-text {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: var(--dark-color-component-text);
}

.k-fab-item-icon {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: var(--dark-color-kendo-button-text);
    outline: 1px solid var(--dark-color-kendo-button-bg);
}

.k-fab-item.k-hover .k-fab-item-icon,
.k-fab-item:hover .k-fab-item-icon {
    background-color: #454d55;
    border-color: #4b545c;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
    color: white;
    outline: 1px solid #4b545c;
}

.k-fab-item:focus .k-fab-item-text,
.k-fab-item:focus .k-fab-item-icon,
.k-fab-item.k-focus .k-fab-item-text,
.k-fab-item.k-focus .k-fab-item-icon { outline-color: rgba(52, 58, 64, 0.5); }

.k-fab-item.k-active .k-fab-item-icon,
.k-fab-item:active .k-fab-item-icon {
    background-color: #4b545c;
    border-color: #515a63;
    color: white;
    outline: 1px solid #515a63;
}

.k-fab-item.k-disabled .k-fab-item-text,
.k-fab-item.k-disabled .k-fab-item-icon,
.k-fab-item:disabled .k-fab-item-text,
.k-fab-item:disabled .k-fab-item-icon {
    background-color: black;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);
    color: #5c5c5c;
}

.k-actionsheet { border-color: transparent; }

.k-actionsheet-header { border-color: transparent; }

.k-actionsheet {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
    color: var(--dark-color-component-text);
}

.k-actionsheet-item-description { color: var(--dark-color-subtle-text); }

.k-actionsheet-action:hover, .k-actionsheet-action.k-state-hover { background-color: var(--dark-color-hovered-bg); }

.k-actionsheet-action:focus, .k-actionsheet-action.k-state-focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-window {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-window-titlebar { border-color: var(--dark-color-border); }

.k-dialog-buttongroup { border-color: var(--dark-color-border); }

.k-drawer {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-drawer-wrapper { scrollbar-color: rgba(156, 156, 156, 0.7) #dedede; }

.k-drawer-wrapper::-webkit-scrollbar-track { background: #dedede; }

.k-drawer-wrapper::-webkit-scrollbar-thumb { background: rgba(156, 156, 156, 0.7); }

.k-drawer-wrapper::-webkit-scrollbar-thumb:hover { background: #9c9c9c; }

.k-drawer-item:hover, .k-drawer-item.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-drawer-item:focus, .k-drawer-item.k-state-focused {
    background-color: var(--dark-color-hovered-bg);
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.15);
}

.k-drawer-item:focus:hover, .k-drawer-item:focus.k-state-hover, .k-drawer-item.k-state-focused:hover, .k-drawer-item.k-state-focused.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-drawer-item.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-drawer-item.k-state-selected:hover, .k-drawer-item.k-state-selected.k-state-hover {
    background-color: #207afd;
    color: var(--dark-color-hovered-text);
}

.k-drawer-separator { background-color: #495057; }

.k-notification {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-notification-wrap > .k-i-close { color: inherit; }

.k-notification-group .k-notification { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }

.k-notification-inverse {
    background-color: #fdfdfe;
    border-color: #fefefe;
    color: #818182;
}

.k-notification-light {
    background-color: #fdfdfe;
    border-color: #fefefe;
    color: #818182;
}

.k-notification-dark {
    background-color: #c1c2c3;
    border-color: #d3d3d4;
    color: #111315;
}

.k-notification-error {
    background-color: #f5c6cb;
    border-color: #f8d7da;
    color: #721c24;
}

.k-notification-warning {
    background-color: #ffeeba;
    border-color: #fff3cd;
    color: #856404;
}

.k-notification-success {
    background-color: #bfddcf;
    border-color: #d1e7dd;
    color: #0d462c;
}

.k-notification-info {
    background-color: #bbf0fb;
    border-color: #cff4fc;
    color: #07697d;
}

.k-notification-tertiary {
    background-color: #d7caee;
    border-color: #e2d9f3;
    color: #3a2264;
}

.k-notification-secondary {
    background-color: #d6d8db;
    border-color: #e2e3e5;
    color: #383d41;
}

.k-notification-primary {
    background-color: #bbd6fe;
    border-color: #cfe2ff;
    color: #073984;
}

.k-card {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-card:focus, .k-card.k-state-focus { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-card-actions { border-color: var(--dark-color-border); }

.k-card-header {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-card-footer {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-card-separator,
.k-card .k-separator { border-color: var(--dark-color-border); }

.k-card-subtitle { color: var(--dark-color-subtle-text); }

.k-card-primary {
    background-color: #cfe2ff;
    border-color: #bbd6fe;
    color: #073984;
}

.k-card-primary .k-card-subtitle { color: inherit; }

.k-card-secondary {
    background-color: #e2e3e5;
    border-color: #d6d8db;
    color: #383d41;
}

.k-card-secondary .k-card-subtitle { color: inherit; }

.k-card-tertiary {
    background-color: #e2d9f3;
    border-color: #d7caee;
    color: #3a2264;
}

.k-card-tertiary .k-card-subtitle { color: inherit; }

.k-card-info {
    background-color: #cff4fc;
    border-color: #bbf0fb;
    color: #07697d;
}

.k-card-info .k-card-subtitle { color: inherit; }

.k-card-success {
    background-color: #d1e7dd;
    border-color: #bfddcf;
    color: #0d462c;
}

.k-card-success .k-card-subtitle { color: inherit; }

.k-card-warning {
    background-color: #fff3cd;
    border-color: #ffeeba;
    color: #856404;
}

.k-card-warning .k-card-subtitle { color: inherit; }

.k-card-error {
    background-color: #f8d7da;
    border-color: #f5c6cb;
    color: #721c24;
}

.k-card-error .k-card-subtitle { color: inherit; }

.k-card-dark {
    background-color: #d3d3d4;
    border-color: #c1c2c3;
    color: #111315;
}

.k-card-dark .k-card-subtitle { color: inherit; }

.k-card-light {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-card-light .k-card-subtitle { color: inherit; }

.k-card-inverse {
    background-color: #fefefe;
    border-color: #fdfdfe;
    color: #818182;
}

.k-card-inverse .k-card-subtitle { color: inherit; }

.k-card-wrap.k-state-focused > .k-card, .k-card-wrap.k-state-selected > .k-card { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-card-callout {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
}

.k-card:focus .k-card-callout.k-callout-n,
.k-card.k-state-focus .k-card-callout.k-callout-n { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-card:focus .k-card-callout.k-callout-e,
.k-card.k-state-focus .k-card-callout.k-callout-e { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-card:focus .k-card-callout.k-callout-s,
.k-card.k-state-focus .k-card-callout.k-callout-s { box-shadow: 3px -3px 0 0 rgba(73, 80, 87, 0.5); }

.k-card:focus .k-card-callout.k-callout-w,
.k-card.k-state-focus .k-card-callout.k-callout-w { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-popover {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-popover-header {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-popover-callout {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
}

.k-bottom-nav-shadow { box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.12); }

.k-bottom-nav-solid.k-bottom-nav-primary {
    background-color: var(--dark-color-primary);
    color: #aaccfe;
}

.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item:focus { background-color: rgba(170, 204, 254, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-secondary {
    background-color: var(--dark-color-secondary);
    color: #cccfd2;
}

.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item:focus { background-color: rgba(204, 207, 210, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-tertiary {
    background-color: var(--dark-color-tertiary);
    color: #cdbde9;
}

.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item:focus { background-color: rgba(205, 189, 233, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-info {
    background-color: var(--dark-color-info);
    color: #aaecfa;
}

.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item:focus { background-color: rgba(170, 236, 250, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-success {
    background-color: var(--dark-color-success);
    color: #afd5c3;
}

.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item:focus { background-color: rgba(175, 213, 195, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-warning {
    background-color: var(--dark-color-warning);
    color: #594402;
}

.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item:focus { background-color: rgba(89, 68, 2, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-selected { color: black; }

.k-bottom-nav-solid.k-bottom-nav-error {
    background-color: var(--dark-color-error);
    color: #f3b8be;
}

.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item:focus { background-color: rgba(243, 184, 190, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-dark {
    background-color: var(--dark-color-base-bg);
    color: #b1b3b4;
}

.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item:focus { background-color: rgba(177, 179, 180, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-selected { color: white; }

.k-bottom-nav-solid.k-bottom-nav-light {
    background-color: #f8f9fa;
    color: #575758;
}

.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item:focus { background-color: rgba(87, 87, 88, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-selected { color: black; }

.k-bottom-nav-solid.k-bottom-nav-inverse {
    background-color: #f8f9fa;
    color: #575758;
}

.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item:focus { background-color: rgba(87, 87, 88, 0.2); }

.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-selected { color: black; }

.k-bottom-nav-flat {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-bottom-nav-flat .k-bottom-nav-item.k-state-focus,
.k-bottom-nav-flat .k-bottom-nav-item.k-state-focused,
.k-bottom-nav-flat .k-bottom-nav-item:focus { background-color: rgba(255, 255, 255, 0.05); }

.k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-state-selected { color: var(--dark-color-primary); }

.k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-state-selected { color: #8f969c; }

.k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-selected { color: var(--dark-color-tertiary); }

.k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-state-selected { color: var(--dark-color-info); }

.k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-state-selected { color: var(--dark-color-success); }

.k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-state-selected { color: var(--dark-color-warning); }

.k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-state-selected { color: var(--dark-color-error); }

.k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-state-selected { color: var(--dark-color-base-bg); }

.k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-state-selected { color: #fafafb; }

.k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-state-selected { color: #f8f9fa; }

.k-ie .k-bottom-nav-item { background-color: transparent; }

.k-breadcrumb-input-container .k-breadcrumb-input-container { border-color: transparent; }

.k-breadcrumb {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-breadcrumb:focus, .k-breadcrumb.k-state-focused { box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.06); }

.k-breadcrumb-link { color: var(--dark-color-link-text); }

.k-breadcrumb-link:hover, .k-breadcrumb-link.k-state-hover { color: var(--dark-color-link-hover-text); }

.k-breadcrumb-link:focus, .k-breadcrumb-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.25); }

.k-breadcrumb-root-link { color: var(--dark-color-link-text); }

.k-breadcrumb-root-link:hover, .k-breadcrumb-root-link.k-state-hover { color: var(--dark-color-link-hover-text); }

.k-breadcrumb-root-link:focus, .k-breadcrumb-root-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.25); }

.k-breadcrumb-last-item .k-breadcrumb-link { color: var(--dark-color-secondary); }

.k-pager-wrap {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pager-wrap:focus, .k-pager-wrap.k-focus, .k-pager-wrap.k-state-focus, .k-pager-wrap.k-state-focused { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }

.k-pager-nav.k-link, .k-pager-refresh {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pager-nav.k-link:hover, .k-pager-refresh:hover, .k-state-hover.k-pager-nav.k-link, .k-state-hover.k-pager-refresh {
    background-color: var(--dark-color-hovered-bg);
    border-color: #444a4f;
    color: var(--dark-color-link-hover-text);
}

.k-state-selected.k-pager-nav.k-link, .k-state-selected.k-pager-refresh {
    background-color: var(--dark-color-selected-bg);
    border-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-pager-nav.k-link:focus, .k-pager-refresh:focus, .k-state-focus.k-pager-nav.k-link, .k-state-focus.k-pager-refresh {
    background-color: var(--dark-color-component-bg);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);
}

.k-pager-numbers .k-link {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pager-numbers .k-link:hover, .k-pager-numbers .k-link.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    border-color: #444a4f;
    color: var(--dark-color-link-text);
}

.k-pager-numbers .k-link:focus, .k-pager-numbers .k-link.k-state-focus {
    background-color: var(--dark-color-component-bg);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);
}

.k-pager-numbers .k-link.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    border-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-pager-md .k-pager-numbers .k-current-page .k-link,
.k-pager-sm .k-pager-numbers .k-current-page .k-link {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-pager-md .k-pager-numbers .k-current-page .k-link:hover, .k-pager-md .k-pager-numbers .k-current-page .k-link.k-state-hover,
.k-pager-sm .k-pager-numbers .k-current-page .k-link:hover,
.k-pager-sm .k-pager-numbers .k-current-page .k-link.k-state-hover {
    background-color: #454d55;
    border-color: #4b545c;
}

.k-pager-md .k-pager-numbers.k-state-expanded,
.k-pager-sm .k-pager-numbers.k-state-expanded {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);
    color: var(--dark-color-component-text);
}

.k-pager-md .k-pager-numbers.k-state-expanded .k-link:hover, .k-pager-md .k-pager-numbers.k-state-expanded .k-link.k-state-hover,
.k-pager-sm .k-pager-numbers.k-state-expanded .k-link:hover,
.k-pager-sm .k-pager-numbers.k-state-expanded .k-link.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-pager-md .k-pager-numbers.k-state-expanded .k-link.k-state-selected,
.k-pager-sm .k-pager-numbers.k-state-expanded .k-link.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-pager-md .k-pager-numbers .k-current-page .k-link,
.k-pager-sm .k-pager-numbers .k-current-page .k-link {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pager-md .k-pager-numbers .k-current-page .k-link:hover, .k-pager-md .k-pager-numbers .k-current-page .k-link.k-state-hover,
.k-pager-sm .k-pager-numbers .k-current-page .k-link:hover,
.k-pager-sm .k-pager-numbers .k-current-page .k-link.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    border-color: #444a4f;
    color: var(--dark-color-hovered-text);
}

.k-stepper { color: var(--dark-color-base-text); }

.k-stepper .k-step:hover .k-step-indicator, .k-stepper .k-step.k-step-hover .k-step-indicator { background-color: #141414; }

.k-stepper .k-step.k-step-disabled .k-step-indicator, .k-stepper .k-step:disabled .k-step-indicator { color: var(--dark-color-disabled-text); }

.k-stepper .k-step-indicator {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-stepper .k-step-indicator::after { box-shadow: inset 0 0 0 2px #000000; }

.k-stepper .k-step-label:only-child {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-stepper .k-step-done .k-step-indicator {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-stepper .k-step-done:hover .k-step-indicator, .k-stepper .k-step-done.k-step-hover .k-step-indicator { background-color: #207afd; }

.k-stepper .k-step-done.k-step-disabled .k-step-indicator, .k-stepper .k-step-done:disabled .k-step-indicator {
    background-color: #084298;
    border-color: #084298;
    color: white;
}

.k-stepper .k-step-current .k-step-indicator {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-stepper .k-step-current:hover .k-step-indicator, .k-stepper .k-step-current.k-step-hover .k-step-indicator { background-color: #207afd; }

.k-stepper .k-step-current.k-step-disabled .k-step-indicator, .k-stepper .k-step-current:disabled .k-step-indicator {
    background-color: #084298;
    border-color: #084298;
    color: white;
}

.k-stepper .k-step-success .k-step-label .k-icon { color: var(--dark-color-success); }

.k-stepper .k-step-error .k-step-label { color: var(--dark-color-error); }

.k-stepper .k-step-error .k-step-label { color: var(--dark-color-error); }

.k-stepper .k-step-error:hover .k-step-label, .k-stepper .k-step-error.k-step-hover .k-step-label { color: var(--dark-color-error); }

.k-stepper .k-step-disabled .k-step-label { color: var(--dark-color-disabled-text); }

.k-stepper .k-step-focus .k-step-label:only-child,
.k-stepper .k-step-link:focus .k-step-label:only-child { box-shadow: inset 0 0 0 2px #495057; }

.k-stepper .k-step-label-optional { color: var(--dark-color-subtle-text); }

.k-tabstrip-items-wrapper {
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-tabstrip-items-wrapper .k-item { color: var(--dark-color-primary); }

.k-tabstrip-items-wrapper .k-item:hover, .k-tabstrip-items-wrapper .k-item.k-state-hover {
    border-color: #e9ecef;
    color: var(--dark-color-link-hover-text);
}

.k-tabstrip-items-wrapper .k-item:active, .k-tabstrip-items-wrapper .k-item.k-state-active, .k-tabstrip-items-wrapper .k-item.k-state-selected {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-tabstrip-items-wrapper .k-item:focus, .k-tabstrip-items-wrapper .k-item.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-tabstrip-items-wrapper .k-item.k-tabstrip-dragging { box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.15); }

.k-tabstrip-content,
.k-tabstrip > .k-content {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-tabstrip-content:focus, .k-tabstrip-content.k-state-focused,
.k-tabstrip > .k-content:focus,
.k-tabstrip > .k-content.k-state-focused { outline-color: #ffffff; }

.k-tabstrip-top > .k-tabstrip-items .k-item.k-state-hover,
.k-tabstrip-top > .k-tabstrip-items .k-item.k-state-active { border-bottom-color: transparent; }

.k-tabstrip-bottom > .k-tabstrip-items .k-item.k-state-hover,
.k-tabstrip-bottom > .k-tabstrip-items .k-item.k-state-active { border-top-color: transparent; }

.k-tabstrip-left > .k-tabstrip-items .k-item.k-state-hover,
.k-tabstrip-left > .k-tabstrip-items .k-item.k-state-active { border-right-color: transparent; }

.k-tabstrip-right > .k-tabstrip-items .k-item.k-state-hover,
.k-tabstrip-right > .k-tabstrip-items .k-item.k-state-active { border-left-color: transparent; }

.k-wizard-step:focus, .k-wizard-step.k-state-focused { outline-color: #656565; }

.k-ie .k-wizard-step:focus,
.k-ie .k-wizard-step.k-state-focused {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);
    outline: none;
}

.k-expander {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-expander.k-state-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-expander-header {
    background-color: transparent;
    color: var(--dark-color-base-text);
    outline: none;
}

.k-expander-header:hover, .k-expander-header.k-state-hover { background-color: rgba(0, 0, 0, 0.04); }

.k-expander-header.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-expander-title { color: var(--dark-color-primary); }

.k-expander-sub-title { color: var(--dark-color-subtle-text); }

.k-panelbar {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-panelbar > .k-item > .k-link,
.k-panelbar > .k-panelbar-header > .k-link {
    background-color: var(--dark-color-component-bg);
    color: var(--dark-color-link-text);
}

.k-panelbar > .k-item > .k-link .k-icon,
.k-panelbar > .k-item > .k-link .k-panelbar-item-icon,
.k-panelbar > .k-panelbar-header > .k-link .k-icon,
.k-panelbar > .k-panelbar-header > .k-link .k-panelbar-item-icon { color: var(--dark-color-base-text); }

.k-panelbar > .k-item > .k-link:hover,
.k-panelbar > .k-item > .k-link.k-state-hover,
.k-panelbar > .k-panelbar-header > .k-link:hover,
.k-panelbar > .k-panelbar-header > .k-link.k-state-hover { background-color: #0a0a0a; }

.k-panelbar > .k-item > .k-link:focus,
.k-panelbar > .k-item > .k-link.k-state-focus,
.k-panelbar > .k-item > .k-link.k-state-focused,
.k-panelbar > .k-panelbar-header > .k-link:focus,
.k-panelbar > .k-panelbar-header > .k-link.k-state-focus,
.k-panelbar > .k-panelbar-header > .k-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-panelbar > .k-item > .k-link.k-state-selected,
.k-panelbar > .k-panelbar-header > .k-link.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-panelbar > .k-item > .k-link.k-state-selected .k-icon,
.k-panelbar > .k-item > .k-link.k-state-selected .k-panelbar-item-icon,
.k-panelbar > .k-panelbar-header > .k-link.k-state-selected .k-icon,
.k-panelbar > .k-panelbar-header > .k-link.k-state-selected .k-panelbar-item-icon { color: inherit; }

.k-panelbar > .k-item > .k-link.k-state-selected:hover,
.k-panelbar > .k-item > .k-link.k-state-selected.k-state-hover,
.k-panelbar > .k-panelbar-header > .k-link.k-state-selected:hover,
.k-panelbar > .k-panelbar-header > .k-link.k-state-selected.k-state-hover { background-color: #207afd; }

.k-panelbar .k-group > .k-item > .k-link:hover,
.k-panelbar .k-group > .k-item > .k-link.k-state-hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link:hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link:hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-hover { background-color: #141414; }

.k-panelbar .k-group > .k-item > .k-link:focus,
.k-panelbar .k-group > .k-item > .k-link.k-state-focus,
.k-panelbar .k-group > .k-item > .k-link.k-state-focused,
.k-panelbar .k-group > .k-panelbar-item > .k-link:focus,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-focus,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-focused,
.k-panelbar .k-panelbar-group > .k-item > .k-link:focus,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-focus,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-focused,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:focus,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-focus,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-panelbar .k-group > .k-item > .k-link.k-state-selected,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-panelbar .k-group > .k-item > .k-link.k-state-selected:hover,
.k-panelbar .k-group > .k-item > .k-link.k-state-selected.k-state-hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected:hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected.k-state-hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected:hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected.k-state-hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected:hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected.k-state-hover { background-color: #207afd; }

.k-splitter {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-splitbar {
    background-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-splitbar:hover,
.k-splitbar.k-state-hover,
.k-splitbar-horizontal-hover,
.k-splitbar-vertical-hover {
    background-color: #2a2e32;
    color: var(--dark-color-hovered-text);
}

.k-splitbar:focus,
.k-splitbar.k-state-focus,
.k-splitbar.k-state-focused {
    background: var(--dark-color-primary);
    color: var(--dark-color-hovered-text);
}

.k-ghost-splitbar { background-color: #2a2e32; }

.k-tilelayout { background-color: #f8f9fa; }

.k-tilelayout-item:focus,
.k-tilelayout-item.k-state-focus,
.k-tilelayout-item.k-state-focused { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-layout-item-hint {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: var(--dark-color-border);
}

.k-pane-wrapper,
.k-view {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pane-wrapper .k-pane > .k-view > .k-content {
    background-color: #050505;
    background-position: 50% 50%;
}

.k-pane-wrapper .k-pane .k-grid-mobile .k-column-active + th.k-header { border-left-color: #ffffff; }

.k-pane-wrapper .k-pane .k-grid-mobile .k-resize-handle-inner::before { background-color: var(--dark-color-base-bg); }

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-nav-current { color: var(--dark-color-primary); }

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendadate { color: inherit; }

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-time-period,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendaweekday { color: var(--dark-color-subtle-text); }

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-wrap,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-datecolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-group-cell,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-all-day { background-color: #050505; }

.k-pane-wrapper .k-pane .k-grid-edit-form .k-item,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-link,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-item,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-link,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-item,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-link,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-item,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-link { color: var(--dark-color-base-text); }

.k-pane-wrapper .k-pane .k-grid-edit-form .k-clear,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-select-all,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-clear,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-select-all,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-column-menu .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-clear,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-select-all,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-clear,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-select-all,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-resetSeries { color: var(--dark-color-primary); }

.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-state-selected {
    background: none;
    color: var(--dark-color-selected-bg);
}

.k-columnmenu-item-wrapper + .k-columnmenu-item-wrapper {
    border-top: 1px solid;
    border-top-color: #495057;
}

.k-grid {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-grid td,
.k-grid .k-grid-content,
.k-grid .k-grid-header-locked,
.k-grid .k-grid-content-locked { border-color: var(--dark-color-border); }

.k-grid .k-alt { background-color: rgba(255, 255, 255, 0.04); }

.k-grid tbody tr:not(.k-detail-row):hover,
.k-grid tbody tr:not(.k-detail-row).k-state-hover { background-color: rgba(255, 255, 255, 0.08); }

.k-grid th.k-state-selected,
.k-grid td.k-state-selected,
.k-grid tr.k-state-selected > td {
    background-color: rgba(13, 110, 253, 0.25);
    color: var(--dark-color-hovered-text);
}

.k-grid td.k-state-focused,
.k-grid th.k-state-focused,
.k-grid th:focus,
.k-grid .k-master-row > td:focus,
.k-grid .k-grouping-row > td:focus,
.k-grid .k-detail-row > td:focus,
.k-grid .k-group-footer > td:focus,
.k-grid .k-grid-pager.k-state-focused,
.k-grid .k-grid-pager:focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }

.k-grid col.k-sorted,
.k-grid th.k-sorted { background-color: rgba(255, 255, 255, 0.02); }

.k-grid .k-grid-header-locked,
.k-grid .k-grid-content-locked,
.k-grid .k-grid-header-locked .k-header,
.k-grid .k-grid-content-locked td { border-color: rgba(255, 255, 255, 0.5); }

.k-grid .k-grid-header-locked .k-header { border-bottom-color: #495057; }

.k-grid .k-grid-content-locked .k-group-footer td,
.k-grid .k-grid-content-locked .k-group-cell { border-color: var(--dark-color-border); }

.k-grid .k-grid-content-locked .k-grouping-row + tr td { border-top-color: #495057; }

.k-grid .k-grid-content-locked .k-state-selected td { background-color: #031c3f; }

.k-grid .k-grid-content-locked .k-state-selected.k-alt td { background-color: #031b3d; }

.k-grid .k-grid-content-locked .k-state-selected:hover td,
.k-grid .k-grid-content-locked .k-state-selected.k-state-hover td { background-color: #031a3b; }

.k-grid[dir="rtl"] th.k-hierarchy-cell,
.k-grid[dir="rtl"] td.k-hierarchy-cell, .k-grid.k-rtl th.k-hierarchy-cell,
.k-grid.k-rtl td.k-hierarchy-cell { border-left-color: transparent; }

.k-grid-toolbar { border-color: inherit; }

.k-grouping-header {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-grouping-header .k-group-indicator {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-grid-header {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-grid-header .k-i-sort-asc-sm,
.k-grid-header .k-i-sort-desc-sm,
.k-grid-header .k-sort-order { color: var(--dark-color-primary); }

.k-grid-header .k-grid-filter:focus, .k-grid-header .k-grid-filter.k-state-focus, .k-grid-header .k-grid-filter.k-state-border-down,
.k-grid-header .k-header-column-menu:focus,
.k-grid-header .k-header-column-menu.k-state-focus,
.k-grid-header .k-header-column-menu.k-state-border-down,
.k-grid-header .k-hierarchy-cell .k-icon:focus,
.k-grid-header .k-hierarchy-cell .k-icon.k-state-focus,
.k-grid-header .k-hierarchy-cell .k-icon.k-state-border-down { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1); }

.k-grid-header .k-grid-filter.k-state-active,
.k-grid-header .k-header-column-menu.k-state-active,
.k-grid-header .k-hierarchy-cell .k-icon.k-state-active {
    background-color: var(--dark-color-primary);
    color: var(--dark-color-selected-text);
}

.k-grid-header .k-grid-header-sticky,
.k-grid-header .k-grid-header-sticky.k-sorted {
    background-color: var(--dark-color-component-bg);
    border-left-color: rgba(255, 255, 255, 0.5);
    border-right-color: rgba(255, 255, 255, 0.5);
    color: var(--dark-color-base-text);
}

.k-grid-footer .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }

.k-master-row .k-grid-content-sticky {
    background-color: var(--dark-color-component-bg);
    border-color: rgba(255, 255, 255, 0.2);
    border-top-color: #495057;
    color: var(--dark-color-component-text);
}

.k-master-row .k-grid-row-sticky {
    background-color: var(--dark-color-component-bg);
    border-bottom-color: rgba(255, 255, 255, 0.5);
    border-top-color: rgba(255, 255, 255, 0.5);
}

.k-master-row.k-alt .k-grid-content-sticky,
.k-master-row.k-alt .k-grid-row-sticky { background-color: #3b3b3b; }

.k-master-row.k-state-selected .k-grid-content-sticky,
.k-master-row.k-state-selected .k-grid-row-sticky,
.k-master-row td.k-grid-content-sticky.k-state-selected { background-color: #031c3f; }

.k-master-row.k-state-selected.k-alt .k-grid-content-sticky,
.k-master-row.k-state-selected.k-alt .k-grid-row-sticky,
.k-master-row.k-alt td.k-grid-content-sticky.k-state-selected { background-color: #031b3d; }

.k-master-row:hover .k-grid-content-sticky,
.k-master-row:hover .k-grid-row-sticky,
.k-master-row.k-state-hover .k-grid-content-sticky,
.k-master-row.k-state-hover .k-grid-row-sticky { background-color: #434343; }

.k-master-row.k-state-selected:hover .k-grid-content-sticky,
.k-master-row.k-state-selected:hover .k-grid-row-sticky,
.k-master-row.k-state-selected.k-state-hover .k-grid-content-sticky,
.k-master-row.k-state-selected.k-state-hover .k-grid-row-sticky,
.k-master-row:hover td.k-grid-content-sticky.k-state-selected,
.k-master-row.k-state-hover td.k-grid-content-sticky.k-state-selected { background-color: #031a3b; }

kendo-grid .k-grid-content-sticky {
    background-color: var(--dark-color-component-bg);
    border-left-color: rgba(255, 255, 255, 0.5);
    border-right-color: rgba(255, 255, 255, 0.5);
    border-top-color: #495057;
}

kendo-grid .k-grid-content-sticky:hover, kendo-grid .k-grid-content-sticky.k-state-hover { background-color: #141414; }

kendo-grid .k-grid-row-sticky td {
    background-color: var(--dark-color-component-bg);
    border-bottom-color: rgba(255, 255, 255, 0.5);
    border-top-color: rgba(255, 255, 255, 0.5);
}

kendo-grid .k-grid-row-sticky td:hover td,
kendo-grid .k-grid-row-sticky td.k-state-hover td { background-color: #141414; }

kendo-grid .k-alt .k-grid-content-sticky,
kendo-grid .k-grid-row-sticky.k-alt td { background-color: #0a0a0a; }

kendo-grid tr.k-state-selected .k-grid-content-sticky,
kendo-grid .k-state-selected.k-grid-row-sticky td,
kendo-grid .k-grid-row-sticky td.k-state-selected,
kendo-grid .k-state-selected.k-grid-content-sticky { background-color: #031c3f; }

kendo-grid tr.k-state-selected.k-alt .k-grid-content-sticky,
kendo-grid .k-state-selected.k-alt.k-grid-row-sticky td,
kendo-grid .k-alt .k-state-selected.k-grid-content-sticky { background-color: #031b3d; }

kendo-grid tr:hover .k-grid-content-sticky,
kendo-grid tr.k-state-hover .k-grid-content-sticky,
kendo-grid .k-grid-row-sticky:hover td,
kendo-grid .k-grid-row-sticky.k-state-hover td,
kendo-grid .k-grid-row-sticky.k-alt:hover td,
kendo-grid .k-grid-row-sticky.k-alt.k-state-hover td,
kendo-grid .k-alt:hover .k-grid-content-sticky,
kendo-grid .k-alt.k-state-hover .k-grid-content-sticky { background-color: #141414; }

kendo-grid tr.k-state-selected:hover .k-grid-content-sticky,
kendo-grid tr.k-state-selected.k-state-hover .k-grid-content-sticky,
kendo-grid .k-state-selected.k-grid-row-sticky:hover td,
kendo-grid .k-state-selected.k-grid-row-sticky.k-state-hover td,
kendo-grid .k-state-selected.k-alt.k-grid-row-sticky:hover td,
kendo-grid .k-state-selected.k-alt.k-grid-row-sticky.k-state-hover td,
kendo-grid tr.k-state-selected.k-alt:hover .k-grid-content-sticky,
kendo-grid tr.k-state-selected.k-alt.k-state-hover .k-grid-content-sticky,
kendo-grid .k-grid-row-sticky:hover td.k-state-selected,
kendo-grid .k-grid-row-sticky.k-state-hover td.k-state-selected,
kendo-grid tr:hover .k-grid-content-sticky.k-state-selected,
kendo-grid tr.k-state-hover .k-grid-content-sticky.k-state-selected { background-color: #031a3b; }

.k-grouping-row .k-grid-content-sticky { background-color: var(--dark-color-base-bg); }

.k-grouping-row:hover .k-grid-content-sticky,
.k-grouping-row.k-state-hover .k-grid-content-sticky { background-color: #141414; }

.k-group-footer td,
.k-group-footer .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }

.k-group-footer:hover .k-grid-footer-sticky,
.k-group-footer.k-state-hover .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }

.k-grid-footer {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-grid-footer .k-grid-footer-locked { border-color: inherit; }

.k-grid-footer .k-grid-footer-sticky {
    background-color: var(--dark-color-base-bg);
    border-color: rgba(255, 255, 255, 0.5);
}

.k-grid-pager {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-grouping-row,
.k-group-cell {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-column-list-item:hover,
.k-columnmenu-item:hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-columnmenu-item:focus,
.k-columnmenu-item.k-state-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-column-list-wrapper { border-color: inherit; }

.k-columnmenu-item.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-column-menu .k-menu:not(.k-context-menu) {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item:hover, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item:focus, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-column-menu-group-header-text {
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-check-all-wrap { border-color: var(--dark-color-border); }

.k-grid-norecords-template {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
}

.k-listview {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-listview-content > .k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-listview-content > .k-state-selected { background-color: rgba(13, 110, 253, 0.25); }

.k-spreadsheet {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-spreadsheet-top-corner,
.k-spreadsheet-row-header,
.k-spreadsheet-column-header {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-syntax-ref { color: #ff8822; }

.k-syntax-num { color: #0099ff; }

.k-syntax-str { color: #38b714; }

.k-syntax-error { color: red; }

.k-syntax-bool { color: #a9169c; }

.k-syntax-paren-match { background-color: #caf200; }

.k-spreadsheet-cell-editor {
    background-color: var(--dark-color-component-bg);
    color: var(--dark-color-component-text);
}

.k-spreadsheet-merged-cell { background-color: var(--dark-color-component-bg); }

.k-spreadsheet .k-selection-full,
.k-spreadsheet .k-selection-partial { background-color: rgba(13, 110, 253, 0.25); }

.k-spreadsheet-selection {
    background-color: rgba(13, 110, 253, 0.25);
    border-color: var(--dark-color-selected-bg);
    box-shadow: inset 0 0 0 1px var(--dark-color-selected-bg);
}

.k-spreadsheet .k-single-selection::after {
    background-color: var(--dark-color-selected-bg);
    border-color: #000000;
}

.k-spreadsheet-active-cell {
    background-color: var(--dark-color-component-bg);
    box-shadow: inset 0 0 0 1px var(--dark-color-primary);
}

.k-spreadsheet-active-cell.k-right { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset -1px 0 0 1px var(--dark-color-primary); }

.k-spreadsheet-active-cell.k-bottom { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset 0 -1px 0 1px var(--dark-color-primary); }

.k-spreadsheet-active-cell.k-bottom.k-right { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset -1px -1px 0 1px var(--dark-color-primary); }

.k-spreadsheet .k-auto-fill {
    background-color: rgba(13, 110, 253, 0.25);
    border-color: var(--dark-color-primary);
    box-shadow: inset 0 0 0 1px var(--dark-color-primary);
}

.k-spreadsheet .k-auto-fill-punch { background-color: rgba(0, 0, 0, 0.5); }

.k-spreadsheet .k-resize-handle,
.k-spreadsheet .k-resize-hint-handle,
.k-spreadsheet .k-resize-hint-marker { background-color: var(--dark-color-primary); }

.k-spreadsheet-has-comment::after { border-color: var(--dark-color-primary) var(--dark-color-primary) transparent transparent; }

.k-dirty { border-color: var(--dark-color-error) transparent transparent var(--dark-color-error); }

.k-spreadsheet .k-filter-range { border-color: var(--dark-color-primary); }

.k-spreadsheet-filter {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    box-shadow: inset 0 0 0 1px var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-spreadsheet-filter.k-state-active {
    background-color: #4b545c;
    border-color: #515a63;
}

.k-spreadsheet-filter:hover {
    background-color: #454d55;
    border-color: #4b545c;
}

.k-spreadsheet-filter-menu > .k-menu .k-item.k-state-hover,
.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-spreadsheet-insert-image-dialog { border-color: var(--dark-color-border); }

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-state-hovered { box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5); }

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,
.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-state-hovered div { color: #000000; }

.k-spreadsheet-drawing.k-spreadsheet-active-drawing { outline-color: var(--dark-color-primary); }

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
}

.k-spreadsheet-drawing-anchor-cell { background: rgba(13, 110, 253, 0.25); }

.k-spreadsheet-popup .k-button:hover,
.k-spreadsheet-popup .k-button.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    color: var(--dark-color-hovered-text);
}

.k-spreadsheet-popup .k-button:active,
.k-spreadsheet-popup .k-button.k-state-active,
.k-spreadsheet-popup .k-button.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-rtl .k-spreadsheet .k-spreadsheet-has-comment::after,
.k-spreadsheet[dir="rtl"] .k-spreadsheet-has-comment::after,
[dir="rtl"] .k-spreadsheet .k-spreadsheet-has-comment::after { border-color: var(--dark-color-primary) transparent transparent var(--dark-color-primary); }

.k-rtl .k-spreadsheet .k-dirty,
.k-spreadsheet[dir="rtl"] .k-dirty,
[dir="rtl"] .k-spreadsheet .k-dirty { border-color: var(--dark-color-error) var(--dark-color-error) transparent transparent; }

.k-pivotgrid {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pivotgrid-column-headers,
.k-pivotgrid-row-headers,
.k-pivotgrid-empty-cell {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pivotgrid-empty-cell { border-color: #666c72; }

.k-pivotgrid-row-headers .k-pivotgrid-row .k-pivotgrid-cell:last-child { border-right-color: #666c72; }

.k-pivotgrid-column-headers .k-pivotgrid-column-total:nth-last-of-type(2) .k-pivotgrid-cell:not(.k-pivotgrid-expanded),
.k-pivotgrid-column-headers .k-pivotgrid-row:last-child { border-bottom-color: #666c72; }

.k-pivotgrid-header-total,
.k-pivotgrid-total {
    background-color: #141414;
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pivotgrid-row-headers tbody > .k-pivotgrid-row.k-state-hover,
.k-pivotgrid-row-headers tbody > .k-pivotgrid-row:hover,
.k-pivotgrid-column-headers tbody > .k-pivotgrid-row.k-state-hover,
.k-pivotgrid-column-headers tbody > .k-pivotgrid-row:hover,
.k-pivotgrid-values tbody > .k-pivotgrid-row.k-state-hover,
.k-pivotgrid-values tbody > .k-pivotgrid-row:hover { background-color: black; }

.k-pivotgrid-cell.k-state-focus,
.k-pivotgrid-cell:focus,
.k-master-row > .k-pivotgrid-cell:focus,
.k-grouping-row > .k-pivotgrid-cell:focus,
.k-detail-row > .k-pivotgrid-cell:focus,
.k-group-footer > .k-pivotgrid-cell:focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }

.k-pivotgrid-cell.k-state-selected,
.k-pivotgrid-row.k-state-selected > .k-pivotgrid-cell { background-color: rgba(13, 110, 253, 0.25); }

.k-pivotgrid-configurator-button,
.k-pivotgrid-configurator-panel {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pivotgrid-configurator-header { color: var(--dark-color-base-text); }

.k-pivotgrid-configurator-content .k-fields-list-wrapper { border-color: var(--dark-color-border); }

.k-calculated-field {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-calculated-field-header { color: var(--dark-color-base-text); }

.k-filter-menu .k-calculated-item { border-color: var(--dark-color-border); }

.k-pivotgrid-configurator-content .k-form-field-wrapper { border-color: var(--dark-color-border); }

.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay { box-shadow: -3px 0px 6px rgba(0, 0, 0, 0.16); }

.k-flex-row-reverse .k-pivotgrid-configurator-overlay { box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.16); }

.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay { box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16); }

.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay { box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16); }

.k-pivot {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pivot-table { border-color: var(--dark-color-border); }

.k-pivot-rowheaders {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pivot-toolbar {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-pivot-toolbar .k-empty { color: var(--dark-color-subtle-text); }

.k-alt { background-color: var(--dark-color-base-bg); }

.k-pivot-toolbar,
.k-pivot-table,
.k-pivot-rowheaders > .k-grid td:first-child,
.k-pivot-table .k-grid-header .k-header.k-first { border-color: var(--dark-color-border); }

.k-header.k-alt { background-color: #2a2e32; }

.k-pivot-layout .k-grid-footer {
    background-color: var(--dark-color-base-bg);
    color: var(--dark-color-base-text);
}

.k-i-kpi-trend-increase,
.k-i-kpi-trend-decrease,
.k-i-kpi-trend-equal { color: inherit; }

.k-i-kpi-status-hold { color: var(--dark-color-warning); }

.k-i-kpi-status-deny { color: var(--dark-color-error); }

.k-i-kpi-status-open { color: var(--dark-color-success); }

.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields { border-color: var(--dark-color-border); }

.k-treelist tr.k-footer,
.k-treelist tr.k-footer-template { background-color: var(--dark-color-base-bg); }

.k-treelist tr.k-footer:hover,
.k-treelist tr.k-footer-template:hover { background-color: var(--dark-color-base-bg); }

.k-treelist-scrollable .k-group-footer td,
.k-treelist-scrollable .k-grouping-row td,
.k-treelist-scrollable tbody .k-group-cell { background-color: var(--dark-color-base-bg); }

.k-filter { color: var(--dark-color-base-text); }

.k-filter .k-filter-preview-field { color: var(--dark-color-primary); }

.k-filter .k-filter-preview-operator { color: var(--dark-color-subtle-text); }

.k-filter .k-filter-item::before,
.k-filter .k-filter-toolbar::before,
.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,
.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after { background-color: #495057; }

.k-filemanager {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-filemanager-breadcrumb { background-color: var(--dark-color-base-bg); }

.k-filemanager-listview .k-listview-item .k-file-icon { color: #adadad; }

.k-filemanager-listview .k-listview-item.k-state-selected .k-file-icon {
    background-color: transparent;
    border-color: transparent;
    color: inherit;
}

.k-filemanager-preview .k-file-icon { color: #adadad; }

.k-taskboard-column {
    background-color: var(--dark-color-base-bg);
    border-color: transparent;
}

.k-taskboard-column:focus,
.k-taskboard-column.k-state-focus { border-color: #5c5e61; }

.k-taskboard-column-header { color: var(--dark-color-base-text); }

.k-taskboard-pane {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-taskboard-pane-header { color: var(--dark-color-base-text); }

.k-taskboard-card {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-taskboard-card .k-card-title { color: var(--dark-color-primary); }

.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-state-focus { color: #0b5cd5; }

.k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-state-hover { color: #0b5cd5; }

.k-taskboard-card:focus, .k-taskboard-card.k-state-focus {
    border-color: #6a7075;
    box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5);
}

.k-taskboard-card:hover, .k-taskboard-card.k-state-hover { border-color: #5b6268; }

.k-taskboard-card.k-state-selected {
    border-color: #b6d3fe;
    box-shadow: none;
}

.k-taskboard-drag-placeholder {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: var(--dark-color-border);
}

.k-editor-content > .ProseMirror .k-placeholder::before { color: #ced4da; }

.k-editor {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

kendo-editor.k-readonly .k-editor-content.k-state-focused { outline-color: #ffffff; }

.k-editor-inline .k-table,
.k-editor-inline .k-table td { border-color: var(--dark-color-subtle-text); }

.k-editor-inline .k-element-resize-handle-wrapper {
    background-color: #ffffff;
    border-color: #000000;
}

.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker { background-color: #00b0ff; }

.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker { background-color: #00b0ff; }

.k-editor-inline:hover, .k-editor-inline.k-state-active { border-color: var(--dark-color-border); }

.k-editor-resize-handle {
    background-color: #ffffff;
    border-color: #000000;
}

.ProseMirror-selectednode { outline-color: #8cf; }

.k-ct-popup .k-state-selected {
    background-color: var(--dark-color-selected-bg);
    border-color: #207afd;
    color: var(--dark-color-selected-text);
}

.k-editor-content .k-text-selected, .k-editor-content::selection {
    background-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-editor-content .k-text-highlighted { background-color: #cfe2ff; }

.k-imageeditor {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-imageeditor-content { background-color: #c6c6c6; }

.k-imageeditor-canvas { background: linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09) 0), white; }

.k-imageeditor-action-pane { background-color: var(--dark-color-component-bg); }

.k-imageeditor-crop { border-color: white; }

.k-imageeditor-crop-overlay { background-color: rgba(0, 0, 0, 0.3); }

.k-gantt {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {
    background-color: #495057;
    border-color: #666c72;
}

.k-gantt .k-treelist-scrollable .k-task-milestone.k-state-selected .k-task-milestone-content {
    background-color: var(--dark-color-primary);
    border-color: #207afd;
}

.k-gantt .k-gantt-dependencies-svg polyline {
    fill: none;
    stroke: gray;
}

.k-gantt .k-gantt-dependencies-svg polyline.k-state-selected { stroke: var(--dark-color-selected-bg); }

.k-gantt-footer { box-shadow: none; }

.k-gantt-treelist .k-treelist,
.k-gantt-treelist .k-grid-content { background-color: transparent; }

.k-gantt .k-nonwork-hour { background-color: rgba(255, 255, 255, 0.025); }

.k-task-dot::before { background-color: #ffffff; }

.k-task-dot:hover::before,
.k-task-dot.k-state-hover::before {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-component-text);
}

.k-task-milestone {
    background-color: #495057;
    border-color: #666c72;
}

.k-task-milestone.k-task-delayed { background-image: repeating-linear-gradient(90deg, #000000, #000000 2px, var(--dark-color-error) 2px, var(--dark-color-error) 4px); }

.k-task-milestone.k-task-advanced { background-color: var(--dark-color-success); }

.k-task-milestone.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    background-image: none;
    border-color: #207afd;
}

.k-task-summary { color: gray; }

.k-task-summary.k-task-delayed { color: #ea868f; }

.k-task-summary.k-task-advanced { color: #75b798; }

.k-task-summary-complete { color: var(--dark-color-base-text); }

.k-task-delayed .k-task-summary-complete { color: var(--dark-color-error); }

.k-task-advanced .k-task-summary-complete { color: var(--dark-color-success); }

.k-task-summary.k-state-selected { color: #07377f; }

.k-task-summary.k-state-selected .k-task-summary-complete { color: var(--dark-color-selected-bg); }

.k-task-single {
    background-color: #495057;
    border-color: var(--dark-color-secondary);
    color: white;
}

.k-task-single.k-task-delayed { background-color: #ea868f; }

.k-task-single.k-task-advanced { background-color: #75b798; }

.k-task-single .k-task-complete { background-color: var(--dark-color-secondary); }

.k-task-delayed .k-task-complete { background-color: var(--dark-color-error); }

.k-task-advanced .k-task-complete { background-color: var(--dark-color-success); }

.k-task-single.k-state-selected {
    background-color: #07377f;
    border-color: var(--dark-color-selected-bg);
    color: var(--dark-color-selected-text);
}

.k-task-single.k-state-selected .k-task-complete { background-color: var(--dark-color-selected-bg); }

.k-gantt-line { color: gray; }

.k-gantt-line.k-state-selected { color: var(--dark-color-selected-bg); }

.k-task-planned .k-task-moment {
    background-color: transparent;
    border-color: var(--dark-color-primary);
}

.k-task-planned .k-task-duration { background-color: var(--dark-color-primary); }

.k-task-planned:hover .k-task-moment { background-color: var(--dark-color-primary); }

.k-task-offset { background-image: repeating-linear-gradient(135deg, #000000, #000000 2px, var(--dark-color-error) 2px, var(--dark-color-error) 4px); }

.k-task-offset .k-resize-e::before { border-color: #000000; }

.k-task-offset .k-task-actions { color: #000000; }

.k-task-offset:hover { background-image: repeating-linear-gradient(135deg, #000000, #000000 2px, #ea868f 2px, #ea868f 4px); }

.k-pdf-export .k-task-offset { background-color: var(--dark-color-error); }

.k-offset-tooltip-delayed { background-color: var(--dark-color-error); }

.k-planned-tooltip { background-color: var(--dark-color-primary); }

.k-gantt-tooltip-validation::before { background-color: #656565; }

.k-gantt-tooltip-valid::before { background-color: var(--dark-color-success); }

.k-gantt-tooltip-invalid::before { background-color: var(--dark-color-error); }

.k-scheduler {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-current-time { background: #ff0000; }

.k-current-time.k-current-time-arrow-left { border-right-color: #ff0000; }

.k-current-time.k-current-time-arrow-right { border-left-color: #ff0000; }

.k-current-time.k-current-time-arrow-down { border-top-color: #ff0000; }

.k-scheduler-toolbar {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-scheduler-footer {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-scheduler-header { background-color: var(--dark-color-base-bg); }

.k-scheduler-header-wrap { background-color: var(--dark-color-component-bg); }

.k-scheduler-nonwork,
.k-scheduler .k-nonwork-hour { background-color: #0a0a0a; }

.k-scheduler-other-month,
.k-scheduler .k-other-month { background-color: #0a0a0a; }

.k-scheduler-layout td.k-state-selected,
.k-scheduler-layout .k-scheduler-cell.k-state-selected { background-color: rgba(13, 110, 253, 0.25); }

.k-scheduler-layout-flex .k-scheduler-head,
.k-scheduler-layout-flex .k-sticky-cell { background-color: var(--dark-color-component-bg); }

.k-event {
    background-color: #3485fd;
    color: var(--dark-color-base-text);
}

.k-event.k-state-selected {
    background-color: var(--dark-color-selected-bg);
    box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.5);
    color: var(--dark-color-selected-text);
}

.k-event-inverse { color: black; }

.k-event-ongoing { box-shadow: inset 0px 0px 0px 1px #ff0000; }

.k-scheduler-marquee::before,
.k-scheduler-marquee::after { border-color: var(--dark-color-primary); }

.k-scheduler-edit-dialog .k-dialog-buttongroup { border-color: var(--dark-color-border); }

.k-scheduler-agendaview .k-scheduler-content tr:hover,
.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-state-hover {
    background-color: var(--dark-color-hovered-bg);
    border-color: #444a4f;
    color: var(--dark-color-hovered-text);
}

.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-groupcolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover .k-scheduler-groupcolumn {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected { background-color: rgba(13, 110, 253, 0.25); }

.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected .k-scheduler-groupcolumn { background-color: var(--dark-color-component-bg); }

.k-scheduler-yearview .k-day-indicator { background-color: var(--dark-color-primary); }

.k-scheduler-yearview .k-state-selected .k-day-indicator { background-color: white; }

.k-tooltip.k-scheduler-tooltip {
    background-color: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    color: var(--dark-color-base-text);
}

.k-tooltip.k-scheduler-tooltip .k-callout { color: white; }

.k-chat {
    background-color: var(--dark-color-body-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-body-text);
}

.k-chat .k-timestamp { color: var(--dark-color-subtle-text); }

.k-chat .k-bubble {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-chat .k-bubble a { color: var(--dark-color-primary); }

.k-chat .k-bubble a:hover { color: var(--dark-color-link-hover-text); }

.k-chat .k-alt .k-bubble {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-chat .k-quick-reply {
    background-color: transparent;
    border-color: var(--dark-color-primary);
    color: var(--dark-color-primary);
}

.k-chat .k-quick-reply:hover {
    background-color: var(--dark-color-primary);
    border-color: var(--dark-color-primary);
    color: white;
}

.k-chat-toolbar,
.k-chat .k-toolbar-box {
    background-color: var(--dark-color-base-bg);
    border-color: inherit;
    color: var(--dark-color-base-text);
}

.k-mediaplayer {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-mediaplayer-titlebar {
    background-image: linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0));
    color: #000000;
    text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
}

.k-timeline .k-timeline-flag {
    background-color: var(--dark-color-primary);
    color: white;
}

.k-timeline .k-timeline-circle { background-color: var(--dark-color-primary); }

.k-timeline .k-timeline-card .k-card-header {
    background-color: var(--dark-color-component-bg);
    color: var(--dark-color-component-text);
}

.k-timeline .k-timeline-card .k-card-body { scrollbar-color: #495057 #000000; }

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-track { background: #000000; }

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb { background: #495057; }

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb:hover { background: #444a4f; }

.k-timeline .k-timeline-date { color: var(--dark-color-base-text); }

.k-timeline .k-timeline-arrow.k-state-disabled {
    background-color: #22262a;
    border-color: #22262a;
    color: #a6a6a6;
}

.k-timeline-vertical::after,
.k-timeline-horizontal .k-timeline-track-wrap::after {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
}

.k-timeline-horizontal .k-timeline-flag::after { background-color: var(--dark-color-primary); }

.k-timeline-track-item.k-state-focus .k-timeline-circle { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }

.k-pdf-viewer {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-pdf-viewer .k-canvas { background-color: #050505; }

.k-pdf-viewer .k-page {
    background-color: white;
    border-color: var(--dark-color-border);
    box-shadow: 0 0 15px #495057;
    color: var(--dark-color-base-text);
}

.k-pdf-viewer .k-search-highlight { background-color: #ffffff; }

.km-touch-scrollbar { background-color: #333333; }

kendo-scrollview.k-scrollview-wrap,
.k-scrollview {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

kendo-scrollview.k-scrollview-wrap.k-scrollview-dark kendo-scrollview-pager,
kendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-nav-wrap,
.k-scrollview.k-scrollview-dark kendo-scrollview-pager,
.k-scrollview.k-scrollview-dark .k-scrollview-nav-wrap { background-color: rgba(0, 0, 0, 0.4); }

kendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-next,
kendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-prev,
.k-scrollview.k-scrollview-dark .k-scrollview-next,
.k-scrollview.k-scrollview-dark .k-scrollview-prev { color: rgba(0, 0, 0, 0.4); }

kendo-scrollview.k-scrollview-wrap.k-scrollview-light kendo-scrollview-pager,
kendo-scrollview.k-scrollview-wrap.k-scrollview-light .k-scrollview-nav-wrap,
.k-scrollview.k-scrollview-light kendo-scrollview-pager,
.k-scrollview.k-scrollview-light .k-scrollview-nav-wrap { background-color: rgba(255, 255, 255, 0.4); }

.k-scrollview:focus,
.k-scrollview-wrap:focus { outline: none; }

.k-scrollview-next,
.k-scrollview-prev {
    background-color: rgba(0, 0, 0, 0);
    color: white;
    text-shadow: rgba(0, 0, 0, 0.3) 0 0 15px;
}

.k-scrollview-next:focus, .k-scrollview-next.k-state-focus,
.k-scrollview-prev:focus,
.k-scrollview-prev.k-state-focus { color: white; }

.k-scrollview-next:focus .k-icon::before, .k-scrollview-next.k-state-focus .k-icon::before,
.k-scrollview-prev:focus .k-icon::before,
.k-scrollview-prev.k-state-focus .k-icon::before { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-scrollview-next:hover, .k-scrollview-next.k-state-hover,
.k-scrollview-prev:hover,
.k-scrollview-prev.k-state-hover { color: white; }

.k-scrollview-pageable > .k-button,
.k-scrollview-nav > .k-link {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
}

.k-scrollview-pageable > .k-button.k-primary,
.k-scrollview-nav > .k-link.k-primary {
    background: var(--dark-color-primary);
    border: var(--dark-color-primary);
}

.k-scrollview-pageable > .k-button:focus, .k-scrollview-pageable > .k-button.k-state-focused,
.k-scrollview-nav > .k-link:focus,
.k-scrollview-nav > .k-link.k-state-focused { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-scrollview-nav > .k-link:hover,
.k-scrollview-nav > .k-link.k-state-hover { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }

.k-scrollview-pageable > .k-button { box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.08); }

.k-var--accent { background-color: var(--dark-color-primary); }

.k-var--accent-contrast { background-color: white; }

.k-var--primary { background-color: var(--dark-color-primary); }

.k-var--primary-contrast { background-color: white; }

.k-var--base { background-color: var(--dark-color-base-bg); }

.k-var--background { background-color: var(--dark-color-component-bg); }

.k-var--border-radius { margin-top: 0.25rem; }

.k-var--normal-background { background-color: var(--dark-color-base-bg); }

.k-var--normal-text-color { background-color: #ffffff; }

.k-var--hover-background { background-color: var(--dark-color-hovered-bg); }

.k-var--hover-text-color { background-color: #ffffff; }

.k-var--selected-background { background-color: var(--dark-color-selected-bg); }

.k-var--selected-text-color { background-color: #ffffff; }

.k-var--success { background-color: var(--dark-color-success); }

.k-var--info { background-color: var(--dark-color-info); }

.k-var--warning { background-color: var(--dark-color-warning); }

.k-var--error { background-color: var(--dark-color-error); }

.k-var--series-a { background-color: var(--dark-color-series-a); }

.k-var--series-b { background-color: var(--dark-color-series-b); }

.k-var--series-c { background-color: var(--dark-color-series-c); }

.k-var--series-d { background-color: var(--dark-color-series-d); }

.k-var--series-e { background-color: var(--dark-color-series-e); }

.k-var--series-f { background-color: var(--dark-color-series-f); }

.k-var--series-1 { background-color: var(--dark-color-series-a); }

.k-var--series-2 { background-color: var(--dark-color-series-b); }

.k-var--series-3 { background-color: var(--dark-color-series-c); }

.k-var--series-4 { background-color: var(--dark-color-series-d); }

.k-var--series-5 { background-color: var(--dark-color-series-e); }

.k-var--series-6 { background-color: var(--dark-color-series-f); }

.k-var--series-7 { background-color: #4a92fe; }

.k-var--series-8 { background-color: #9371d1; }

.k-var--series-9 { background-color: #58d7b1; }

.k-var--series-10 { background-color: #53a57f; }

.k-var--series-11 { background-color: #ffd145; }

.k-var--series-12 { background-color: #e56874; }

.k-var--series-13 { background-color: #0a53be; }

.k-var--series-14 { background-color: #533291; }

.k-var--series-15 { background-color: #189771; }

.k-var--series-16 { background-color: #13653f; }

.k-var--series-17 { background-color: #bf9105; }

.k-var--series-18 { background-color: #a52834; }

.k-var--series-19 { background-color: #86b7fe; }

.k-var--series-20 { background-color: #b7a1e0; }

.k-var--series-21 { background-color: #90e4cb; }

.k-var--series-22 { background-color: #8cc3aa; }

.k-var--series-23 { background-color: #ffe083; }

.k-var--series-24 { background-color: #ee9aa2; }

.k-var--series-25 { background-color: #07377f; }

.k-var--series-26 { background-color: #382161; }

.k-var--series-27 { background-color: #10654c; }

.k-var--series-28 { background-color: #0d442a; }

.k-var--series-29 { background-color: #806104; }

.k-var--series-30 { background-color: #6e1b23; }

.k-var--gauge-pointer { background-color: var(--dark-color-primary); }

.k-var--gauge-track { background-color: #141414; }

.k-var--chart-inactive { background-color: rgba(255, 255, 255, 0.5); }

.k-var--chart-major-lines { background-color: rgba(255, 255, 255, 0.08); }

.k-var--chart-minor-lines { background-color: rgba(255, 255, 255, 0.04); }

.k-var--chart-notes-background { background-color: rgba(255, 255, 255, 0.5); }

.k-var--chart-notes-border { background-color: rgba(255, 255, 255, 0.5); }

.k-var--chart-notes-lines { background-color: rgba(255, 255, 255, 0.5); }

.k-var--chart-crosshair-background { background-color: rgba(255, 255, 255, 0.5); }

.k-var--chart-error-bars-background { background-color: rgba(255, 255, 255, 0.5); }

.k-chart,
.k-sparkline,
.k-stockchart {
    background-color: transparent;
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-chart .k-popup,
.k-sparkline .k-popup,
.k-stockchart .k-popup { background: transparent; }

.k-chart-tooltip { color: var(--dark-color-base-text); }

.k-chart-tooltip-inverse { color: #000000; }

.k-chart-crosshair-tooltip,
.k-chart-shared-tooltip {
    background-color: #141414;
    border-color: rgba(255, 255, 255, 0.08);
    color: var(--dark-color-base-text);
}

.k-selection {
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: inset 0 1px 7px rgba(255, 255, 255, 0.15);
}

.k-selection-bg { background-color: transparent; }

.k-handle {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
    cursor: e-resize;
}

.k-handle:hover {
    background-color: #454d55;
    border-color: #4b545c;
}

.k-handle div { background-color: transparent; }

.k-mask { background-color: var(--dark-color-component-bg); }

.k-treemap {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-treemap .k-treemap-title {
    background-color: var(--dark-color-base-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-base-text);
}

.k-treemap .k-leaf { color: #000000; }

.k-treemap .k-leaf.k-inverse { color: #ffffff; }

.k-treemap .k-leaf.k-state-hover { box-shadow: inset 0 0 0 3px #495057; }

.k-map {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-map .k-navigator {
    background-color: var(--dark-color-kendo-button-bg);
    border-color: var(--dark-color-kendo-button-bg);
    color: var(--dark-color-kendo-button-text);
}

.k-map .k-marker { color: var(--dark-color-primary); }

.k-map .k-attribution { background-color: rgba(0, 0, 0, 0.8); }

.k-orgchart {
    background-color: var(--dark-color-component-bg);
    border-color: var(--dark-color-border);
    color: var(--dark-color-component-text);
}

.k-orgchart-card:focus, .k-orgchart-card.k-state-focus { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-orgchart-node-group-container {
    background-color: var(--dark-color-base-bg);
    border-color: #33363a;
    color: var(--dark-color-base-text);
}

.k-orgchart-node-group-container:focus,
.k-orgchart-node-group-container.k-state-focus,
.k-orgchart-node-group-container.k-state-focused { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }

.k-orgchart-node-group-subtitle { color: var(--dark-color-subtle-text); }

.k-orgchart-line-h,
.k-orgchart-line-v { color: #33363a; }`, "",{"version":3,"sources":["webpack://./ClientApp/styles/dark/kendoOverride.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,QAAQ,sCAAsC,EAAE;;AAEhD,WAAW,qFAAqF,EAAE;;AAElG;kBACkB,qFAAqF,EAAE;;AAEzG,sBAAsB,oCAAoC,EAAE;;AAE5D;mBACmB,yBAAyB,EAAE;;AAE9C,oBAAoB,2CAA2C,EAAE;;AAEjE,oCAAoC,4CAA4C,EAAE;;AAElF,kCAAkC,6CAA6C,EAAE;;AAEjF,oCAAoC,2CAA2C,EAAE;;AAEjF,kCAAkC,8CAA8C,EAAE;;AAElF;IACI,2CAA2C;IAC3C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,gDAAgD,6BAA6B,EAAE;;AAE/E,mBAAmB,gDAAgD,EAAE;;AAErE,eAAe,6BAA6B,EAAE;;AAE9C;;;;IAII,6BAA6B;IAC7B,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;;IAEI,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,kBAAkB,kCAAkC,EAAE;;AAEtD;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,oBAAoB,kDAAkD,EAAE;;AAExE,sBAAsB,oDAAoD,EAAE;;AAE5E,qBAAqB,mDAAmD,EAAE;;AAE1E,iBAAiB,+CAA+C,EAAE;;AAElE,oBAAoB,kDAAkD,EAAE;;AAExE,oBAAoB,kDAAkD,EAAE;;AAExE,kBAAkB,gDAAgD,EAAE;;AAEpE,iBAAiB,kDAAkD,EAAE;;AAErE,kBAAkB,gCAAgC,EAAE;;AAEpD,oBAAoB,gCAAgC,EAAE;;AAEtD;gBACgB,kCAAkC,EAAE;;AAEpD,mBAAmB,cAAc,EAAE;;AAEnC;mBACmB,2CAA2C,EAAE;;AAEhE;qBACqB,6CAA6C,EAAE;;AAEpE;oBACoB,4CAA4C,EAAE;;AAElE;gBACgB,wCAAwC,EAAE;;AAE1D;mBACmB,2CAA2C,EAAE;;AAEhE;mBACmB,2CAA2C,EAAE;;AAEhE;iBACiB,yCAAyC,EAAE;;AAE5D;gBACgB,2CAA2C,EAAE;;AAE7D;iBACiB,yBAAyB,EAAE;;AAE5C;mBACmB,yBAAyB,EAAE;;AAE9C,gBAAgB,sDAAsD,EAAE;;AAExE,kBAAkB,wDAAwD,EAAE;;AAE5E,iBAAiB,uDAAuD,EAAE;;AAE1E,aAAa,mDAAmD,EAAE;;AAElE,gBAAgB,sDAAsD,EAAE;;AAExE,gBAAgB,sDAAsD,EAAE;;AAExE,cAAc,oDAAoD,EAAE;;AAEpE,aAAa,sDAAsD,EAAE;;AAErE,cAAc,oCAAoC,EAAE;;AAEpD,gBAAgB,oCAAoC,EAAE;;AAEtD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,WAAW,wFAAwF,EAAE;;AAErG;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;;IAEI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,uCAAuC;IACvC,kDAAkD;AACtD;;AAEA,wBAAwB,qCAAqC,EAAE;;AAE/D,4CAA4C,8BAA8B,EAAE;;AAE5E,kCAAkC,gCAAgC,EAAE;;AAEpE,yCAAyC,qCAAqC,EAAE;;AAEhF;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,8BAA8B,qBAAqB,EAAE;;AAErD;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA,mGAAmG,qDAAqD,EAAE;;AAE1J;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,qBAAqB,qBAAqB,EAAE;;AAE5C;IACI,6CAA6C;IAC7C,cAAc;AAClB;;AAEA,wBAAwB,oCAAoC,EAAE;;AAE9D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,aAAa,gDAAgD,EAAE;;AAE/D,qBAAqB,2CAA2C,EAAE;;AAElE,uBAAuB,6CAA6C,EAAE;;AAEtE,sBAAsB,4CAA4C,EAAE;;AAEpE,kBAAkB,wCAAwC,EAAE;;AAE5D,qBAAqB,2CAA2C,EAAE;;AAElE,qBAAqB,2CAA2C,EAAE;;AAElE,mBAAmB,yCAAyC,EAAE;;AAE9D,kBAAkB,2CAA2C,EAAE;;AAE/D,mBAAmB,yBAAyB,EAAE;;AAE9C,qBAAqB,yBAAyB,EAAE;;AAEhD,YAAY,4EAA4E,EAAE;;AAE1F;IACI,gDAAgD;IAChD,sCAAsC;IACtC,4EAA4E;IAC5E,uCAAuC;AAC3C;;AAEA,yBAAyB,6BAA6B,EAAE;;AAExD;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA,mCAAmC,gCAAgC,EAAE;;AAErE,qCAAqC,kCAAkC,EAAE;;AAEzE,oCAAoC,iCAAiC,EAAE;;AAEvE,gCAAgC,6BAA6B,EAAE;;AAE/D,mCAAmC,gCAAgC,EAAE;;AAErE,mCAAmC,gCAAgC,EAAE;;AAErE,iCAAiC,8BAA8B,EAAE;;AAEjE,gCAAgC,gCAAgC,EAAE;;AAElE,iCAAiC,cAAc,EAAE;;AAEjD,mCAAmC,cAAc,EAAE;;AAEnD,iBAAiB,oCAAoC,EAAE;;AAEvD;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,2DAA2D,+CAA+C,EAAE;;AAE5G;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,iEAAiE,mDAAmD,EAAE;;AAEtH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,qEAAqE,oDAAoD,EAAE;;AAE3H;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mEAAmE,mDAAmD,EAAE;;AAExH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,2DAA2D,mDAAmD,EAAE;;AAEhH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,iEAAiE,kDAAkD,EAAE;;AAErH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,iEAAiE,kDAAkD,EAAE;;AAErH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,6DAA6D,kDAAkD,EAAE;;AAEjH;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,2DAA2D,iDAAiD,EAAE;;AAE9G;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,6DAA6D,oDAAoD,EAAE;;AAEnH;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,iEAAiE,oDAAoD,EAAE;;AAEvH;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qEAAqE,mDAAmD,EAAE;;AAE1H;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA,yEAAyE,oDAAoD,EAAE;;AAE/H;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA,uEAAuE,mDAAmD,EAAE;;AAE5H;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA,+DAA+D,mDAAmD,EAAE;;AAEpH;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qEAAqE,kDAAkD,EAAE;;AAEzH;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qEAAqE,kDAAkD,EAAE;;AAEzH;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA,iEAAiE,kDAAkD,EAAE;;AAErH;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA,+DAA+D,iDAAiD,EAAE;;AAElH;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,iEAAiE,oDAAoD,EAAE;;AAEvH;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,qEAAqE,oDAAoD,EAAE;;AAE3H;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,+DAA+D,oDAAoD,EAAE;;AAErH;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,yBAAyB,gCAAgC,EAAE;;AAE3D,2BAA2B,kCAAkC,EAAE;;AAE/D,0BAA0B,iCAAiC,EAAE;;AAE7D,sBAAsB,6BAA6B,EAAE;;AAErD,yBAAyB,gCAAgC,EAAE;;AAE3D,yBAAyB,gCAAgC,EAAE;;AAE3D,uBAAuB,8BAA8B,EAAE;;AAEvD,sBAAsB,gCAAgC,EAAE;;AAExD,uBAAuB,cAAc,EAAE;;AAEvC,yBAAyB,cAAc,EAAE;;AAEzC,sBAAsB,cAAc,EAAE;;AAEtC,yBAAyB,gCAAgC,EAAE;;AAE3D,+DAA+D,cAAc,EAAE;;AAE/E,+DAA+D,mDAAmD,EAAE;;AAEpH,iEAAiE,cAAc,EAAE;;AAEjF,oCAAoC,cAAc,EAAE;;AAEpD,2BAA2B,kCAAkC,EAAE;;AAE/D,mEAAmE,cAAc,EAAE;;AAEnF,mEAAmE,oDAAoD,EAAE;;AAEzH,qEAAqE,cAAc,EAAE;;AAErF,sCAAsC,cAAc,EAAE;;AAEtD,0BAA0B,iCAAiC,EAAE;;AAE7D,iEAAiE,cAAc,EAAE;;AAEjF,iEAAiE,mDAAmD,EAAE;;AAEtH,mEAAmE,cAAc,EAAE;;AAEnF,qCAAqC,cAAc,EAAE;;AAErD,sBAAsB,6BAA6B,EAAE;;AAErD,yDAAyD,cAAc,EAAE;;AAEzE,yDAAyD,mDAAmD,EAAE;;AAE9G,2DAA2D,cAAc,EAAE;;AAE3E,iCAAiC,cAAc,EAAE;;AAEjD,yBAAyB,gCAAgC,EAAE;;AAE3D,+DAA+D,cAAc,EAAE;;AAE/E,+DAA+D,kDAAkD,EAAE;;AAEnH,iEAAiE,cAAc,EAAE;;AAEjF,oCAAoC,cAAc,EAAE;;AAEpD,yBAAyB,gCAAgC,EAAE;;AAE3D,+DAA+D,cAAc,EAAE;;AAE/E,+DAA+D,kDAAkD,EAAE;;AAEnH,iEAAiE,cAAc,EAAE;;AAEjF,oCAAoC,cAAc,EAAE;;AAEpD,uBAAuB,8BAA8B,EAAE;;AAEvD,2DAA2D,cAAc,EAAE;;AAE3E,2DAA2D,kDAAkD,EAAE;;AAE/G,6DAA6D,cAAc,EAAE;;AAE7E,kCAAkC,cAAc,EAAE;;AAElD,sBAAsB,gCAAgC,EAAE;;AAExD,yDAAyD,cAAc,EAAE;;AAEzE,yDAAyD,iDAAiD,EAAE;;AAE5G,2DAA2D,cAAc,EAAE;;AAE3E,iCAAiC,cAAc,EAAE;;AAEjD,uBAAuB,cAAc,EAAE;;AAEvC,2DAA2D,cAAc,EAAE;;AAE3E,2DAA2D,oDAAoD,EAAE;;AAEjH,6DAA6D,cAAc,EAAE;;AAE7E,kCAAkC,cAAc,EAAE;;AAElD,yBAAyB,cAAc,EAAE;;AAEzC,+DAA+D,cAAc,EAAE;;AAE/E,+DAA+D,oDAAoD,EAAE;;AAErH,iEAAiE,cAAc,EAAE;;AAEjF,oCAAoC,cAAc,EAAE;;AAEpD,sBAAsB,kCAAkC,EAAE;;AAE1D,yDAAyD,YAAY,EAAE;;AAEvE,yDAAyD,oDAAoD,EAAE;;AAE/G,2DAA2D,YAAY,EAAE;;AAEzE,iCAAiC,YAAY,EAAE;;AAE/C,0BAA0B,gCAAgC,EAAE;;AAE5D,4BAA4B,kCAAkC,EAAE;;AAEhE,2BAA2B,iCAAiC,EAAE;;AAE9D,uBAAuB,6BAA6B,EAAE;;AAEtD,0BAA0B,gCAAgC,EAAE;;AAE5D,0BAA0B,gCAAgC,EAAE;;AAE5D,wBAAwB,8BAA8B,EAAE;;AAExD,uBAAuB,gCAAgC,EAAE;;AAEzD,wBAAwB,cAAc,EAAE;;AAExC,0BAA0B,cAAc,EAAE;;AAE1C,uBAAuB,kCAAkC,EAAE;;AAE3D;0BAC0B,+CAA+C,EAAE;;AAE3E,4EAA4E,cAAc,EAAE;;AAE5F,kEAAkE,cAAc,EAAE;;AAElF,oEAAoE,cAAc,EAAE;;AAEpF;yBACyB,cAAc,EAAE;;AAEzC;kCACkC,cAAc,EAAE;;AAElD,4CAA4C,cAAc,EAAE;;AAE5D,uCAAuC,cAAc,EAAE;;AAEvD,wCAAwC,cAAc,EAAE;;AAExD,8BAA8B,cAAc,EAAE;;AAE9C,uCAAuC,cAAc,EAAE;;AAEvD;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,kDAAkD;IAClD,cAAc;AAClB;;AAEA,mFAAmF,qCAAqC,EAAE;;AAE1H,8JAA8J,8BAA8B,EAAE;;AAE9L,+MAA+M,iDAAiD,EAAE;;AAElQ,0HAA0H,iDAAiD,EAAE;;AAE7K;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,qCAAqC,+CAA+C,EAAE;;AAEtF,yBAAyB,+CAA+C,EAAE;;AAE1E,sFAAsF,qCAAqC,EAAE;;AAE7H,iKAAiK,8BAA8B,EAAE;;AAEjM,qNAAqN,iDAAiD,EAAE;;AAExQ,6HAA6H,iDAAiD,EAAE;;AAEhL;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;IAGI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,mBAAmB,2CAA2C,EAAE;;AAEhE;;;qCAGqC,2CAA2C,EAAE;;AAElF;;;oCAGoC,+CAA+C,EAAE;;AAErF;;IAEI,0CAA0C;IAC1C,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,oBAAoB,0BAA0B,EAAE;;AAEhD,4BAA4B,gCAAgC,EAAE;;AAE9D,8BAA8B,kCAAkC,EAAE;;AAElE,6BAA6B,iCAAiC,EAAE;;AAEhE,yBAAyB,6BAA6B,EAAE;;AAExD,4BAA4B,gCAAgC,EAAE;;AAE9D,4BAA4B,gCAAgC,EAAE;;AAE9D,0BAA0B,8BAA8B,EAAE;;AAE1D,yBAAyB,gCAAgC,EAAE;;AAE3D,0BAA0B,cAAc,EAAE;;AAE1C,4BAA4B,cAAc,EAAE;;AAE5C;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA,uDAAuD,yBAAyB,EAAE;;AAElF,gCAAgC,yBAAyB,EAAE;;AAE3D;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA,yDAAyD,yBAAyB,EAAE;;AAEpF,iCAAiC,yBAAyB,EAAE;;AAE5D;IACI,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA,uDAAuD,yBAAyB,EAAE;;AAElF,gCAAgC,yBAAyB,EAAE;;AAE3D;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA,6DAA6D,yBAAyB,EAAE;;AAExF,mCAAmC,yBAAyB,EAAE;;AAE9D;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA,6DAA6D,yBAAyB,EAAE;;AAExF,mCAAmC,yBAAyB,EAAE;;AAE9D;IACI,gDAAgD;IAChD,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA,2DAA2D,+CAA+C,EAAE;;AAE5G;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA,6DAA6D,6CAA6C,EAAE;;AAE5G;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA,2DAA2D,8CAA8C,EAAE;;AAE3G;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA,iEAAiE,6CAA6C,EAAE;;AAEhH;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA,iEAAiE,6CAA6C,EAAE;;AAEhH;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA,4CAA4C,yBAAyB,EAAE;;AAEvE,mBAAmB,sCAAsC,EAAE;;AAE3D,mDAAmD,qBAAqB,EAAE;;AAE1E,oBAAoB,gCAAgC,EAAE;;AAEtD,sBAAsB,gCAAgC,EAAE;;AAExD,qBAAqB,iCAAiC,EAAE;;AAExD,iBAAiB,6BAA6B,EAAE;;AAEhD,oBAAoB,gCAAgC,EAAE;;AAEtD,oBAAoB,gCAAgC,EAAE;;AAEtD,kBAAkB,8BAA8B,EAAE;;AAElD,iBAAiB,gCAAgC,EAAE;;AAEnD,kBAAkB,cAAc,EAAE;;AAElC,oBAAoB,cAAc,EAAE;;AAEpC;IACI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA,8CAA8C,2CAA2C,EAAE;;AAE3F,cAAc,0CAA0C,EAAE;;AAE1D,0EAA0E,0FAA0F,EAAE;;AAEtK,kCAAkC,sCAAsC,EAAE;;AAE1E,6BAA6B,sCAAsC,EAAE;;AAErE;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,yCAAyC,+BAA+B,EAAE;;AAE1E,+FAA+F,+BAA+B,EAAE;;AAEhI,iGAAiG,+BAA+B,EAAE;;AAElI,+FAA+F,qDAAqD,EAAE;;AAEtJ;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;IAGI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;;;;IAII,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;yCAEyC,qDAAqD,EAAE;;AAEhG;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA,8BAA8B,+BAA+B,EAAE;;AAE/D;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,0BAA0B,qBAAqB,EAAE;;AAEjD;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA,iFAAiF,qDAAqD,EAAE;;AAExI;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA,uFAAuF,cAAc,EAAE;;AAEvG;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;iBACiB,kCAAkC,EAAE;;AAErD;gCACgC,sCAAsC,EAAE;;AAExE;+BAC+B,oCAAoC,EAAE;;AAErE;gCACgC,8BAA8B,EAAE;;AAEhE;;+BAE+B,8BAA8B,EAAE;;AAE/D,oBAAoB,sCAAsC,EAAE;;AAE5D,gCAAgC,4EAA4E,EAAE;;AAE9G;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,wBAAwB,kCAAkC,EAAE;;AAE5D;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,gCAAgC,gCAAgC,EAAE;;AAElE;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;AAEA,6BAA6B,6BAA6B,EAAE;;AAE5D;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,gCAAgC,gCAAgC,EAAE;;AAElE;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,gCAAgC,gCAAgC,EAAE;;AAElE;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA,8BAA8B,8BAA8B,EAAE;;AAE9D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,0BAA0B,2CAA2C,EAAE;;AAEvE,yBAAyB,yBAAyB,EAAE;;AAEpD;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA,yBAAyB,qBAAqB,EAAE;;AAEhD;IACI,yBAAyB;IACzB,+IAA+I;IAC/I,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;;;+BAG+B,qCAAqC,EAAE;;AAEtE;;;gDAGgD,8BAA8B,EAAE;;AAEhF;;IAEI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,uCAAuC;IACvC,kDAAkD;AACtD;;AAEA,sCAAsC,qCAAqC,EAAE;;AAE7E,oBAAoB,6BAA6B,EAAE;;AAEnD,gBAAgB,6BAA6B,EAAE;;AAE/C,YAAY,kCAAkC,EAAE;;AAEhD,4BAA4B,yBAAyB,EAAE;;AAEvD,gCAAgC,+CAA+C,EAAE;;AAEjF;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,yEAAyE,6CAA6C,EAAE;;AAExH,0CAA0C,6CAA6C,EAAE;;AAEzF,iBAAiB,yBAAyB,EAAE;;AAE5C,+CAA+C,iCAAiC,EAAE;;AAElF,gEAAgE,iDAAiD,EAAE;;AAEnH;6CAC6C,uBAAuB,EAAE;;AAEtE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,qBAAqB;IACrB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,2BAA2B,gCAAgC,EAAE;;AAE7D,iJAAiJ,wCAAwC,EAAE;;AAE3L;;;8BAG8B,oCAAoC,EAAE;;AAEpE,gDAAgD,uDAAuD,EAAE;;AAEzG,gEAAgE,kGAAkG,EAAE;;AAEpK,6BAA6B,oCAAoC,EAAE;;AAEnE;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;;IAEI,8CAA8C;IAC9C,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;IAC7C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;mDACmD,qDAAqD,EAAE;;AAE1G;oEACoE,mDAAmD,EAAE;;AAEzH;IACI,2CAA2C;IAC3C,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;sDACsD,wCAAwC,EAAE;;AAEhG;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;4CAC4C,+BAA+B,EAAE;;AAE7E,sJAAsJ,qCAAqC,EAAE;;AAE7L;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;;2BAE2B,yJAAyJ,EAAE;;AAEtL;;;IAGI,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;mCACmC,6CAA6C,EAAE;;AAElF;kDACkD,gDAAgD,EAAE;;AAEpG;IACI,sFAAsF;IACtF,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uFAAuF;IACvF,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;sCACsC,gCAAgC,EAAE;;AAExE;4CAC4C,wCAAwC,EAAE;;AAEtF,gCAAgC,oCAAoC,EAAE;;AAEtE,gDAAgD,qCAAqC,EAAE;;AAEvF,4FAA4F,qCAAqC,EAAE;;AAEnI,4CAA4C,iCAAiC,EAAE;;AAE/E,6BAA6B,gCAAgC,EAAE;;AAE/D,oBAAoB,uBAAuB,EAAE;;AAE7C;IACI,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,cAAc;AAClB;;AAEA,+FAA+F,oFAAoF,EAAE;;AAErL,+FAA+F,oFAAoF,EAAE;;AAErL,6JAA6J,mEAAmE,EAAE;;AAElO;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;2BAE2B,qBAAqB,EAAE;;AAElD,0CAA0C,yHAAyH,EAAE;;AAErK;IACI,6BAA6B;IAC7B,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,2EAA2E,oGAAoG,EAAE;;AAEjL,yEAAyE,kGAAkG,EAAE;;AAE7K,+BAA+B,oCAAoC,EAAE;;AAErE;iFACiF,mGAAmG,EAAE;;AAEtL;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;yBAEyB,qBAAqB,EAAE;;AAEhD,cAAc,kCAAkC,EAAE;;AAElD;IACI,8CAA8C;IAC9C,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA,mDAAmD,qDAAqD,EAAE;;AAE1G;IACI,+CAA+C;IAC/C,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,qDAAqD;IACrD,wCAAwC;AAC5C;;AAEA,YAAY,kCAAkC,EAAE;;AAEhD,+FAA+F,yCAAyC,EAAE;;AAE1I,iIAAiI,yCAAyC,EAAE;;AAE5K,iBAAiB,oCAAoC,EAAE;;AAEvD,kCAAkC,oCAAoC,EAAE;;AAExE,yFAAyF,oCAAoC,EAAE;;AAE/H;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA,gCAAgC,yBAAyB,EAAE;;AAE3D;IACI,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA,mFAAmF,mDAAmD,EAAE;;AAExI,mCAAmC,kBAAkB,EAAE;;AAEvD;IACI,2CAA2C;IAC3C,uCAAuC;AAC3C;;AAEA,+BAA+B,uBAAuB,EAAE;;AAExD,2EAA2E,+CAA+C,EAAE;;AAE5H,iFAAiF,yBAAyB,EAAE;;AAE5G,mCAAmC,kBAAkB,EAAE;;AAEvD;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;qCACqC,cAAc,EAAE;;AAErD,qCAAqC,oCAAoC,EAAE;;AAE3E;8CAC8C,gCAAgC,EAAE;;AAEhF,wBAAwB,6BAA6B,EAAE;;AAEvD;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,mFAAmF,yBAAyB,EAAE;;AAE9G,yCAAyC,oCAAoC,EAAE;;AAE/E;oBACoB,sCAAsC,EAAE;;AAE5D,oCAAoC,+CAA+C,EAAE;;AAErF,qDAAqD,yCAAyC,EAAE;;AAEhG,6BAA6B,oCAAoC,EAAE;;AAEnE,0CAA0C,kCAAkC,EAAE;;AAE9E,yCAAyC,wCAAwC,EAAE;;AAEnF,wCAAwC,2CAA2C,EAAE;;AAErF;uDACuD,8BAA8B,EAAE;;AAEvF;wCACwC,yCAAyC,EAAE;;AAEnF;;;;;;;;IAQI,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;;;;;gDAKgD,2CAA2C,EAAE;;AAE7F;;;;;IAKI,gDAAgD;IAChD,iGAAiG;AACrG;;AAEA;;IAEI,gDAAgD;IAChD,+CAA+C;AACnD;;AAEA;;gCAEgC,oCAAoC,EAAE;;AAEtE,0DAA0D,kCAAkC,EAAE;;AAE9F,4FAA4F,qCAAqC,EAAE;;AAEnI,YAAY,2CAA2C,EAAE;;AAEzD,mBAAmB,4CAA4C,EAAE;;AAEjE;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,8GAA8G;IAC9G,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,8GAA8G;IAC9G,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,8GAA8G;IAC9G,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,8GAA8G;IAC9G,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,8GAA8G;IAC9G,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,8GAA8G;IAC9G,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,8GAA8G;IAC9G,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,8GAA8G;IAC9G,kCAAkC;IAClC,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8GAA8G;IAC9G,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8GAA8G;IAC9G,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;6BAC6B,sCAAsC,EAAE;;AAErE;+BAC+B,uCAAuC,EAAE;;AAExE;8BAC8B,sCAAsC,EAAE;;AAEtE;0BAC0B,sCAAsC,EAAE;;AAElE;6BAC6B,qCAAqC,EAAE;;AAEpE;6BAC6B,qCAAqC,EAAE;;AAEpE;2BAC2B,qCAAqC,EAAE;;AAElE;0BAC0B,oCAAoC,EAAE;;AAEhE;2BAC2B,uCAAuC,EAAE;;AAEpE;6BAC6B,uCAAuC,EAAE;;AAEtE;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;IAGI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,oHAAoH;IACpH,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,8GAA8G;IAC9G,uCAAuC;AAC3C;;AAEA;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,8GAA8G;IAC9G,0CAA0C;IAC1C,oDAAoD;AACxD;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,8GAA8G;IAC9G,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;uCAGuC,oCAAoC,EAAE;;AAE7E;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;;IAII,uBAAuB;IACvB,oHAAoH;IACpH,cAAc;AAClB;;AAEA,iBAAiB,yBAAyB,EAAE;;AAE5C,wBAAwB,yBAAyB,EAAE;;AAEnD;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uHAAuH;IACvH,uCAAuC;AAC3C;;AAEA,kCAAkC,oCAAoC,EAAE;;AAExE,mEAAmE,8CAA8C,EAAE;;AAEnH,mEAAmE,+CAA+C,EAAE;;AAEpH;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,qBAAqB,sCAAsC,EAAE;;AAE7D,wBAAwB,sCAAsC,EAAE;;AAEhE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,oBAAoB,iDAAiD,EAAE;;AAEvE,6CAA6C,mBAAmB,EAAE;;AAElE,6CAA6C,oCAAoC,EAAE;;AAEnF,mDAAmD,mBAAmB,EAAE;;AAExE;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;IAC9C,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,sBAAsB,yBAAyB,EAAE;;AAEjD;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,oCAAoC,cAAc,EAAE;;AAEpD,wCAAwC,4EAA4E,EAAE;;AAEtH;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,uCAAuC,2CAA2C,EAAE;;AAEpF,kBAAkB,sCAAsC,EAAE;;AAE1D;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;uBACuB,sCAAsC,EAAE;;AAE/D,mBAAmB,oCAAoC,EAAE;;AAEzD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,qCAAqC,cAAc,EAAE;;AAErD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,oCAAoC,cAAc,EAAE;;AAEpD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,gCAAgC,cAAc,EAAE;;AAEhD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,iCAAiC,cAAc,EAAE;;AAEjD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,gCAAgC,cAAc,EAAE;;AAEhD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,iCAAiC,cAAc,EAAE;;AAEjD;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD,kFAAkF,2CAA2C,EAAE;;AAE/H;IACI,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;oDACoD,2CAA2C,EAAE;;AAEjG;oDACoD,2CAA2C,EAAE;;AAEjG;oDACoD,8CAA8C,EAAE;;AAEpG;oDACoD,2CAA2C,EAAE;;AAEjG;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA,uBAAuB,2CAA2C,EAAE;;AAEpE;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;oEAEoE,0CAA0C,EAAE;;AAEhH,+EAA+E,YAAY,EAAE;;AAE7F;IACI,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;;sEAEsE,0CAA0C,EAAE;;AAElH,iFAAiF,YAAY,EAAE;;AAE/F;IACI,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;;qEAEqE,0CAA0C,EAAE;;AAEjH,gFAAgF,YAAY,EAAE;;AAE9F;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;;iEAEiE,0CAA0C,EAAE;;AAE7G,4EAA4E,YAAY,EAAE;;AAE1F;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;oEAEoE,0CAA0C,EAAE;;AAEhH,+EAA+E,YAAY,EAAE;;AAE7F;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;oEAEoE,sCAAsC,EAAE;;AAE5G,+EAA+E,YAAY,EAAE;;AAE7F;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;;kEAEkE,0CAA0C,EAAE;;AAE9G,6EAA6E,YAAY,EAAE;;AAE3F;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;iEAEiE,0CAA0C,EAAE;;AAE7G,4EAA4E,YAAY,EAAE;;AAE1F;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;kEAEkE,uCAAuC,EAAE;;AAE3G,6EAA6E,YAAY,EAAE;;AAE3F;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;oEAEoE,uCAAuC,EAAE;;AAE7G,+EAA+E,YAAY,EAAE;;AAE7F;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;8CAE8C,2CAA2C,EAAE;;AAE3F,8EAA8E,gCAAgC,EAAE;;AAEhH,gFAAgF,cAAc,EAAE;;AAEhG,+EAA+E,iCAAiC,EAAE;;AAElH,2EAA2E,6BAA6B,EAAE;;AAE1G,8EAA8E,gCAAgC,EAAE;;AAEhH,8EAA8E,gCAAgC,EAAE;;AAEhH,4EAA4E,8BAA8B,EAAE;;AAE5G,2EAA2E,gCAAgC,EAAE;;AAE7G,4EAA4E,cAAc,EAAE;;AAE5F,8EAA8E,cAAc,EAAE;;AAE9F,2BAA2B,6BAA6B,EAAE;;AAE1D,8DAA8D,yBAAyB,EAAE;;AAEzF;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,qDAAqD,2CAA2C,EAAE;;AAElG,qBAAqB,kCAAkC,EAAE;;AAEzD,6DAA6D,wCAAwC,EAAE;;AAEvG,+DAA+D,qDAAqD,EAAE;;AAEtH,0BAA0B,kCAAkC,EAAE;;AAE9D,uEAAuE,wCAAwC,EAAE;;AAEjH,yEAAyE,qDAAqD,EAAE;;AAEhI,6CAA6C,kCAAkC,EAAE;;AAEjF;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,yGAAyG,+CAA+C,EAAE;;AAE1J;IACI,gDAAgD;IAChD,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,8CAA8C;IAC9C,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,gDAAgD;IAChD,8CAA8C;AAClD;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,8CAA8C;IAC9C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;IAChD,8CAA8C;AAClD;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;;IAEI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,4EAA4E;IAC5E,uCAAuC;AAC3C;;AAEA;;;IAGI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;;IAEI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;IAGI,8CAA8C;IAC9C,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA,aAAa,kCAAkC,EAAE;;AAEjD,gGAAgG,yBAAyB,EAAE;;AAE3H,sGAAsG,sCAAsC,EAAE;;AAE9I;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,sCAAsC,mCAAmC,EAAE;;AAE3E;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,0GAA0G,yBAAyB,EAAE;;AAErI;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA,gHAAgH,yBAAyB,EAAE;;AAE3I;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,mDAAmD,gCAAgC,EAAE;;AAErF,yCAAyC,8BAA8B,EAAE;;AAEzE,yCAAyC,8BAA8B,EAAE;;AAEzE,oGAAoG,8BAA8B,EAAE;;AAEpI,4CAA4C,sCAAsC,EAAE;;AAEpF;yDACyD,mCAAmC,EAAE;;AAE9F,oCAAoC,oCAAoC,EAAE;;AAE1E;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,oCAAoC,gCAAgC,EAAE;;AAEtE;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,6FAA6F,qDAAqD,EAAE;;AAEpJ,wDAAwD,2CAA2C,EAAE;;AAErG;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;2CAE2C,sBAAsB,EAAE;;AAEnE;6DAC6D,gCAAgC,EAAE;;AAE/F;gEACgE,6BAA6B,EAAE;;AAE/F;8DAC8D,+BAA+B,EAAE;;AAE/F;+DAC+D,8BAA8B,EAAE;;AAE/F,uDAAuD,sBAAsB,EAAE;;AAE/E;;IAEI,+CAA+C;IAC/C,aAAa;AACjB;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,4BAA4B,qDAAqD,EAAE;;AAEnF;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,aAAa;AACjB;;AAEA,6DAA6D,qCAAqC,EAAE;;AAEpG,qCAAqC,qDAAqD,EAAE;;AAE5F,oBAAoB,gCAAgC,EAAE;;AAEtD,wBAAwB,oCAAoC,EAAE;;AAE9D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;IAEI,gDAAgD;IAChD,kCAAkC;AACtC;;AAEA;;;mEAGmE,kCAAkC,EAAE;;AAEvG;;;2DAG2D,yBAAyB,EAAE;;AAEtF;;;;;6DAK6D,qDAAqD,EAAE;;AAEpH;;IAEI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;;oFAGoF,cAAc,EAAE;;AAEpG;;;4EAG4E,yBAAyB,EAAE;;AAEvG;;;;;;;2EAO2E,yBAAyB,EAAE;;AAEtG;;;;;;;;;;;6EAW6E,qDAAqD,EAAE;;AAEpI;;;;IAII,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;;;;;;4FAO4F,yBAAyB,EAAE;;AAEvH;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;;;;IAII,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;;;IAGI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA,oBAAoB,yBAAyB,EAAE;;AAE/C,gBAAgB,yBAAyB,EAAE;;AAE3C;;qCAEqC,2CAA2C,EAAE;;AAElF;IACI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,wEAAwE,0BAA0B,EAAE;;AAEpG,wEAAwE,2CAA2C,EAAE;;AAErH,6DAA6D,gCAAgC,EAAE;;AAE/F;;;6EAG6E,cAAc,EAAE;;AAE7F;gFACgF,oCAAoC,EAAE;;AAEtH;;;;;;0EAM0E,yBAAyB,EAAE;;AAErG;;;;;;;yDAOyD,kCAAkC,EAAE;;AAE7F;;;;;;;;;;;;;;;0EAe0E,gCAAgC,EAAE;;AAE5G;IACI,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;iCAGiC,sCAAsC,EAAE;;AAEzE,iBAAiB,2CAA2C,EAAE;;AAE9D;oDACoD,2CAA2C,EAAE;;AAEjG;;;IAGI,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;;;;;;;;8BAQ8B,+CAA+C,EAAE;;AAE/E;sBACsB,2CAA2C,EAAE;;AAEnE;;;oCAGoC,sCAAsC,EAAE;;AAE5E,0CAA0C,4BAA4B,EAAE;;AAExE;+CAC+C,sCAAsC,EAAE;;AAEvF,yDAAyD,yBAAyB,EAAE;;AAEpF,sDAAsD,yBAAyB,EAAE;;AAEjF,4DAA4D,yBAAyB,EAAE;;AAEvF;oEACoE,yBAAyB,EAAE;;AAE/F;;oCAEoC,8BAA8B,EAAE;;AAEpE,kBAAkB,qBAAqB,EAAE;;AAEzC;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;+BAE+B,gCAAgC,EAAE;;AAEjE;;;;;;+DAM+D,8CAA8C,EAAE;;AAE/G;;;IAGI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;;IAEI,gDAAgD;IAChD,2CAA2C;IAC3C,4CAA4C;IAC5C,kCAAkC;AACtC;;AAEA,uCAAuC,2CAA2C,EAAE;;AAEpF;IACI,gDAAgD;IAChD,sCAAsC;IACtC,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,gDAAgD;IAChD,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA;yCACyC,yBAAyB,EAAE;;AAEpE;;0DAE0D,yBAAyB,EAAE;;AAErF;;gEAEgE,yBAAyB,EAAE;;AAE3F;;;iDAGiD,yBAAyB,EAAE;;AAE5E;;;;;wEAKwE,yBAAyB,EAAE;;AAEnG;IACI,gDAAgD;IAChD,2CAA2C;IAC3C,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA,2FAA2F,yBAAyB,EAAE;;AAEtH;IACI,gDAAgD;IAChD,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA;oDACoD,yBAAyB,EAAE;;AAE/E;yCACyC,yBAAyB,EAAE;;AAEpE;;;qDAGqD,yBAAyB,EAAE;;AAEhF;;4DAE4D,yBAAyB,EAAE;;AAEvF;;;;;;;yDAOyD,yBAAyB,EAAE;;AAEpF;;;;;;;;;;;sEAWsE,yBAAyB,EAAE;;AAEjG,yCAAyC,2CAA2C,EAAE;;AAEtF;uDACuD,yBAAyB,EAAE;;AAElF;wCACwC,2CAA2C,EAAE;;AAErF;sDACsD,2CAA2C,EAAE;;AAEnG;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,uCAAuC,qBAAqB,EAAE;;AAE9D;IACI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;mCACmC,qDAAqD,EAAE;;AAE1F,yBAAyB,qBAAqB,EAAE;;AAEhD;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA,iIAAiI,qDAAqD,EAAE;;AAExL;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,oBAAoB,sCAAsC,EAAE;;AAE5D;IACI,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,yCAAyC,qDAAqD,EAAE;;AAEhG,0CAA0C,0CAA0C,EAAE;;AAEtF;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;IAGI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,gBAAgB,cAAc,EAAE;;AAEhC,gBAAgB,cAAc,EAAE;;AAEhC,gBAAgB,cAAc,EAAE;;AAEhC,kBAAkB,UAAU,EAAE;;AAE9B,iBAAiB,cAAc,EAAE;;AAEjC,wBAAwB,yBAAyB,EAAE;;AAEnD;IACI,gDAAgD;IAChD,uCAAuC;AAC3C;;AAEA,6BAA6B,gDAAgD,EAAE;;AAE/E;sCACsC,0CAA0C,EAAE;;AAElF;IACI,0CAA0C;IAC1C,2CAA2C;IAC3C,yDAAyD;AAC7D;;AAEA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,qDAAqD;AACzD;;AAEA,qCAAqC,mGAAmG,EAAE;;AAE1I,sCAAsC,mGAAmG,EAAE;;AAE3I,8CAA8C,sGAAsG,EAAE;;AAEtJ;IACI,0CAA0C;IAC1C,uCAAuC;IACvC,qDAAqD;AACzD;;AAEA,oCAAoC,oCAAoC,EAAE;;AAE1E;;uCAEuC,2CAA2C,EAAE;;AAEpF,oCAAoC,yFAAyF,EAAE;;AAE/H,WAAW,qFAAqF,EAAE;;AAElG,iCAAiC,uCAAuC,EAAE;;AAE1E;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,6DAA6D;IAC7D,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,qCAAqC,sCAAsC,EAAE;;AAE7E,iJAAiJ,iDAAiD,EAAE;;AAEpM;kFACkF,cAAc,EAAE;;AAElG,sDAAsD,wCAAwC,EAAE;;AAEhG;IACI,2CAA2C;IAC3C,uCAAuC;AAC3C;;AAEA,qCAAqC,oCAAoC,EAAE;;AAE3E;;IAEI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;;;IAGI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;+DAE+D,yFAAyF,EAAE;;AAE1J;;sCAEsC,qFAAqF,EAAE;;AAE7H;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;IAGI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,0BAA0B,qBAAqB,EAAE;;AAEjD,yEAAyE,2BAA2B,EAAE;;AAEtG;0DAC0D,4BAA4B,EAAE;;AAExF;;IAEI,yBAAyB;IACzB,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;;;;qDAKqD,uBAAuB,EAAE;;AAE9E;;;;;4CAK4C,qDAAqD,EAAE;;AAEnG;wDACwD,0CAA0C,EAAE;;AAEpG;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,mCAAmC,kCAAkC,EAAE;;AAEvE,2DAA2D,sCAAsC,EAAE;;AAEnG;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,6BAA6B,kCAAkC,EAAE;;AAEjE,oCAAoC,sCAAsC,EAAE;;AAE5E,0DAA0D,sCAAsC,EAAE;;AAElG,iGAAiG,4CAA4C,EAAE;;AAE/I,wDAAwD,2CAA2C,EAAE;;AAErG,mJAAmJ,4CAA4C,EAAE;;AAEjM,kHAAkH,2CAA2C,EAAE;;AAE/J;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,iBAAiB,sCAAsC,EAAE;;AAEzD;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,4BAA4B,oCAAoC,EAAE;;AAElE,SAAS,2CAA2C,EAAE;;AAEtD;;;kDAGkD,sCAAsC,EAAE;;AAE1F,kBAAkB,yBAAyB,EAAE;;AAE7C;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;;uBAEuB,cAAc,EAAE;;AAEvC,uBAAuB,gCAAgC,EAAE;;AAEzD,uBAAuB,8BAA8B,EAAE;;AAEvD,uBAAuB,gCAAgC,EAAE;;AAEzD,gEAAgE,sCAAsC,EAAE;;AAExG;mCACmC,2CAA2C,EAAE;;AAEhF;yCACyC,2CAA2C,EAAE;;AAEtF;;6CAE6C,2CAA2C,EAAE;;AAE1F,YAAY,kCAAkC,EAAE;;AAEhD,oCAAoC,gCAAgC,EAAE;;AAEtE,uCAAuC,oCAAoC,EAAE;;AAE7E;;;qFAGqF,yBAAyB,EAAE;;AAEhH;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,4BAA4B,2CAA2C,EAAE;;AAEzE,wDAAwD,cAAc,EAAE;;AAExE;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;AAClB;;AAEA,sCAAsC,cAAc,EAAE;;AAEtD;IACI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;oCACoC,qBAAqB,EAAE;;AAE3D,6BAA6B,kCAAkC,EAAE;;AAEjE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,2BAA2B,kCAAkC,EAAE;;AAE/D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,kCAAkC,gCAAgC,EAAE;;AAEpE,uFAAuF,cAAc,EAAE;;AAEvG,uFAAuF,cAAc,EAAE;;AAEvG;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA,2DAA2D,qBAAqB,EAAE;;AAElF;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA,0DAA0D,cAAc,EAAE;;AAE1E;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,4DAA4D,sBAAsB,EAAE;;AAEpF;+BAC+B,2CAA2C,EAAE;;AAE5E;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mGAAmG,yBAAyB,EAAE;;AAE9H,qEAAqE,yBAAyB,EAAE;;AAEhG,0DAA0D,sCAAsC,EAAE;;AAElG;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,4BAA4B,mBAAmB,EAAE;;AAEjD;IACI,+CAA+C;IAC/C,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA,wCAAwC,yBAAyB,EAAE;;AAEnE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,yBAAyB,yBAAyB,EAAE;;AAEpD,wBAAwB,uRAAuR,EAAE;;AAEjT,6BAA6B,gDAAgD,EAAE;;AAE/E,sBAAsB,mBAAmB,EAAE;;AAE3C,8BAA8B,oCAAoC,EAAE;;AAEpE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA,+DAA+D,qCAAqC,EAAE;;AAEtG,kBAAkB,gBAAgB,EAAE;;AAEpC;oCACoC,6BAA6B,EAAE;;AAEnE,2BAA2B,4CAA4C,EAAE;;AAEzE,sBAAsB,yBAAyB,EAAE;;AAEjD;;IAEI,gDAAgD;IAChD,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mCAAmC,kIAAkI,EAAE;;AAEvK,oCAAoC,2CAA2C,EAAE;;AAEjF;IACI,+CAA+C;IAC/C,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,kBAAkB,WAAW,EAAE;;AAE/B,iCAAiC,cAAc,EAAE;;AAEjD,kCAAkC,cAAc,EAAE;;AAElD,2BAA2B,kCAAkC,EAAE;;AAE/D,2CAA2C,8BAA8B,EAAE;;AAE3E,4CAA4C,gCAAgC,EAAE;;AAE9E,mCAAmC,cAAc,EAAE;;AAEnD,4DAA4D,oCAAoC,EAAE;;AAElG;IACI,yBAAyB;IACzB,yCAAyC;IACzC,YAAY;AAChB;;AAEA,gCAAgC,yBAAyB,EAAE;;AAE3D,iCAAiC,yBAAyB,EAAE;;AAE5D,kCAAkC,6CAA6C,EAAE;;AAEjF,mCAAmC,yCAAyC,EAAE;;AAE9E,oCAAoC,2CAA2C,EAAE;;AAEjF;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA,mDAAmD,+CAA+C,EAAE;;AAEpG,gBAAgB,WAAW,EAAE;;AAE7B,iCAAiC,oCAAoC,EAAE;;AAEvE;IACI,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA,mCAAmC,2CAA2C,EAAE;;AAEhF,uCAAuC,2CAA2C,EAAE;;AAEpF,iBAAiB,mIAAmI,EAAE;;AAEtJ,qCAAqC,qBAAqB,EAAE;;AAE5D,iCAAiC,cAAc,EAAE;;AAEjD,uBAAuB,mGAAmG,EAAE;;AAE5H,+BAA+B,yCAAyC,EAAE;;AAE1E,4BAA4B,yCAAyC,EAAE;;AAEvE,qBAAqB,2CAA2C,EAAE;;AAElE,sCAAsC,yBAAyB,EAAE;;AAEjE,iCAAiC,2CAA2C,EAAE;;AAE9E,mCAAmC,yCAAyC,EAAE;;AAE9E;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,kBAAkB,mBAAmB,EAAE;;AAEvC,4CAA4C,2BAA2B,EAAE;;AAEzE,6CAA6C,0BAA0B,EAAE;;AAEzE,4CAA4C,yBAAyB,EAAE;;AAEvE;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,sBAAsB,2CAA2C,EAAE;;AAEnE,2BAA2B,gDAAgD,EAAE;;AAE7E;+BAC+B,yBAAyB,EAAE;;AAE1D;8BAC8B,yBAAyB,EAAE;;AAEzD;yDACyD,0CAA0C,EAAE;;AAErG;0CAC0C,gDAAgD,EAAE;;AAE5F;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,sCAAsC;AAC1C;;AAEA,mBAAmB,YAAY,EAAE;;AAEjC,mBAAmB,yCAAyC,EAAE;;AAE9D;8BAC8B,uCAAuC,EAAE;;AAEvE,iDAAiD,sCAAsC,EAAE;;AAEzF;;;;IAII,8CAA8C;IAC9C,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;;;;IAII,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,mEAAmE,0CAA0C,EAAE;;AAE/G;4FAC4F,gDAAgD,EAAE;;AAE9I,yCAAyC,2CAA2C,EAAE;;AAEtF,2DAA2D,uBAAuB,EAAE;;AAEpF;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA,4CAA4C,YAAY,EAAE;;AAE1D;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,uBAAuB,oCAAoC,EAAE;;AAE7D;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA,sBAAsB,gCAAgC,EAAE;;AAExD,4BAA4B,wCAAwC,EAAE;;AAEtE;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,2CAA2C;IAC3C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,mFAAmF;IACnF,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA,iCAAiC,2CAA2C,EAAE;;AAE9E;IACI,gDAAgD;IAChD,uCAAuC;AAC3C;;AAEA,4CAA4C,gCAAgC,EAAE;;AAE9E,qEAAqE,mBAAmB,EAAE;;AAE1F,qEAAqE,mBAAmB,EAAE;;AAE1F,2EAA2E,mBAAmB,EAAE;;AAEhG,+BAA+B,kCAAkC,EAAE;;AAEnE;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,mDAAmD;IACnD,+CAA+C;AACnD;;AAEA,iDAAiD,2CAA2C,EAAE;;AAE9F,0DAA0D,6CAA6C,EAAE;;AAEzG;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,0BAA0B,yBAAyB,EAAE;;AAErD;IACI,uBAAuB;IACvB,sCAAsC;IACtC,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA,oCAAoC,yBAAyB,EAAE;;AAE/D,sBAAsB,yBAAyB,EAAE;;AAEjD;;IAEI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;yDAGyD,oCAAoC,EAAE;;AAE/F;;;qDAGqD,yBAAyB,EAAE;;AAEhF;;;0DAG0D,0CAA0C,EAAE;;AAEtG;2BAC2B,aAAa,EAAE;;AAE1C;;IAEI,kCAAkC;IAClC,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;;mCAEmC,YAAY,EAAE;;AAEjD;;mDAEmD,yCAAyC,EAAE;;AAE9F;;mCAEmC,YAAY,EAAE;;AAEjD;;IAEI,mDAAmD;IACnD,+CAA+C;AACnD;;AAEA;;IAEI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;;8CAE8C,yCAAyC,EAAE;;AAEzF;4CAC4C,yCAAyC,EAAE;;AAEvF,qCAAqC,6CAA6C,EAAE;;AAEpF,iBAAiB,2CAA2C,EAAE;;AAE9D,0BAA0B,uBAAuB,EAAE;;AAEnD,kBAAkB,2CAA2C,EAAE;;AAE/D,2BAA2B,uBAAuB,EAAE;;AAEpD,eAAe,2CAA2C,EAAE;;AAE5D,qBAAqB,gDAAgD,EAAE;;AAEvE,wBAAwB,mBAAmB,EAAE;;AAE7C,4BAA4B,2CAA2C,EAAE;;AAEzE,4BAA4B,yBAAyB,EAAE;;AAEvD,2BAA2B,8CAA8C,EAAE;;AAE3E,2BAA2B,yBAAyB,EAAE;;AAEtD,8BAA8B,+CAA+C,EAAE;;AAE/E,8BAA8B,yBAAyB,EAAE;;AAEzD,kBAAkB,2CAA2C,EAAE;;AAE/D,eAAe,wCAAwC,EAAE;;AAEzD,kBAAkB,2CAA2C,EAAE;;AAE/D,gBAAgB,yCAAyC,EAAE;;AAE3D,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,4CAA4C,EAAE;;AAEjE,mBAAmB,yBAAyB,EAAE;;AAE9C,mBAAmB,yBAAyB,EAAE;;AAE9C,mBAAmB,yBAAyB,EAAE;;AAE9C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,yBAAyB,EAAE;;AAE/C,wBAAwB,2CAA2C,EAAE;;AAErE,sBAAsB,yBAAyB,EAAE;;AAEjD,yBAAyB,0CAA0C,EAAE;;AAErE,4BAA4B,2CAA2C,EAAE;;AAEzE,4BAA4B,2CAA2C,EAAE;;AAEzE,iCAAiC,0CAA0C,EAAE;;AAE7E,6BAA6B,0CAA0C,EAAE;;AAEzE,4BAA4B,0CAA0C,EAAE;;AAExE,qCAAqC,0CAA0C,EAAE;;AAEjF,sCAAsC,0CAA0C,EAAE;;AAElF;;;IAGI,6BAA6B;IAC7B,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;;yBAEyB,uBAAuB,EAAE;;AAElD,mBAAmB,kCAAkC,EAAE;;AAEvD,2BAA2B,cAAc,EAAE;;AAE3C;;IAEI,yBAAyB;IACzB,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,qDAAqD;AACzD;;AAEA,kBAAkB,6BAA6B,EAAE;;AAEjD;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,gBAAgB,6BAA6B,EAAE;;AAE/C,UAAU,gDAAgD,EAAE;;AAE5D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,qBAAqB,cAAc,EAAE;;AAErC,+BAA+B,cAAc,EAAE;;AAE/C,mCAAmC,mCAAmC,EAAE;;AAExE;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA,mBAAmB,gCAAgC,EAAE;;AAErD,wBAAwB,oCAAoC,EAAE;;AAE9D;IACI,gDAAgD;IAChD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,yDAAyD,2CAA2C,EAAE;;AAEtG;IACI,2CAA2C;IAC3C,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;;mDAEmD,2CAA2C,EAAE;;AAEhG,kCAAkC,oCAAoC,EAAE;;AAExE;qBACqB,cAAc,EAAE","sourcesContent":["/* ReSharper disable once CssBrowserCompatibility */\r\n\r\n.k-text-selection ::selection {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-block,\r\n.k-panel {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-block > .k-header,\r\n.k-panel > .k-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-content {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-hr { border-color: var(--dark-color-border); }\r\n\r\n.k-dirty { border-color: var(--dark-color-error) var(--dark-color-error) transparent transparent; }\r\n\r\n[dir=\"rtl\"] .k-dirty,\r\n.k-rtl .k-dirty { border-color: transparent transparent var(--dark-color-error) var(--dark-color-error); }\r\n\r\n.k-placeholder-line { background-color: rgba(0, 0, 0, 0.1); }\r\n\r\n.k-drop-hint-start,\r\n.k-drop-hint-end { border-color: transparent; }\r\n\r\n.k-drop-hint-line { background-color: var(--dark-color-primary); }\r\n\r\n.k-drop-hint-h .k-drop-hint-start { border-left-color: var(--dark-color-primary); }\r\n\r\n.k-drop-hint-h .k-drop-hint-end { border-right-color: var(--dark-color-primary); }\r\n\r\n.k-drop-hint-v .k-drop-hint-start { border-top-color: var(--dark-color-primary); }\r\n\r\n.k-drop-hint-v .k-drop-hint-end { border-bottom-color: var(--dark-color-primary); }\r\n\r\n.k-drag-clue {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: #207afd;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-reorder-cue::before, .k-reorder-cue::after { border: 3px solid transparent; }\r\n\r\n.k-loading-color { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-i-loading { background-color: transparent; }\r\n\r\n.k-i-loading::before,\r\n.k-i-loading::after,\r\n.k-loading-image::before,\r\n.k-loading-image::after {\r\n    background-color: transparent;\r\n    border-bottom-color: transparent;\r\n    border-top-color: transparent;\r\n}\r\n\r\n.k-i-loading::before,\r\n.k-loading-image::before {\r\n    border-color: currentColor;\r\n    border-right-color: transparent !important;\r\n}\r\n\r\n.k-touch-scrollbar {\r\n    background-color: #858585;\r\n    border: 1px solid #8a8a8a;\r\n}\r\n\r\n.k-marquee-color {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: #207afd;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-marquee-text { color: var(--dark-color-base-text); }\r\n\r\n.k-pre > .k-code {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n}\r\n\r\n.k-body {\r\n    background-color: var(--dark-color-body-bg);\r\n    color: var(--dark-color-body-text);\r\n}\r\n\r\n.k-pre,\r\n.k-code {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-border-primary { border-color: var(--dark-color-primary) !important; }\r\n\r\n.k-border-secondary { border-color: var(--dark-color-secondary) !important; }\r\n\r\n.k-border-tertiary { border-color: var(--dark-color-tertiary) !important; }\r\n\r\n.k-border-info { border-color: var(--dark-color-info) !important; }\r\n\r\n.k-border-success { border-color: var(--dark-color-success) !important; }\r\n\r\n.k-border-warning { border-color: var(--dark-color-warning) !important; }\r\n\r\n.k-border-error { border-color: var(--dark-color-error) !important; }\r\n\r\n.k-border-dark { border-color: var(--dark-color-base-bg) !important; }\r\n\r\n.k-border-light { border-color: #f8f9fa !important; }\r\n\r\n.k-border-inverse { border-color: #f8f9fa !important; }\r\n\r\n.k-text-base,\r\n.k-color-base { color: var(--dark-color-base-text); }\r\n\r\n.k-color-inherit { color: inherit; }\r\n\r\n.k-text-primary,\r\n.k-color-primary { color: var(--dark-color-primary) !important; }\r\n\r\n.k-text-secondary,\r\n.k-color-secondary { color: var(--dark-color-secondary) !important; }\r\n\r\n.k-text-tertiary,\r\n.k-color-tertiary { color: var(--dark-color-tertiary) !important; }\r\n\r\n.k-text-info,\r\n.k-color-info { color: var(--dark-color-info) !important; }\r\n\r\n.k-text-success,\r\n.k-color-success { color: var(--dark-color-success) !important; }\r\n\r\n.k-text-warning,\r\n.k-color-warning { color: var(--dark-color-warning) !important; }\r\n\r\n.k-text-error,\r\n.k-color-error { color: var(--dark-color-error) !important; }\r\n\r\n.k-text-dark,\r\n.k-color-dark { color: var(--dark-color-base-bg) !important; }\r\n\r\n.k-text-light,\r\n.k-color-light { color: #f8f9fa !important; }\r\n\r\n.k-text-inverse,\r\n.k-color-inverse { color: #f8f9fa !important; }\r\n\r\n.k-bg-primary { background-color: var(--dark-color-primary) !important; }\r\n\r\n.k-bg-secondary { background-color: var(--dark-color-secondary) !important; }\r\n\r\n.k-bg-tertiary { background-color: var(--dark-color-tertiary) !important; }\r\n\r\n.k-bg-info { background-color: var(--dark-color-info) !important; }\r\n\r\n.k-bg-success { background-color: var(--dark-color-success) !important; }\r\n\r\n.k-bg-warning { background-color: var(--dark-color-warning) !important; }\r\n\r\n.k-bg-error { background-color: var(--dark-color-error) !important; }\r\n\r\n.k-bg-dark { background-color: var(--dark-color-base-bg) !important; }\r\n\r\n.k-bg-light { background-color: #f8f9fa !important; }\r\n\r\n.k-bg-inverse { background-color: #f8f9fa !important; }\r\n\r\n.k-state-primary {\r\n    background-color: #cfe2ff;\r\n    border-color: #bbd6fe;\r\n    color: #073984;\r\n}\r\n\r\n.k-state-secondary {\r\n    background-color: #e2e3e5;\r\n    border-color: #d6d8db;\r\n    color: #383d41;\r\n}\r\n\r\n.k-state-tertiary {\r\n    background-color: #e2d9f3;\r\n    border-color: #d7caee;\r\n    color: #3a2264;\r\n}\r\n\r\n.k-state-info {\r\n    background-color: #cff4fc;\r\n    border-color: #bbf0fb;\r\n    color: #07697d;\r\n}\r\n\r\n.k-state-success {\r\n    background-color: #d1e7dd;\r\n    border-color: #bfddcf;\r\n    color: #0d462c;\r\n}\r\n\r\n.k-state-warning {\r\n    background-color: #fff3cd;\r\n    border-color: #ffeeba;\r\n    color: #856404;\r\n}\r\n\r\n.k-state-error {\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    color: #721c24;\r\n}\r\n\r\n.k-state-dark {\r\n    background-color: #d3d3d4;\r\n    border-color: #c1c2c3;\r\n    color: #111315;\r\n}\r\n\r\n.k-state-light {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-state-inverse {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-info-colored {\r\n    background-color: #f0f9ff;\r\n    border-color: #d0d9df;\r\n    color: #50607f;\r\n}\r\n\r\n.k-success-colored {\r\n    background-color: #f0fff0;\r\n    border-color: #d0dfd0;\r\n    color: #507f50;\r\n}\r\n\r\n.k-error-colored {\r\n    background-color: #fff0f0;\r\n    border-color: #dfd0d0;\r\n    color: #7f5050;\r\n}\r\n\r\n.k-inset { box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.03), inset 0 4px 5px 0 rgba(0, 0, 0, 0.04); }\r\n\r\n.k-messagebox-primary {\r\n    background-color: #cfe2ff;\r\n    border-color: #bbd6fe;\r\n    color: #073984;\r\n}\r\n\r\n.k-messagebox-secondary {\r\n    background-color: #e2e3e5;\r\n    border-color: #d6d8db;\r\n    color: #383d41;\r\n}\r\n\r\n.k-messagebox-tertiary {\r\n    background-color: #e2d9f3;\r\n    border-color: #d7caee;\r\n    color: #3a2264;\r\n}\r\n\r\n.k-messagebox-info {\r\n    background-color: #cff4fc;\r\n    border-color: #bbf0fb;\r\n    color: #07697d;\r\n}\r\n\r\n.k-messagebox-success {\r\n    background-color: #d1e7dd;\r\n    border-color: #bfddcf;\r\n    color: #0d462c;\r\n}\r\n\r\n.k-messagebox-warning {\r\n    background-color: #fff3cd;\r\n    border-color: #ffeeba;\r\n    color: #856404;\r\n}\r\n\r\n.k-messagebox-error {\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    color: #721c24;\r\n}\r\n\r\n.k-messagebox-dark {\r\n    background-color: #d3d3d4;\r\n    border-color: #c1c2c3;\r\n    color: #111315;\r\n}\r\n\r\n.k-messagebox-light {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-messagebox-inverse {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-checkbox {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-secondary);\r\n}\r\n\r\n.k-checkbox:focus,\r\n.k-checkbox.k-focus {\r\n    border-color: #07377f;\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-checkbox:indeterminate,\r\n.k-checkbox.k-indeterminate {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-checkbox:checked,\r\n.k-checkbox.k-checked {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-checkbox:checked:focus,\r\n.k-checkbox.k-checked.k-focus {\r\n    border-color: var(--dark-color-primary);\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-checkbox.k-invalid { border-color: var(--dark-color-error); }\r\n\r\n.k-checkbox.k-invalid + .k-checkbox-label { color: var(--dark-color-error); }\r\n\r\n.k-checkbox-wrap .k-ripple-blob { color: var(--dark-color-primary); }\r\n\r\n.k-ripple-container .k-checkbox::after { background: var(--dark-color-primary); }\r\n\r\n.k-list {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-list-group-sticky-header { border-color: inherit; }\r\n\r\n.k-list-item:hover, .k-list-optionlabel:hover, .k-list-item.k-hover, .k-hover.k-list-optionlabel {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-list-item:focus, .k-list-optionlabel:focus, .k-list-item.k-focus, .k-focus.k-list-optionlabel { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-list-item.k-selected, .k-selected.k-list-optionlabel {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {\r\n    background-color: #0c65e9;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-list-group-item { border-color: inherit; }\r\n\r\n.k-list-item-group-label {\r\n    background-color: var(--dark-color-base-text);\r\n    color: #000000;\r\n}\r\n\r\n.k-no-data, .k-nodata { color: var(--dark-color-subtle-text); }\r\n\r\n.k-listgroup {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-overlay { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-overlay-primary { background-color: var(--dark-color-primary); }\r\n\r\n.k-overlay-secondary { background-color: var(--dark-color-secondary); }\r\n\r\n.k-overlay-tertiary { background-color: var(--dark-color-tertiary); }\r\n\r\n.k-overlay-info { background-color: var(--dark-color-info); }\r\n\r\n.k-overlay-success { background-color: var(--dark-color-success); }\r\n\r\n.k-overlay-warning { background-color: var(--dark-color-warning); }\r\n\r\n.k-overlay-error { background-color: var(--dark-color-error); }\r\n\r\n.k-overlay-dark { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-overlay-light { background-color: #f8f9fa; }\r\n\r\n.k-overlay-inverse { background-color: #f8f9fa; }\r\n\r\n.k-shadow { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }\r\n\r\n.k-popup {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-badge-border-cutout { box-shadow: 0 0 0 2px #000000; }\r\n\r\n.k-badge-solid.k-badge-primary {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-info {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-success {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-warning {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-badge-solid.k-badge-error {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-badge-solid.k-badge-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-badge-solid.k-badge-light {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-badge-solid.k-badge-inverse {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-badge-outline {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: currentColor;\r\n}\r\n\r\n.k-badge-outline.k-badge-primary { color: var(--dark-color-primary); }\r\n\r\n.k-badge-outline.k-badge-secondary { color: var(--dark-color-secondary); }\r\n\r\n.k-badge-outline.k-badge-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-badge-outline.k-badge-info { color: var(--dark-color-info); }\r\n\r\n.k-badge-outline.k-badge-success { color: var(--dark-color-success); }\r\n\r\n.k-badge-outline.k-badge-warning { color: var(--dark-color-warning); }\r\n\r\n.k-badge-outline.k-badge-error { color: var(--dark-color-error); }\r\n\r\n.k-badge-outline.k-badge-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-badge-outline.k-badge-light { color: #f8f9fa; }\r\n\r\n.k-badge-outline.k-badge-inverse { color: #f8f9fa; }\r\n\r\n.k-button-flat { border-color: transparent !important; }\r\n\r\n.k-button-solid-base {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-button-solid-base:hover, .k-button-solid-base.k-hover {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n}\r\n\r\n.k-button-solid-base:focus, .k-button-solid-base.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-button-solid-base:active, .k-button-solid-base.k-active {\r\n    background-color: #4b545c;\r\n    border-color: #515a63;\r\n}\r\n\r\n.k-button-solid-base.k-selected {\r\n    background-color: #408cfd;\r\n    border-color: #4c94fe;\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-primary {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {\r\n    background-color: #3385fd;\r\n    border-color: #408cfd;\r\n}\r\n\r\n.k-button-solid-primary:focus, .k-button-solid-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }\r\n\r\n.k-button-solid-primary:active, .k-button-solid-primary.k-active {\r\n    background-color: #408cfd;\r\n    border-color: #4c94fe;\r\n}\r\n\r\n.k-button-solid-primary.k-selected {\r\n    background-color: #408cfd;\r\n    border-color: #4c94fe;\r\n}\r\n\r\n.k-button-solid-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {\r\n    background-color: #7f8890;\r\n    border-color: #868e96;\r\n}\r\n\r\n.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }\r\n\r\n.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {\r\n    background-color: #868e96;\r\n    border-color: #8d959c;\r\n}\r\n\r\n.k-button-solid-secondary.k-selected {\r\n    background-color: #868e96;\r\n    border-color: #8d959c;\r\n}\r\n\r\n.k-button-solid-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {\r\n    background-color: #855fca;\r\n    border-color: #8c68ce;\r\n}\r\n\r\n.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }\r\n\r\n.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {\r\n    background-color: #8c68ce;\r\n    border-color: #9472d1;\r\n}\r\n\r\n.k-button-solid-tertiary.k-selected {\r\n    background-color: #8c68ce;\r\n    border-color: #9472d1;\r\n}\r\n\r\n.k-button-solid-info {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-info:hover, .k-button-solid-info.k-hover {\r\n    background-color: #2fd3f4;\r\n    border-color: #3cd5f4;\r\n}\r\n\r\n.k-button-solid-info:focus, .k-button-solid-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }\r\n\r\n.k-button-solid-info:active, .k-button-solid-info.k-active {\r\n    background-color: #3cd5f4;\r\n    border-color: #48d8f5;\r\n}\r\n\r\n.k-button-solid-info.k-selected {\r\n    background-color: #3cd5f4;\r\n    border-color: #48d8f5;\r\n}\r\n\r\n.k-button-solid-success {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-success:hover, .k-button-solid-success.k-hover {\r\n    background-color: #1fa768;\r\n    border-color: #21b26f;\r\n}\r\n\r\n.k-button-solid-success:focus, .k-button-solid-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }\r\n\r\n.k-button-solid-success:active, .k-button-solid-success.k-active {\r\n    background-color: #21b26f;\r\n    border-color: #23bd75;\r\n}\r\n\r\n.k-button-solid-success.k-selected {\r\n    background-color: #21b26f;\r\n    border-color: #23bd75;\r\n}\r\n\r\n.k-button-solid-warning {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {\r\n    background-color: #ffcb2d;\r\n    border-color: #ffce3a;\r\n}\r\n\r\n.k-button-solid-warning:focus, .k-button-solid-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }\r\n\r\n.k-button-solid-warning:active, .k-button-solid-warning.k-active {\r\n    background-color: #ffce3a;\r\n    border-color: #ffd147;\r\n}\r\n\r\n.k-button-solid-warning.k-selected {\r\n    background-color: #ffce3a;\r\n    border-color: #ffd147;\r\n}\r\n\r\n.k-button-solid-error {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-button-solid-error:hover, .k-button-solid-error.k-hover {\r\n    background-color: #e25663;\r\n    border-color: #e4606d;\r\n}\r\n\r\n.k-button-solid-error:focus, .k-button-solid-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }\r\n\r\n.k-button-solid-error:active, .k-button-solid-error.k-active {\r\n    background-color: #e4606d;\r\n    border-color: #e56b77;\r\n}\r\n\r\n.k-button-solid-error.k-selected {\r\n    background-color: #e4606d;\r\n    border-color: #e56b77;\r\n}\r\n\r\n.k-button-solid-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {\r\n    background-color: #32383e;\r\n    border-color: #383f45;\r\n}\r\n\r\n.k-button-solid-dark:focus, .k-button-solid-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }\r\n\r\n.k-button-solid-dark:active, .k-button-solid-dark.k-active {\r\n    background-color: #383f45;\r\n    border-color: #3d454c;\r\n}\r\n\r\n.k-button-solid-dark.k-selected {\r\n    background-color: #383f45;\r\n    border-color: #3d454c;\r\n}\r\n\r\n.k-button-solid-light {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-solid-light:hover, .k-button-solid-light.k-hover {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-solid-light:focus, .k-button-solid-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-solid-light:active, .k-button-solid-light.k-active {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-solid-light.k-selected {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-solid-inverse {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-solid-inverse.k-selected {\r\n    background-color: white;\r\n    border-color: white;\r\n}\r\n\r\n.k-button-outline-primary {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-primary);\r\n}\r\n\r\n.k-button-outline-primary:hover, .k-button-outline-primary.k-hover {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-primary:focus, .k-button-outline-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }\r\n\r\n.k-button-outline-primary:active, .k-button-outline-primary.k-active {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-primary.k-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-button-outline-secondary {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-secondary);\r\n}\r\n\r\n.k-button-outline-secondary:hover, .k-button-outline-secondary.k-hover {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-secondary:focus, .k-button-outline-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }\r\n\r\n.k-button-outline-secondary:active, .k-button-outline-secondary.k-active {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-secondary.k-selected {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-tertiary {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-tertiary);\r\n}\r\n\r\n.k-button-outline-tertiary:hover, .k-button-outline-tertiary.k-hover {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-tertiary:focus, .k-button-outline-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }\r\n\r\n.k-button-outline-tertiary:active, .k-button-outline-tertiary.k-active {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-tertiary.k-selected {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-info {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-info);\r\n}\r\n\r\n.k-button-outline-info:hover, .k-button-outline-info.k-hover {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-info:focus, .k-button-outline-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }\r\n\r\n.k-button-outline-info:active, .k-button-outline-info.k-active {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-info.k-selected {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-success {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-success);\r\n}\r\n\r\n.k-button-outline-success:hover, .k-button-outline-success.k-hover {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-success:focus, .k-button-outline-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }\r\n\r\n.k-button-outline-success:active, .k-button-outline-success.k-active {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-success.k-selected {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-warning {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-warning);\r\n}\r\n\r\n.k-button-outline-warning:hover, .k-button-outline-warning.k-hover {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-warning:focus, .k-button-outline-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }\r\n\r\n.k-button-outline-warning:active, .k-button-outline-warning.k-active {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-warning.k-selected {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-error {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-error);\r\n}\r\n\r\n.k-button-outline-error:hover, .k-button-outline-error.k-hover {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-error:focus, .k-button-outline-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }\r\n\r\n.k-button-outline-error:active, .k-button-outline-error.k-active {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-error.k-selected {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-button-outline-dark {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-base-bg);\r\n}\r\n\r\n.k-button-outline-dark:hover, .k-button-outline-dark.k-hover {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-button-outline-dark:focus, .k-button-outline-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }\r\n\r\n.k-button-outline-dark:active, .k-button-outline-dark.k-active {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-button-outline-dark.k-selected {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-button-outline-light {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: #f8f9fa;\r\n}\r\n\r\n.k-button-outline-light:hover, .k-button-outline-light.k-hover {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-light:focus, .k-button-outline-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-outline-light:active, .k-button-outline-light.k-active {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-light.k-selected {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-inverse {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: #f8f9fa;\r\n}\r\n\r\n.k-button-outline-inverse:hover, .k-button-outline-inverse.k-hover {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-inverse:focus, .k-button-outline-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-outline-inverse:active, .k-button-outline-inverse.k-active {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-inverse.k-selected {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-base {\r\n    background-color: transparent;\r\n    border-color: currentColor;\r\n    box-shadow: none;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-button-outline-base:hover, .k-button-outline-base.k-hover {\r\n    background-color: #ffffff;\r\n    border-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-base:focus, .k-button-outline-base.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 255, 255, 0.5); }\r\n\r\n.k-button-outline-base:active, .k-button-outline-base.k-active {\r\n    background-color: #ffffff;\r\n    border-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-button-outline-base.k-selected {\r\n    background-color: #ffffff;\r\n    border-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-button-flat-primary { color: var(--dark-color-primary); }\r\n\r\n.k-button-flat-secondary { color: var(--dark-color-secondary); }\r\n\r\n.k-button-flat-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-button-flat-info { color: var(--dark-color-info); }\r\n\r\n.k-button-flat-success { color: var(--dark-color-success); }\r\n\r\n.k-button-flat-warning { color: var(--dark-color-warning); }\r\n\r\n.k-button-flat-error { color: var(--dark-color-error); }\r\n\r\n.k-button-flat-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-button-flat-light { color: #f8f9fa; }\r\n\r\n.k-button-flat-inverse { color: #f8f9fa; }\r\n\r\n.k-button-flat-base { color: inherit; }\r\n\r\n.k-button-link-primary { color: var(--dark-color-primary); }\r\n\r\n.k-button-link-primary:hover, .k-button-link-primary.k-hover { color: #3485fd; }\r\n\r\n.k-button-link-primary:focus, .k-button-link-primary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5); }\r\n\r\n.k-button-link-primary:active, .k-button-link-primary.k-active { color: #3485fd; }\r\n\r\n.k-button-link-primary.k-selected { color: #3485fd; }\r\n\r\n.k-button-link-secondary { color: var(--dark-color-secondary); }\r\n\r\n.k-button-link-secondary:hover, .k-button-link-secondary.k-hover { color: #848b92; }\r\n\r\n.k-button-link-secondary:focus, .k-button-link-secondary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5); }\r\n\r\n.k-button-link-secondary:active, .k-button-link-secondary.k-active { color: #848b92; }\r\n\r\n.k-button-link-secondary.k-selected { color: #848b92; }\r\n\r\n.k-button-link-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-button-link-tertiary:hover, .k-button-link-tertiary.k-hover { color: #8660cb; }\r\n\r\n.k-button-link-tertiary:focus, .k-button-link-tertiary.k-focus { box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5); }\r\n\r\n.k-button-link-tertiary:active, .k-button-link-tertiary.k-active { color: #8660cb; }\r\n\r\n.k-button-link-tertiary.k-selected { color: #8660cb; }\r\n\r\n.k-button-link-info { color: var(--dark-color-info); }\r\n\r\n.k-button-link-info:hover, .k-button-link-info.k-hover { color: #34d2f2; }\r\n\r\n.k-button-link-info:focus, .k-button-link-info.k-focus { box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5); }\r\n\r\n.k-button-link-info:active, .k-button-link-info.k-active { color: #34d2f2; }\r\n\r\n.k-button-link-info.k-selected { color: #34d2f2; }\r\n\r\n.k-button-link-success { color: var(--dark-color-success); }\r\n\r\n.k-button-link-success:hover, .k-button-link-success.k-hover { color: #3e9a6f; }\r\n\r\n.k-button-link-success:focus, .k-button-link-success.k-focus { box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5); }\r\n\r\n.k-button-link-success:active, .k-button-link-success.k-active { color: #3e9a6f; }\r\n\r\n.k-button-link-success.k-selected { color: #3e9a6f; }\r\n\r\n.k-button-link-warning { color: var(--dark-color-warning); }\r\n\r\n.k-button-link-warning:hover, .k-button-link-warning.k-hover { color: #ffcb2f; }\r\n\r\n.k-button-link-warning:focus, .k-button-link-warning.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5); }\r\n\r\n.k-button-link-warning:active, .k-button-link-warning.k-active { color: #ffcb2f; }\r\n\r\n.k-button-link-warning.k-selected { color: #ffcb2f; }\r\n\r\n.k-button-link-error { color: var(--dark-color-error); }\r\n\r\n.k-button-link-error:hover, .k-button-link-error.k-hover { color: #e25563; }\r\n\r\n.k-button-link-error:focus, .k-button-link-error.k-focus { box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5); }\r\n\r\n.k-button-link-error:active, .k-button-link-error.k-active { color: #e25563; }\r\n\r\n.k-button-link-error.k-selected { color: #e25563; }\r\n\r\n.k-button-link-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-button-link-dark:hover, .k-button-link-dark.k-hover { color: #45484b; }\r\n\r\n.k-button-link-dark:focus, .k-button-link-dark.k-focus { box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5); }\r\n\r\n.k-button-link-dark:active, .k-button-link-dark.k-active { color: #45484b; }\r\n\r\n.k-button-link-dark.k-selected { color: #45484b; }\r\n\r\n.k-button-link-light { color: #f8f9fa; }\r\n\r\n.k-button-link-light:hover, .k-button-link-light.k-hover { color: #f9fafb; }\r\n\r\n.k-button-link-light:focus, .k-button-link-light.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-link-light:active, .k-button-link-light.k-active { color: #f9fafb; }\r\n\r\n.k-button-link-light.k-selected { color: #f9fafb; }\r\n\r\n.k-button-link-inverse { color: #f8f9fa; }\r\n\r\n.k-button-link-inverse:hover, .k-button-link-inverse.k-hover { color: #f9fafb; }\r\n\r\n.k-button-link-inverse:focus, .k-button-link-inverse.k-focus { box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5); }\r\n\r\n.k-button-link-inverse:active, .k-button-link-inverse.k-active { color: #f9fafb; }\r\n\r\n.k-button-link-inverse.k-selected { color: #f9fafb; }\r\n\r\n.k-button-link-base { color: var(--dark-color-base-text); }\r\n\r\n.k-button-link-base:hover, .k-button-link-base.k-hover { color: white; }\r\n\r\n.k-button-link-base:focus, .k-button-link-base.k-focus { box-shadow: 0 0 0px 0.25rem rgba(255, 255, 255, 0.5); }\r\n\r\n.k-button-link-base:active, .k-button-link-base.k-active { color: white; }\r\n\r\n.k-button-link-base.k-selected { color: white; }\r\n\r\n.k-button-clear-primary { color: var(--dark-color-primary); }\r\n\r\n.k-button-clear-secondary { color: var(--dark-color-secondary); }\r\n\r\n.k-button-clear-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-button-clear-info { color: var(--dark-color-info); }\r\n\r\n.k-button-clear-success { color: var(--dark-color-success); }\r\n\r\n.k-button-clear-warning { color: var(--dark-color-warning); }\r\n\r\n.k-button-clear-error { color: var(--dark-color-error); }\r\n\r\n.k-button-clear-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-button-clear-light { color: #f8f9fa; }\r\n\r\n.k-button-clear-inverse { color: #f8f9fa; }\r\n\r\n.k-button-clear-base { color: var(--dark-color-base-text); }\r\n\r\n.k-split-button:focus,\r\n.k-split-button.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-input::-webkit-input-placeholder, .k-picker::-webkit-input-placeholder { color: #ced4da; }\r\n\r\n.k-input:-ms-input-placeholder, .k-picker:-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-input::-ms-input-placeholder, .k-picker::-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-input::placeholder,\r\n.k-picker::placeholder { color: #ced4da; }\r\n\r\n.k-input:-ms-input-placeholder,\r\n.k-picker:-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-input-inner::-webkit-input-placeholder { color: #ced4da; }\r\n\r\n.k-input-inner:-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-input-inner::-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-input-inner::placeholder { color: #ced4da; }\r\n\r\n.k-input-inner:-ms-input-placeholder { color: #ced4da; }\r\n\r\n.k-picker .k-input-button {\r\n    background: none;\r\n    border-color: transparent;\r\n    color: inherit;\r\n}\r\n\r\n.k-input {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: #dee2e6;\r\n}\r\n\r\n.k-input:focus, .k-input.k-focus {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #86b7fe;\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n    color: #dee2e6;\r\n}\r\n\r\n.k-input:focus-within {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #86b7fe;\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n    color: #dee2e6;\r\n}\r\n\r\n.k-input.k-invalid, .k-input.ng-invalid.ng-touched, .k-input.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }\r\n\r\n.k-input.k-invalid .k-input-validation-icon, .k-input.ng-invalid.ng-touched .k-input-validation-icon, .k-input.ng-invalid.ng-dirty .k-input-validation-icon { color: var(--dark-color-error); }\r\n\r\n.k-input.k-invalid:focus, .k-input.k-invalid.k-focus, .k-input.ng-invalid.ng-touched:focus, .k-input.ng-invalid.ng-touched.k-focus, .k-input.ng-invalid.ng-dirty:focus, .k-input.ng-invalid.ng-dirty.k-focus { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }\r\n\r\n.k-input.k-invalid:focus-within, .k-input.ng-invalid.ng-touched:focus-within, .k-input.ng-invalid.ng-dirty:focus-within { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }\r\n\r\n.k-picker {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-picker:hover, .k-picker.k-hover {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n}\r\n\r\n.k-picker:focus, .k-picker.k-focus { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-picker:focus-within { box-shadow: 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-picker.k-invalid, .k-picker.ng-invalid.ng-touched, .k-picker.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }\r\n\r\n.k-picker.k-invalid .k-input-validation-icon, .k-picker.ng-invalid.ng-touched .k-input-validation-icon, .k-picker.ng-invalid.ng-dirty .k-input-validation-icon { color: var(--dark-color-error); }\r\n\r\n.k-picker.k-invalid:focus, .k-picker.k-invalid.k-focus, .k-picker.ng-invalid.ng-touched:focus, .k-picker.ng-invalid.ng-touched.k-focus, .k-picker.ng-invalid.ng-dirty:focus, .k-picker.ng-invalid.ng-dirty.k-focus { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }\r\n\r\n.k-picker.k-invalid:focus-within, .k-picker.ng-invalid.ng-touched:focus-within, .k-picker.ng-invalid.ng-dirty:focus-within { box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25); }\r\n\r\n.k-table,\r\n.k-data-table {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-table-thead,\r\n.k-table-header,\r\n.k-table-group-sticky-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-table-tfoot,\r\n.k-table-footer {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-table-group-row {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-table-group-td > span {\r\n    background-color: #ffffff;\r\n    color: #000000;\r\n}\r\n\r\n.k-table-alt-row { background-color: rgba(255, 255, 255, 0.04); }\r\n\r\n.k-table-tbody .k-table-row:hover,\r\n.k-table-list .k-table-row:hover,\r\n.k-table-tbody .k-table-row.k-hover,\r\n.k-table-list .k-table-row.k-hover { background-color: rgba(255, 255, 255, 0.08); }\r\n\r\n.k-table-tbody .k-table-row.k-focus,\r\n.k-table-list .k-table-row.k-focus,\r\n.k-table-tbody .k-table-td.k-focus,\r\n.k-table-list .k-table-td.k-focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }\r\n\r\n.k-table-tbody .k-table-row.k-selected,\r\n.k-table-list .k-table-row.k-selected {\r\n    background-color: rgba(13, 110, 253, 0.25);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-avatar-solid-primary {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-info {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-success {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-warning {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-avatar-solid-error {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-avatar-solid-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-avatar-solid-light {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-avatar-solid-inverse {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-avatar-outline { border-color: currentColor; }\r\n\r\n.k-avatar-outline-primary { color: var(--dark-color-primary); }\r\n\r\n.k-avatar-outline-secondary { color: var(--dark-color-secondary); }\r\n\r\n.k-avatar-outline-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-avatar-outline-info { color: var(--dark-color-info); }\r\n\r\n.k-avatar-outline-success { color: var(--dark-color-success); }\r\n\r\n.k-avatar-outline-warning { color: var(--dark-color-warning); }\r\n\r\n.k-avatar-outline-error { color: var(--dark-color-error); }\r\n\r\n.k-avatar-outline-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-avatar-outline-light { color: #f8f9fa; }\r\n\r\n.k-avatar-outline-inverse { color: #f8f9fa; }\r\n\r\n.k-chip-solid-base {\r\n    background-color: #141414;\r\n    border-color: #4d4d4d;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-chip-solid-base:focus, .k-chip-solid-base.k-focus {\r\n    background-color: #141414;\r\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.16);\r\n}\r\n\r\n.k-chip-solid-base:hover, .k-chip-solid-base.k-hover { background-color: #292929; }\r\n\r\n.k-chip-solid-base.k-selected { background-color: #3d3d3d; }\r\n\r\n.k-chip-solid-error {\r\n    background-color: #120406;\r\n    border-color: #421015;\r\n    color: var(--dark-color-error);\r\n}\r\n\r\n.k-chip-solid-error:focus, .k-chip-solid-error.k-focus {\r\n    background-color: #120406;\r\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);\r\n}\r\n\r\n.k-chip-solid-error:hover, .k-chip-solid-error.k-hover { background-color: #23080b; }\r\n\r\n.k-chip-solid-error.k-selected { background-color: #350d11; }\r\n\r\n.k-chip-solid-info {\r\n    background-color: #011013;\r\n    border-color: #043d48;\r\n    color: var(--dark-color-info);\r\n}\r\n\r\n.k-chip-solid-info:focus, .k-chip-solid-info.k-focus {\r\n    background-color: #011013;\r\n    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);\r\n}\r\n\r\n.k-chip-solid-info:hover, .k-chip-solid-info.k-hover { background-color: #022026; }\r\n\r\n.k-chip-solid-info.k-selected { background-color: #03303a; }\r\n\r\n.k-chip-solid-warning {\r\n    background-color: #140f01;\r\n    border-color: #4d3a02;\r\n    color: var(--dark-color-warning);\r\n}\r\n\r\n.k-chip-solid-warning:focus, .k-chip-solid-warning.k-focus {\r\n    background-color: #140f01;\r\n    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);\r\n}\r\n\r\n.k-chip-solid-warning:hover, .k-chip-solid-warning.k-hover { background-color: #291f01; }\r\n\r\n.k-chip-solid-warning.k-selected { background-color: #3d2e02; }\r\n\r\n.k-chip-solid-success {\r\n    background-color: #020b07;\r\n    border-color: #082919;\r\n    color: var(--dark-color-success);\r\n}\r\n\r\n.k-chip-solid-success:focus, .k-chip-solid-success.k-focus {\r\n    background-color: #020b07;\r\n    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);\r\n}\r\n\r\n.k-chip-solid-success:hover, .k-chip-solid-success.k-hover { background-color: #04160d; }\r\n\r\n.k-chip-solid-success.k-selected { background-color: #062014; }\r\n\r\n.k-chip-outline-base {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #ffffff;\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-chip-outline-base:focus, .k-chip-outline-base.k-focus { box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.16); }\r\n\r\n.k-chip-outline-base:hover, .k-chip-outline-base.k-hover {\r\n    background-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-chip-outline-base.k-selected {\r\n    background-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-chip-outline-error {\r\n    background-color: #ffffff;\r\n    border-color: var(--dark-color-error);\r\n    color: var(--dark-color-error);\r\n}\r\n\r\n.k-chip-outline-error:focus, .k-chip-outline-error.k-focus { box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16); }\r\n\r\n.k-chip-outline-error:hover, .k-chip-outline-error.k-hover {\r\n    background-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-chip-outline-error.k-selected {\r\n    background-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-chip-outline-info {\r\n    background-color: #ffffff;\r\n    border-color: var(--dark-color-info);\r\n    color: var(--dark-color-info);\r\n}\r\n\r\n.k-chip-outline-info:focus, .k-chip-outline-info.k-focus { box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16); }\r\n\r\n.k-chip-outline-info:hover, .k-chip-outline-info.k-hover {\r\n    background-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-chip-outline-info.k-selected {\r\n    background-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-chip-outline-warning {\r\n    background-color: #ffffff;\r\n    border-color: var(--dark-color-warning);\r\n    color: var(--dark-color-warning);\r\n}\r\n\r\n.k-chip-outline-warning:focus, .k-chip-outline-warning.k-focus { box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16); }\r\n\r\n.k-chip-outline-warning:hover, .k-chip-outline-warning.k-hover {\r\n    background-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-chip-outline-warning.k-selected {\r\n    background-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-chip-outline-success {\r\n    background-color: #ffffff;\r\n    border-color: var(--dark-color-success);\r\n    color: var(--dark-color-success);\r\n}\r\n\r\n.k-chip-outline-success:focus, .k-chip-outline-success.k-focus { box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16); }\r\n\r\n.k-chip-outline-success:hover, .k-chip-outline-success.k-hover {\r\n    background-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-chip-outline-success.k-selected {\r\n    background-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-no-color .k-color-preview-mask::before { background-color: #ffffff; }\r\n\r\n.k-color-preview { border-color: var(--dark-color-border); }\r\n\r\n.k-color-preview:hover, .k-color-preview.k-hover { border-color: #444a4f; }\r\n\r\n.k-loader-primary { color: var(--dark-color-primary); }\r\n\r\n.k-loader-secondary { color: var(--dark-color-base-bg); }\r\n\r\n.k-loader-tertiary { color: var(--dark-color-tertiary); }\r\n\r\n.k-loader-info { color: var(--dark-color-info); }\r\n\r\n.k-loader-success { color: var(--dark-color-success); }\r\n\r\n.k-loader-warning { color: var(--dark-color-warning); }\r\n\r\n.k-loader-error { color: var(--dark-color-error); }\r\n\r\n.k-loader-dark { color: var(--dark-color-base-bg); }\r\n\r\n.k-loader-light { color: #f8f9fa; }\r\n\r\n.k-loader-inverse { color: #f8f9fa; }\r\n\r\n.k-loader-container-panel {\r\n    background-color: #ffffff;\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-loader-container-inner .k-text-secondary { color: var(--dark-color-base-bg) !important; }\r\n\r\n.k-skeleton { background-color: rgba(248, 249, 250, 0.2); }\r\n\r\n.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave.k-skeleton::after { background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.04), transparent); }\r\n\r\n.k-menu-vertical > .k-separator { border-color: var(--dark-color-border); }\r\n\r\n.k-menu-group .k-separator { border-color: var(--dark-color-border); }\r\n\r\n.k-menu:not(.k-context-menu) {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-menu:not(.k-context-menu) > .k-item { color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-menu:not(.k-context-menu) > .k-item:hover, .k-menu:not(.k-context-menu) > .k-item.k-hover { color: rgba(255, 255, 255, 0.7); }\r\n\r\n.k-menu:not(.k-context-menu) > .k-item:active, .k-menu:not(.k-context-menu) > .k-item.k-active { color: rgba(255, 255, 255, 0.9); }\r\n\r\n.k-menu:not(.k-context-menu) > .k-item:focus, .k-menu:not(.k-context-menu) > .k-item.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-menu-group,\r\n.k-menu.k-context-menu {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-menu-group .k-item > .k-link:hover, .k-menu-group .k-item > .k-link.k-hover,\r\n.k-menu.k-context-menu .k-item > .k-link:hover,\r\n.k-menu.k-context-menu .k-item > .k-link.k-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-menu-group .k-item > .k-link:active, .k-menu-group .k-item > .k-link.k-active, .k-menu-group .k-item > .k-link.k-selected,\r\n.k-menu.k-context-menu .k-item > .k-link:active,\r\n.k-menu.k-context-menu .k-item > .k-link.k-active,\r\n.k-menu.k-context-menu .k-item > .k-link.k-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-menu-group .k-item:focus, .k-menu-group .k-item.k-focus,\r\n.k-menu.k-context-menu .k-item:focus,\r\n.k-menu.k-context-menu .k-item.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-menu-scroll-button {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.k-menu-scroll-button:hover { color: rgba(255, 255, 255, 0.7); }\r\n\r\n.k-toolbar {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-toolbar .k-separator { border-color: inherit; }\r\n\r\n.k-overflow-container .k-button:hover, .k-overflow-container .k-button.k-hover {\r\n    background: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-overflow-container .k-button:focus, .k-overflow-container .k-button.k-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-overflow-container .k-button:active, .k-overflow-container .k-button.k-active {\r\n    background: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-overflow-container .k-button.k-selected {\r\n    background: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-overflow-container .k-button:disabled, .k-overflow-container .k-button.k-disabled { color: inherit; }\r\n\r\n.k-floating-toolbar,\r\n.editorToolbarWindow.k-window-content {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-form,\r\n.k-form-inline { color: var(--dark-color-base-text); }\r\n\r\n.k-form .k-form-legend,\r\n.k-form-inline .k-form-legend { border-color: var(--dark-color-border); }\r\n\r\n.k-form .k-field-info,\r\n.k-form-inline .k-field-info { color: var(--dark-color-subtle-text); }\r\n\r\n.k-form .k-alert-error,\r\n.k-form-inline .k-alert-error { color: var(--dark-color-error); }\r\n\r\n.k-form-error,\r\n.k-text-error,\r\n.k-form-field-error .k-label { color: var(--dark-color-error); }\r\n\r\n.k-form-separator { border-color: var(--dark-color-border); }\r\n\r\n.k-tooltip-wrapper .k-tooltip { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }\r\n\r\n.k-tooltip {\r\n    background-color: #ffffff;\r\n    border-color: #ffffff;\r\n    color: black;\r\n}\r\n\r\n.k-tooltip .k-callout { color: var(--dark-color-base-text); }\r\n\r\n.k-tooltip-primary {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-tooltip-primary .k-callout { color: var(--dark-color-primary); }\r\n\r\n.k-tooltip-info {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-tooltip-info .k-callout { color: var(--dark-color-info); }\r\n\r\n.k-tooltip-success {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-tooltip-success .k-callout { color: var(--dark-color-success); }\r\n\r\n.k-tooltip-warning {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-tooltip-warning .k-callout { color: var(--dark-color-warning); }\r\n\r\n.k-tooltip-error {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-tooltip-error .k-callout { color: var(--dark-color-error); }\r\n\r\n.k-listbox .k-list-scroller {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-listbox .k-drop-hint { border-top-color: var(--dark-color-primary); }\r\n\r\n.k-progressbar .k-item { border-color: transparent; }\r\n\r\n.k-progressbar {\r\n    background-color: #e9ecef;\r\n    color: black;\r\n}\r\n\r\n.k-progressbar .k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-progressbar .k-item { border-color: #000000; }\r\n\r\n.k-progressbar-indeterminate {\r\n    background-color: #e9ecef;\r\n    background-image: linear-gradient(45deg, #d6d9dc 25%, transparent 25%, transparent 50%, #d6d9dc 50%, #d6d9dc 75%, transparent 75%, transparent);\r\n    color: black;\r\n}\r\n\r\n.k-radio {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-secondary);\r\n}\r\n\r\n.k-radio:focus,\r\n.k-radio.k-state-focus {\r\n    border-color: #07377f;\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-radio.k-invalid,\r\n.k-radio.k-state-invalid,\r\n.k-radio.ng-invalid.ng-touched,\r\n.k-radio.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }\r\n\r\n.k-radio.k-invalid + .k-radio-label,\r\n.k-radio.k-state-invalid + .k-radio-label,\r\n.k-radio.ng-invalid.ng-touched + .k-radio-label,\r\n.k-radio.ng-invalid.ng-dirty + .k-radio-label { color: var(--dark-color-error); }\r\n\r\n.k-radio:checked,\r\n.k-radio.k-checked {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-radio:checked:focus,\r\n.k-radio.k-checked.k-state-focus {\r\n    border-color: var(--dark-color-primary);\r\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-ripple-container .k-radio::after { background: var(--dark-color-primary); }\r\n\r\n.k-slider .k-tick { background-color: transparent; }\r\n\r\n.k-draghandle { background-color: transparent; }\r\n\r\n.k-slider { color: var(--dark-color-base-text); }\r\n\r\n.k-slider .k-slider-track { background-color: #e9ecef; }\r\n\r\n.k-slider .k-slider-selection { background-color: var(--dark-color-selected-bg); }\r\n\r\n.k-slider .k-draghandle {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    border-radius: 50%;\r\n    color: white;\r\n}\r\n\r\n.k-slider .k-draghandle:hover {\r\n    background-color: #3385fd;\r\n    border-color: #408cfd;\r\n    color: white;\r\n}\r\n\r\n.k-slider .k-draghandle:active, .k-slider .k-draghandle.k-pressed {\r\n    background-color: #408cfd;\r\n    border-color: #4c94fe;\r\n    color: white;\r\n}\r\n\r\n.k-slider .k-draghandle:focus, .k-slider .k-draghandle.k-state-focused { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }\r\n\r\n.k-slider.k-state-focused .k-draghandle { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }\r\n\r\n.k-calendar-td { border-color: transparent; }\r\n\r\n.k-calendar-infinite .k-calendar-view::after { box-shadow: 0 0 38px 19px #000000; }\r\n\r\n.k-calendar-navigation::before, .k-calendar-navigation::after { box-shadow: 0 0 6em 3em var(--dark-color-base-bg); }\r\n\r\n.k-calendar-navigation .k-content,\r\n.k-calendar-navigation .k-calendar-content { background: transparent; }\r\n\r\n.k-calendar {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-calendar .k-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: inherit;\r\n    box-shadow: none;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-calendar .k-nav-today { color: var(--dark-color-primary); }\r\n\r\n.k-calendar .k-nav-today:hover, .k-calendar .k-nav-today.k-state-hover, .k-calendar .k-nav-today:focus, .k-calendar .k-nav-today.k-state-focus { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-calendar .k-calendar-th,\r\n.k-calendar .k-calendar-caption,\r\n.k-calendar .k-meta-header,\r\n.k-calendar .k-month-header { color: var(--dark-color-subtle-text); }\r\n\r\n.k-calendar .k-calendar-view .k-today .k-link { box-shadow: inset 0 0 0 1px var(--dark-color-link-text); }\r\n\r\n.k-calendar .k-calendar-view .k-today.k-state-focused .k-link { box-shadow: inset 0 0 0 1px var(--dark-color-link-text), inset 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-calendar .k-other-month { color: var(--dark-color-subtle-text); }\r\n\r\n.k-calendar .k-alt {\r\n    background-color: transparent;\r\n    color: var(--dark-color-subtle-text);\r\n}\r\n\r\n.k-calendar .k-calendar-td:hover .k-link,\r\n.k-calendar .k-calendar-td.k-state-hover .k-link {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: #444a4f;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-calendar .k-calendar-td.k-state-selected .k-link {\r\n    background-color: var(--dark-color-link-text);\r\n    border-color: #207afd;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-calendar .k-calendar-td.k-state-selected:hover .k-link,\r\n.k-calendar .k-calendar-td.k-state-selected.k-state-hover .k-link {\r\n    background-color: #1774fd;\r\n    border-color: #33363a;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-calendar .k-calendar-td.k-state-focused .k-link,\r\n.k-calendar .k-calendar-td.k-state-focus .k-link { box-shadow: inset 0 0 0 0.25rem rgba(52, 58, 64, 0.5); }\r\n\r\n.k-calendar .k-calendar-td.k-state-selected.k-state-focused .k-link,\r\n.k-calendar .k-calendar-td.k-state-selected.k-state-focus .k-link { box-shadow: inset 0 0 0 2px rgba(76, 148, 254, 0.5); }\r\n\r\n.k-calendar .k-calendar-navigation {\r\n    background-color: var(--dark-color-base-bg);\r\n    box-shadow: inset -1px 0 #495057;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-calendar .k-calendar-navigation li:hover,\r\n.k-calendar .k-calendar-navigation li.k-state-hover { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-calendar .k-calendar-navigation-highlight {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-calendar[dir=\"rtl\"] .k-calendar-navigation,\r\n.k-rtl .k-calendar .k-calendar-navigation { box-shadow: inset 1px 0 #495057; }\r\n\r\n.k-calendar.k-invalid, .k-calendar.k-invalid:hover, .k-calendar.k-state-invalid, .k-calendar.ng-invalid.ng-touched, .k-calendar.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }\r\n\r\n.k-scheduler .k-calendar .k-other-month {\r\n    background-color: transparent;\r\n    color: var(--dark-color-subtle-text);\r\n}\r\n\r\n.k-calendar .k-range-start,\r\n.k-calendar .k-range-end,\r\n.k-calendar .k-range-mid { background-image: linear-gradient(transparent 1px, rgba(13, 110, 253, 0.25) 1px, rgba(13, 110, 253, 0.25) calc(100% - 1px), transparent calc(100% - 1px)); }\r\n\r\n.k-ie .k-calendar .k-range-start, .k-ie\r\n.k-calendar .k-range-end, .k-ie\r\n.k-calendar .k-range-mid {\r\n    background-color: rgba(13, 110, 253, 0.25);\r\n    background-image: none;\r\n}\r\n\r\n.k-calendar .k-range-start.k-range-end {\r\n    background-color: transparent;\r\n    background-image: none;\r\n}\r\n\r\n.k-calendar .k-range-start .k-link,\r\n.k-calendar .k-range-end .k-link { background-color: var(--dark-color-link-text); }\r\n\r\n.k-calendar .k-range-start.k-state-active .k-link,\r\n.k-calendar .k-range-end.k-state-active .k-link { box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, 0.2); }\r\n\r\n.k-calendar .k-range-split-start::after {\r\n    background-image: linear-gradient(to left, rgba(13, 110, 253, 0.25), transparent 100%);\r\n    left: -5px;\r\n    right: auto;\r\n}\r\n\r\n.k-calendar .k-range-split-end::after {\r\n    background-image: linear-gradient(to right, rgba(13, 110, 253, 0.25), transparent 100%);\r\n    left: auto;\r\n    right: -5px;\r\n}\r\n\r\n.k-timeselector {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-time-header .k-time-now,\r\n.k-time-selector-header .k-time-now { color: var(--dark-color-primary); }\r\n\r\n.k-time-header .k-time-now:hover,\r\n.k-time-selector-header .k-time-now:hover { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-time-list-wrapper .k-title { color: var(--dark-color-subtle-text); }\r\n\r\n.k-time-list-wrapper.k-state-focused .k-title { color: var(--dark-color-hovered-text); }\r\n\r\n.k-time-list-wrapper.k-state-focused::before, .k-time-list-wrapper.k-state-focused::after { background-color: rgba(0, 0, 0, 0.02); }\r\n\r\n.k-time-list::before, .k-time-list::after { box-shadow: 0 0 3em 1.5em #000000; }\r\n\r\n.k-time-list .k-item:hover { color: var(--dark-color-primary); }\r\n\r\n.k-time-container { background: transparent; }\r\n\r\n.k-time-highlight {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-captcha {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #000000;\r\n    color: #000000;\r\n}\r\n\r\n.k-colorpalette-tile:focus, .k-colorpalette-tile.k-state-focus, .k-colorpalette-tile.k-focus { box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.5); }\r\n\r\n.k-colorpalette-tile:hover, .k-colorpalette-tile.k-state-hover, .k-colorpalette-tile.k-hover { box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.8); }\r\n\r\n.k-colorpalette-tile.k-state-selected, .k-colorpalette-tile.k-state-selected:hover, .k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover { box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px white; }\r\n\r\n.k-colorgradient {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-colorgradient:focus,\r\n.k-colorgradient.k-state-focus,\r\n.k-colorgradient.k-focus { border-color: #444a4f; }\r\n\r\n.k-colorgradient-canvas .k-hsv-gradient { background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black), linear-gradient(to right, white, rgba(255, 255, 255, 0)); }\r\n\r\n.k-colorgradient .k-draghandle {\r\n    background-color: transparent;\r\n    border-color: rgba(255, 255, 255, 0.8);\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.k-colorgradient .k-draghandle:focus, .k-colorgradient .k-draghandle.k-state-focus, .k-colorgradient .k-draghandle.k-focus {\r\n    background-color: transparent;\r\n    border-color: #ffffff;\r\n    box-shadow: 0 1px 4px black;\r\n}\r\n\r\n.k-colorgradient .k-draghandle:active, .k-colorgradient .k-draghandle:hover, .k-colorgradient .k-draghandle.k-state-hover, .k-colorgradient .k-draghandle.k-hover {\r\n    background-color: transparent;\r\n    border-color: #ffffff;\r\n    box-shadow: 0 1px 4px black;\r\n}\r\n\r\n.k-colorgradient-slider.k-hue-slider.k-slider-horizontal .k-slider-track { background: linear-gradient(to right, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }\r\n\r\n.k-colorgradient-slider.k-hue-slider.k-slider-vertical .k-slider-track { background: linear-gradient(to top, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }\r\n\r\n.k-colorgradient-input-label { color: var(--dark-color-subtle-text); }\r\n\r\n.k-rtl .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track,\r\n[dir=\"rtl\"] .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track { background: linear-gradient(to left, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000); }\r\n\r\n.k-coloreditor {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-coloreditor:focus,\r\n.k-coloreditor.k-state-focus,\r\n.k-coloreditor.k-focus { border-color: #444a4f; }\r\n\r\n.k-treeview { color: var(--dark-color-base-text); }\r\n\r\n.k-treeview-leaf:hover, .k-treeview-leaf.k-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-treeview-leaf:focus, .k-treeview-leaf.k-focus { box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-treeview-leaf.k-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-treeview .k-treeview-load-more-button {\r\n    background-color: transparent;\r\n    color: var(--dark-color-primary);\r\n}\r\n\r\n.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover {\r\n    background-color: transparent;\r\n    color: var(--dark-color-link-hover-text);\r\n}\r\n\r\n.k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {\r\n    background-color: transparent;\r\n    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15);\r\n    color: var(--dark-color-link-hover-text);\r\n}\r\n\r\n.k-rating { color: var(--dark-color-base-text); }\r\n\r\n.k-rating:focus .k-rating-item > .k-icon, .k-rating.k-state-focused .k-rating-item > .k-icon { text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }\r\n\r\n.k-rating:focus .k-rating-item.k-state-selected > .k-icon, .k-rating.k-state-focused .k-rating-item.k-state-selected > .k-icon { text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }\r\n\r\n.k-rating-item { color: var(--dark-color-subtle-text); }\r\n\r\n.k-rating-item.k-state-selected { color: var(--dark-color-selected-bg); }\r\n\r\n.k-rating-item.k-state-selected:focus, .k-rating-item.k-state-selected.k-state-focused { color: var(--dark-color-selected-bg); }\r\n\r\n.k-rating-item:hover, .k-rating-item.k-state-hover {\r\n    color: var(--dark-color-primary);\r\n    cursor: pointer;\r\n}\r\n\r\n.k-switch-off .k-switch-track {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #adb5bd;\r\n}\r\n\r\n.k-switch-off .k-switch-thumb { background-color: #adb5bd; }\r\n\r\n.k-switch-off:focus .k-switch-track, .k-switch-off.k-focus .k-switch-track {\r\n    border-color: #07377f;\r\n    outline: 0.25rem solid rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-switch-off:disabled .k-switch-track, .k-switch-off.k-disabled .k-switch-track { background-color: var(--dark-color-kendo-button-bg); }\r\n\r\n.k-switch-off .k-switch-label-on { color: transparent; }\r\n\r\n.k-switch-on .k-switch-track {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n}\r\n\r\n.k-switch-on .k-switch-thumb { background-color: white; }\r\n\r\n.k-switch-on:focus .k-switch-track, .k-switch-on.k-focus .k-switch-track { outline: 0.25rem solid rgba(13, 110, 253, 0.25); }\r\n\r\n.k-switch-on:disabled .k-switch-track, .k-switch-on.k-disabled .k-switch-track { background-color: #07377f; }\r\n\r\n.k-switch-on .k-switch-label-off { color: transparent; }\r\n\r\n.k-dropzone-inner {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-dropzone-inner > .k-icon,\r\n.k-dropzone-inner .k-dropzone-icon { color: #5c5c5c; }\r\n\r\n.k-dropzone-inner .k-dropzone-note { color: var(--dark-color-subtle-text); }\r\n\r\n.k-external-dropzone-hover .k-icon,\r\n.k-external-dropzone-hover .k-dropzone-icon { color: var(--dark-color-primary); }\r\n\r\n.k-upload .k-dropzone { background-color: transparent; }\r\n\r\n.k-upload {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-upload .k-dropzone {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-upload .k-dropzone.k-dropzone-hover, .k-upload .k-dropzone.k-dropzone-hovered { background-color: #25282c; }\r\n\r\n.k-upload .k-dropzone .k-dropzone-hint { color: var(--dark-color-subtle-text); }\r\n\r\n.k-upload .k-upload-files,\r\n.k-upload .k-file { border-color: var(--dark-color-border); }\r\n\r\n.k-upload .k-file.k-state-focused { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-upload .k-file .k-upload-action.k-state-focused { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-upload .k-upload-status { color: var(--dark-color-subtle-text); }\r\n\r\n.k-upload .k-file-progress .k-file-name { color: var(--dark-color-base-text); }\r\n\r\n.k-upload .k-file-progress .k-progress { background-color: var(--dark-color-info); }\r\n\r\n.k-upload .k-file-success .k-progress { background-color: var(--dark-color-success); }\r\n\r\n.k-upload .k-file-error .k-file-validation-message,\r\n.k-upload .k-file-invalid .k-file-validation-message { color: var(--dark-color-error); }\r\n\r\n.k-upload .k-file-error .k-progress,\r\n.k-upload .k-file-invalid .k-progress { background-color: var(--dark-color-error); }\r\n\r\n.k-upload .k-file-extension-wrapper,\r\n.k-upload .k-multiple-files-extension-wrapper,\r\n.k-upload .k-file-group-wrapper,\r\n.k-upload .k-multiple-files-group-wrapper,\r\n.k-upload .k-file-invalid-extension-wrapper,\r\n.k-upload .k-multiple-files-invalid-extension-wrapper,\r\n.k-upload .k-file-invalid-group-wrapper,\r\n.k-upload .k-multiple-files-invalid-group-wrapper {\r\n    border-color: var(--dark-color-subtle-text);\r\n    color: var(--dark-color-subtle-text);\r\n}\r\n\r\n.k-upload .k-file-invalid-extension-wrapper,\r\n.k-upload .k-multiple-files-invalid-extension-wrapper,\r\n.k-upload .k-file-error .k-file-extension-wrapper,\r\n.k-upload .k-file-invalid-group-wrapper,\r\n.k-upload .k-multiple-files-invalid-group-wrapper,\r\n.k-upload .k-file-error .k-file-group-wrapper { border-color: var(--dark-color-subtle-text); }\r\n\r\n.k-upload .k-file-extension-wrapper::before,\r\n.k-upload .k-multiple-files-extension-wrapper::before,\r\n.k-upload .k-file-invalid-extension-wrapper::before,\r\n.k-upload .k-multiple-files-invalid-extension-wrapper::before,\r\n.k-upload .k-file-error .k-file-extension-wrapper::before {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: transparent transparent var(--dark-color-subtle-text) var(--dark-color-subtle-text);\r\n}\r\n\r\n.k-upload .k-multiple-files-extension-wrapper::after,\r\n.k-upload .k-multiple-files-invalid-extension-wrapper::after {\r\n    border-left-color: var(--dark-color-subtle-text);\r\n    border-top-color: var(--dark-color-subtle-text);\r\n}\r\n\r\n.k-upload .k-file-size,\r\n.k-upload .k-file-validation-message,\r\n.k-upload .k-file-information { color: var(--dark-color-subtle-text); }\r\n\r\n.k-upload .k-multiple-files-wrapper .k-file-information { color: var(--dark-color-base-text); }\r\n\r\n.k-upload.k-state-invalid, .k-upload.ng-invalid.ng-touched, .k-upload.ng-invalid.ng-dirty { border-color: var(--dark-color-error); }\r\n\r\n.k-appbar { box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-appbar-bottom { box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-appbar-primary {\r\n    background-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-info {\r\n    background-color: var(--dark-color-info);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-success {\r\n    background-color: var(--dark-color-success);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-warning {\r\n    background-color: var(--dark-color-warning);\r\n    color: black;\r\n}\r\n\r\n.k-appbar-error {\r\n    background-color: var(--dark-color-error);\r\n    color: white;\r\n}\r\n\r\n.k-appbar-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-appbar-light {\r\n    background-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-appbar-inverse {\r\n    background-color: #f8f9fa;\r\n    color: black;\r\n}\r\n\r\n.k-fab {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n}\r\n\r\n.k-fab-solid-primary {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-primary);\r\n}\r\n\r\n.k-fab-solid-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    border-color: var(--dark-color-secondary);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-secondary);\r\n}\r\n\r\n.k-fab-solid-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    border-color: var(--dark-color-tertiary);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-tertiary);\r\n}\r\n\r\n.k-fab-solid-info {\r\n    background-color: var(--dark-color-info);\r\n    border-color: var(--dark-color-info);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-info);\r\n}\r\n\r\n.k-fab-solid-success {\r\n    background-color: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-success);\r\n}\r\n\r\n.k-fab-solid-warning {\r\n    background-color: var(--dark-color-warning);\r\n    border-color: var(--dark-color-warning);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: black;\r\n    outline: 1px solid var(--dark-color-warning);\r\n}\r\n\r\n.k-fab-solid-error {\r\n    background-color: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid var(--dark-color-error);\r\n}\r\n\r\n.k-fab-solid-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-base-bg);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: var(--dark-color-base-text);\r\n    outline: 1px solid var(--dark-color-base-bg);\r\n}\r\n\r\n.k-fab-solid-light {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: black;\r\n    outline: 1px solid #f8f9fa;\r\n}\r\n\r\n.k-fab-solid-inverse {\r\n    background-color: #f8f9fa;\r\n    border-color: #f8f9fa;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: black;\r\n    outline: 1px solid #f8f9fa;\r\n}\r\n\r\n.k-hover.k-fab-solid-primary,\r\n.k-fab-solid-primary:hover {\r\n    background-color: #3385fd;\r\n    border-color: #408cfd;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-secondary,\r\n.k-fab-solid-secondary:hover {\r\n    background-color: #7f8890;\r\n    border-color: #868e96;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-tertiary,\r\n.k-fab-solid-tertiary:hover {\r\n    background-color: #855fca;\r\n    border-color: #8c68ce;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-info,\r\n.k-fab-solid-info:hover {\r\n    background-color: #2fd3f4;\r\n    border-color: #3cd5f4;\r\n    color: black;\r\n}\r\n\r\n.k-hover.k-fab-solid-success,\r\n.k-fab-solid-success:hover {\r\n    background-color: #1fa768;\r\n    border-color: #21b26f;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-warning,\r\n.k-fab-solid-warning:hover {\r\n    background-color: #ffcb2d;\r\n    border-color: #ffce3a;\r\n    color: black;\r\n}\r\n\r\n.k-hover.k-fab-solid-error,\r\n.k-fab-solid-error:hover {\r\n    background-color: #e25663;\r\n    border-color: #e4606d;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-dark,\r\n.k-fab-solid-dark:hover {\r\n    background-color: #32383e;\r\n    border-color: #383f45;\r\n    color: white;\r\n}\r\n\r\n.k-hover.k-fab-solid-light,\r\n.k-fab-solid-light:hover {\r\n    background-color: white;\r\n    border-color: white;\r\n    color: black;\r\n}\r\n\r\n.k-hover.k-fab-solid-inverse,\r\n.k-fab-solid-inverse:hover {\r\n    background-color: white;\r\n    border-color: white;\r\n    color: black;\r\n}\r\n\r\n.k-fab-solid-primary.k-focus,\r\n.k-fab-solid-primary:focus { outline-color: rgba(13, 110, 253, 0.5); }\r\n\r\n.k-fab-solid-secondary.k-focus,\r\n.k-fab-solid-secondary:focus { outline-color: rgba(108, 117, 125, 0.5); }\r\n\r\n.k-fab-solid-tertiary.k-focus,\r\n.k-fab-solid-tertiary:focus { outline-color: rgba(111, 66, 193, 0.5); }\r\n\r\n.k-fab-solid-info.k-focus,\r\n.k-fab-solid-info:focus { outline-color: rgba(13, 202, 240, 0.5); }\r\n\r\n.k-fab-solid-success.k-focus,\r\n.k-fab-solid-success:focus { outline-color: rgba(25, 135, 84, 0.5); }\r\n\r\n.k-fab-solid-warning.k-focus,\r\n.k-fab-solid-warning:focus { outline-color: rgba(255, 193, 7, 0.5); }\r\n\r\n.k-fab-solid-error.k-focus,\r\n.k-fab-solid-error:focus { outline-color: rgba(220, 53, 69, 0.5); }\r\n\r\n.k-fab-solid-dark.k-focus,\r\n.k-fab-solid-dark:focus { outline-color: rgba(33, 37, 41, 0.5); }\r\n\r\n.k-fab-solid-light.k-focus,\r\n.k-fab-solid-light:focus { outline-color: rgba(248, 249, 250, 0.5); }\r\n\r\n.k-fab-solid-inverse.k-focus,\r\n.k-fab-solid-inverse:focus { outline-color: rgba(248, 249, 250, 0.5); }\r\n\r\n.k-active.k-fab-solid-primary,\r\n.k-selected.k-fab-solid-primary,\r\n.k-fab-solid-primary:active {\r\n    background-color: #408cfd;\r\n    border-color: #4c94fe;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-secondary,\r\n.k-selected.k-fab-solid-secondary,\r\n.k-fab-solid-secondary:active {\r\n    background-color: #868e96;\r\n    border-color: #8d959c;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-tertiary,\r\n.k-selected.k-fab-solid-tertiary,\r\n.k-fab-solid-tertiary:active {\r\n    background-color: #8c68ce;\r\n    border-color: #9472d1;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-info,\r\n.k-selected.k-fab-solid-info,\r\n.k-fab-solid-info:active {\r\n    background-color: #3cd5f4;\r\n    border-color: #48d8f5;\r\n    color: black;\r\n}\r\n\r\n.k-active.k-fab-solid-success,\r\n.k-selected.k-fab-solid-success,\r\n.k-fab-solid-success:active {\r\n    background-color: #21b26f;\r\n    border-color: #23bd75;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-warning,\r\n.k-selected.k-fab-solid-warning,\r\n.k-fab-solid-warning:active {\r\n    background-color: #ffce3a;\r\n    border-color: #ffd147;\r\n    color: black;\r\n}\r\n\r\n.k-active.k-fab-solid-error,\r\n.k-selected.k-fab-solid-error,\r\n.k-fab-solid-error:active {\r\n    background-color: #e4606d;\r\n    border-color: #e56b77;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-dark,\r\n.k-selected.k-fab-solid-dark,\r\n.k-fab-solid-dark:active {\r\n    background-color: #383f45;\r\n    border-color: #3d454c;\r\n    color: white;\r\n}\r\n\r\n.k-active.k-fab-solid-light,\r\n.k-selected.k-fab-solid-light,\r\n.k-fab-solid-light:active {\r\n    background-color: white;\r\n    border-color: white;\r\n    color: black;\r\n}\r\n\r\n.k-active.k-fab-solid-inverse,\r\n.k-selected.k-fab-solid-inverse,\r\n.k-fab-solid-inverse:active {\r\n    background-color: white;\r\n    border-color: white;\r\n    color: black;\r\n}\r\n\r\n.k-disabled.k-fab-solid-primary,\r\n.k-fab-solid-primary:disabled {\r\n    background-color: #0846a2;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-secondary,\r\n.k-fab-solid-secondary:disabled {\r\n    background-color: #454b50;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-tertiary,\r\n.k-fab-solid-tertiary:disabled {\r\n    background-color: #472a7c;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-info,\r\n.k-fab-solid-info:disabled {\r\n    background-color: #08819a;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-success,\r\n.k-fab-solid-success:disabled {\r\n    background-color: #105636;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-warning,\r\n.k-fab-solid-warning:disabled {\r\n    background-color: #a37c04;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: black;\r\n}\r\n\r\n.k-disabled.k-fab-solid-error,\r\n.k-fab-solid-error:disabled {\r\n    background-color: #8d222c;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-dark,\r\n.k-fab-solid-dark:disabled {\r\n    background-color: #15181a;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #999999;\r\n}\r\n\r\n.k-disabled.k-fab-solid-light,\r\n.k-fab-solid-light:disabled {\r\n    background-color: #9f9fa0;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: black;\r\n}\r\n\r\n.k-disabled.k-fab-solid-inverse,\r\n.k-fab-solid-inverse:disabled {\r\n    background-color: #9f9fa0;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: black;\r\n}\r\n\r\n.k-fab-item-text {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-fab-item-icon {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: var(--dark-color-kendo-button-text);\r\n    outline: 1px solid var(--dark-color-kendo-button-bg);\r\n}\r\n\r\n.k-fab-item.k-hover .k-fab-item-icon,\r\n.k-fab-item:hover .k-fab-item-icon {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);\r\n    color: white;\r\n    outline: 1px solid #4b545c;\r\n}\r\n\r\n.k-fab-item:focus .k-fab-item-text,\r\n.k-fab-item:focus .k-fab-item-icon,\r\n.k-fab-item.k-focus .k-fab-item-text,\r\n.k-fab-item.k-focus .k-fab-item-icon { outline-color: rgba(52, 58, 64, 0.5); }\r\n\r\n.k-fab-item.k-active .k-fab-item-icon,\r\n.k-fab-item:active .k-fab-item-icon {\r\n    background-color: #4b545c;\r\n    border-color: #515a63;\r\n    color: white;\r\n    outline: 1px solid #515a63;\r\n}\r\n\r\n.k-fab-item.k-disabled .k-fab-item-text,\r\n.k-fab-item.k-disabled .k-fab-item-icon,\r\n.k-fab-item:disabled .k-fab-item-text,\r\n.k-fab-item:disabled .k-fab-item-icon {\r\n    background-color: black;\r\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1744), 0px 1px 18px rgba(0, 0, 0, 0.1552), 0px 3px 5px rgba(0, 0, 0, 0.232);\r\n    color: #5c5c5c;\r\n}\r\n\r\n.k-actionsheet { border-color: transparent; }\r\n\r\n.k-actionsheet-header { border-color: transparent; }\r\n\r\n.k-actionsheet {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-actionsheet-item-description { color: var(--dark-color-subtle-text); }\r\n\r\n.k-actionsheet-action:hover, .k-actionsheet-action.k-state-hover { background-color: var(--dark-color-hovered-bg); }\r\n\r\n.k-actionsheet-action:focus, .k-actionsheet-action.k-state-focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-window {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-window-titlebar { border-color: var(--dark-color-border); }\r\n\r\n.k-dialog-buttongroup { border-color: var(--dark-color-border); }\r\n\r\n.k-drawer {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-drawer-wrapper { scrollbar-color: rgba(156, 156, 156, 0.7) #dedede; }\r\n\r\n.k-drawer-wrapper::-webkit-scrollbar-track { background: #dedede; }\r\n\r\n.k-drawer-wrapper::-webkit-scrollbar-thumb { background: rgba(156, 156, 156, 0.7); }\r\n\r\n.k-drawer-wrapper::-webkit-scrollbar-thumb:hover { background: #9c9c9c; }\r\n\r\n.k-drawer-item:hover, .k-drawer-item.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-drawer-item:focus, .k-drawer-item.k-state-focused {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.k-drawer-item:focus:hover, .k-drawer-item:focus.k-state-hover, .k-drawer-item.k-state-focused:hover, .k-drawer-item.k-state-focused.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-drawer-item.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-drawer-item.k-state-selected:hover, .k-drawer-item.k-state-selected.k-state-hover {\r\n    background-color: #207afd;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-drawer-separator { background-color: #495057; }\r\n\r\n.k-notification {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-notification-wrap > .k-i-close { color: inherit; }\r\n\r\n.k-notification-group .k-notification { box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04); }\r\n\r\n.k-notification-inverse {\r\n    background-color: #fdfdfe;\r\n    border-color: #fefefe;\r\n    color: #818182;\r\n}\r\n\r\n.k-notification-light {\r\n    background-color: #fdfdfe;\r\n    border-color: #fefefe;\r\n    color: #818182;\r\n}\r\n\r\n.k-notification-dark {\r\n    background-color: #c1c2c3;\r\n    border-color: #d3d3d4;\r\n    color: #111315;\r\n}\r\n\r\n.k-notification-error {\r\n    background-color: #f5c6cb;\r\n    border-color: #f8d7da;\r\n    color: #721c24;\r\n}\r\n\r\n.k-notification-warning {\r\n    background-color: #ffeeba;\r\n    border-color: #fff3cd;\r\n    color: #856404;\r\n}\r\n\r\n.k-notification-success {\r\n    background-color: #bfddcf;\r\n    border-color: #d1e7dd;\r\n    color: #0d462c;\r\n}\r\n\r\n.k-notification-info {\r\n    background-color: #bbf0fb;\r\n    border-color: #cff4fc;\r\n    color: #07697d;\r\n}\r\n\r\n.k-notification-tertiary {\r\n    background-color: #d7caee;\r\n    border-color: #e2d9f3;\r\n    color: #3a2264;\r\n}\r\n\r\n.k-notification-secondary {\r\n    background-color: #d6d8db;\r\n    border-color: #e2e3e5;\r\n    color: #383d41;\r\n}\r\n\r\n.k-notification-primary {\r\n    background-color: #bbd6fe;\r\n    border-color: #cfe2ff;\r\n    color: #073984;\r\n}\r\n\r\n.k-card {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-card:focus, .k-card.k-state-focus { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-card-actions { border-color: var(--dark-color-border); }\r\n\r\n.k-card-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-card-footer {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-card-separator,\r\n.k-card .k-separator { border-color: var(--dark-color-border); }\r\n\r\n.k-card-subtitle { color: var(--dark-color-subtle-text); }\r\n\r\n.k-card-primary {\r\n    background-color: #cfe2ff;\r\n    border-color: #bbd6fe;\r\n    color: #073984;\r\n}\r\n\r\n.k-card-primary .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-secondary {\r\n    background-color: #e2e3e5;\r\n    border-color: #d6d8db;\r\n    color: #383d41;\r\n}\r\n\r\n.k-card-secondary .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-tertiary {\r\n    background-color: #e2d9f3;\r\n    border-color: #d7caee;\r\n    color: #3a2264;\r\n}\r\n\r\n.k-card-tertiary .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-info {\r\n    background-color: #cff4fc;\r\n    border-color: #bbf0fb;\r\n    color: #07697d;\r\n}\r\n\r\n.k-card-info .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-success {\r\n    background-color: #d1e7dd;\r\n    border-color: #bfddcf;\r\n    color: #0d462c;\r\n}\r\n\r\n.k-card-success .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-warning {\r\n    background-color: #fff3cd;\r\n    border-color: #ffeeba;\r\n    color: #856404;\r\n}\r\n\r\n.k-card-warning .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-error {\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    color: #721c24;\r\n}\r\n\r\n.k-card-error .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-dark {\r\n    background-color: #d3d3d4;\r\n    border-color: #c1c2c3;\r\n    color: #111315;\r\n}\r\n\r\n.k-card-dark .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-light {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-card-light .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-inverse {\r\n    background-color: #fefefe;\r\n    border-color: #fdfdfe;\r\n    color: #818182;\r\n}\r\n\r\n.k-card-inverse .k-card-subtitle { color: inherit; }\r\n\r\n.k-card-wrap.k-state-focused > .k-card, .k-card-wrap.k-state-selected > .k-card { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-card-callout {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-card:focus .k-card-callout.k-callout-n,\r\n.k-card.k-state-focus .k-card-callout.k-callout-n { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-card:focus .k-card-callout.k-callout-e,\r\n.k-card.k-state-focus .k-card-callout.k-callout-e { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-card:focus .k-card-callout.k-callout-s,\r\n.k-card.k-state-focus .k-card-callout.k-callout-s { box-shadow: 3px -3px 0 0 rgba(73, 80, 87, 0.5); }\r\n\r\n.k-card:focus .k-card-callout.k-callout-w,\r\n.k-card.k-state-focus .k-card-callout.k-callout-w { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-popover {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-popover-header {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-popover-callout {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-bottom-nav-shadow { box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.12); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-primary {\r\n    background-color: var(--dark-color-primary);\r\n    color: #aaccfe;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item:focus { background-color: rgba(170, 204, 254, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-secondary {\r\n    background-color: var(--dark-color-secondary);\r\n    color: #cccfd2;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item:focus { background-color: rgba(204, 207, 210, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-tertiary {\r\n    background-color: var(--dark-color-tertiary);\r\n    color: #cdbde9;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item:focus { background-color: rgba(205, 189, 233, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-info {\r\n    background-color: var(--dark-color-info);\r\n    color: #aaecfa;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item:focus { background-color: rgba(170, 236, 250, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-success {\r\n    background-color: var(--dark-color-success);\r\n    color: #afd5c3;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item:focus { background-color: rgba(175, 213, 195, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-warning {\r\n    background-color: var(--dark-color-warning);\r\n    color: #594402;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item:focus { background-color: rgba(89, 68, 2, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-state-selected { color: black; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-error {\r\n    background-color: var(--dark-color-error);\r\n    color: #f3b8be;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item:focus { background-color: rgba(243, 184, 190, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-dark {\r\n    background-color: var(--dark-color-base-bg);\r\n    color: #b1b3b4;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item:focus { background-color: rgba(177, 179, 180, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-state-selected { color: white; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-light {\r\n    background-color: #f8f9fa;\r\n    color: #575758;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item:focus { background-color: rgba(87, 87, 88, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-state-selected { color: black; }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-inverse {\r\n    background-color: #f8f9fa;\r\n    color: #575758;\r\n}\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item:focus { background-color: rgba(87, 87, 88, 0.2); }\r\n\r\n.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-state-selected { color: black; }\r\n\r\n.k-bottom-nav-flat {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-bottom-nav-flat .k-bottom-nav-item.k-state-focus,\r\n.k-bottom-nav-flat .k-bottom-nav-item.k-state-focused,\r\n.k-bottom-nav-flat .k-bottom-nav-item:focus { background-color: rgba(255, 255, 255, 0.05); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-state-selected { color: var(--dark-color-primary); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-state-selected { color: #8f969c; }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-state-selected { color: var(--dark-color-tertiary); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-state-selected { color: var(--dark-color-info); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-state-selected { color: var(--dark-color-success); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-state-selected { color: var(--dark-color-warning); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-state-selected { color: var(--dark-color-error); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-state-selected { color: var(--dark-color-base-bg); }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-state-selected { color: #fafafb; }\r\n\r\n.k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-state-selected { color: #f8f9fa; }\r\n\r\n.k-ie .k-bottom-nav-item { background-color: transparent; }\r\n\r\n.k-breadcrumb-input-container .k-breadcrumb-input-container { border-color: transparent; }\r\n\r\n.k-breadcrumb {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-breadcrumb:focus, .k-breadcrumb.k-state-focused { box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.06); }\r\n\r\n.k-breadcrumb-link { color: var(--dark-color-link-text); }\r\n\r\n.k-breadcrumb-link:hover, .k-breadcrumb-link.k-state-hover { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-breadcrumb-link:focus, .k-breadcrumb-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.25); }\r\n\r\n.k-breadcrumb-root-link { color: var(--dark-color-link-text); }\r\n\r\n.k-breadcrumb-root-link:hover, .k-breadcrumb-root-link.k-state-hover { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-breadcrumb-root-link:focus, .k-breadcrumb-root-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.25); }\r\n\r\n.k-breadcrumb-last-item .k-breadcrumb-link { color: var(--dark-color-secondary); }\r\n\r\n.k-pager-wrap {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pager-wrap:focus, .k-pager-wrap.k-focus, .k-pager-wrap.k-state-focus, .k-pager-wrap.k-state-focused { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }\r\n\r\n.k-pager-nav.k-link, .k-pager-refresh {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pager-nav.k-link:hover, .k-pager-refresh:hover, .k-state-hover.k-pager-nav.k-link, .k-state-hover.k-pager-refresh {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: #444a4f;\r\n    color: var(--dark-color-link-hover-text);\r\n}\r\n\r\n.k-state-selected.k-pager-nav.k-link, .k-state-selected.k-pager-refresh {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-pager-nav.k-link:focus, .k-pager-refresh:focus, .k-state-focus.k-pager-nav.k-link, .k-state-focus.k-pager-refresh {\r\n    background-color: var(--dark-color-component-bg);\r\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-pager-numbers .k-link {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pager-numbers .k-link:hover, .k-pager-numbers .k-link.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: #444a4f;\r\n    color: var(--dark-color-link-text);\r\n}\r\n\r\n.k-pager-numbers .k-link:focus, .k-pager-numbers .k-link.k-state-focus {\r\n    background-color: var(--dark-color-component-bg);\r\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.k-pager-numbers .k-link.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers .k-current-page .k-link,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers .k-current-page .k-link:hover, .k-pager-md .k-pager-numbers .k-current-page .k-link.k-state-hover,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link:hover,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link.k-state-hover {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n}\r\n\r\n.k-pager-md .k-pager-numbers.k-state-expanded,\r\n.k-pager-sm .k-pager-numbers.k-state-expanded {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers.k-state-expanded .k-link:hover, .k-pager-md .k-pager-numbers.k-state-expanded .k-link.k-state-hover,\r\n.k-pager-sm .k-pager-numbers.k-state-expanded .k-link:hover,\r\n.k-pager-sm .k-pager-numbers.k-state-expanded .k-link.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers.k-state-expanded .k-link.k-state-selected,\r\n.k-pager-sm .k-pager-numbers.k-state-expanded .k-link.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers .k-current-page .k-link,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pager-md .k-pager-numbers .k-current-page .k-link:hover, .k-pager-md .k-pager-numbers .k-current-page .k-link.k-state-hover,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link:hover,\r\n.k-pager-sm .k-pager-numbers .k-current-page .k-link.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: #444a4f;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-stepper { color: var(--dark-color-base-text); }\r\n\r\n.k-stepper .k-step:hover .k-step-indicator, .k-stepper .k-step.k-step-hover .k-step-indicator { background-color: #141414; }\r\n\r\n.k-stepper .k-step.k-step-disabled .k-step-indicator, .k-stepper .k-step:disabled .k-step-indicator { color: var(--dark-color-disabled-text); }\r\n\r\n.k-stepper .k-step-indicator {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-stepper .k-step-indicator::after { box-shadow: inset 0 0 0 2px #000000; }\r\n\r\n.k-stepper .k-step-label:only-child {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-stepper .k-step-done .k-step-indicator {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-stepper .k-step-done:hover .k-step-indicator, .k-stepper .k-step-done.k-step-hover .k-step-indicator { background-color: #207afd; }\r\n\r\n.k-stepper .k-step-done.k-step-disabled .k-step-indicator, .k-stepper .k-step-done:disabled .k-step-indicator {\r\n    background-color: #084298;\r\n    border-color: #084298;\r\n    color: white;\r\n}\r\n\r\n.k-stepper .k-step-current .k-step-indicator {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-stepper .k-step-current:hover .k-step-indicator, .k-stepper .k-step-current.k-step-hover .k-step-indicator { background-color: #207afd; }\r\n\r\n.k-stepper .k-step-current.k-step-disabled .k-step-indicator, .k-stepper .k-step-current:disabled .k-step-indicator {\r\n    background-color: #084298;\r\n    border-color: #084298;\r\n    color: white;\r\n}\r\n\r\n.k-stepper .k-step-success .k-step-label .k-icon { color: var(--dark-color-success); }\r\n\r\n.k-stepper .k-step-error .k-step-label { color: var(--dark-color-error); }\r\n\r\n.k-stepper .k-step-error .k-step-label { color: var(--dark-color-error); }\r\n\r\n.k-stepper .k-step-error:hover .k-step-label, .k-stepper .k-step-error.k-step-hover .k-step-label { color: var(--dark-color-error); }\r\n\r\n.k-stepper .k-step-disabled .k-step-label { color: var(--dark-color-disabled-text); }\r\n\r\n.k-stepper .k-step-focus .k-step-label:only-child,\r\n.k-stepper .k-step-link:focus .k-step-label:only-child { box-shadow: inset 0 0 0 2px #495057; }\r\n\r\n.k-stepper .k-step-label-optional { color: var(--dark-color-subtle-text); }\r\n\r\n.k-tabstrip-items-wrapper {\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-tabstrip-items-wrapper .k-item { color: var(--dark-color-primary); }\r\n\r\n.k-tabstrip-items-wrapper .k-item:hover, .k-tabstrip-items-wrapper .k-item.k-state-hover {\r\n    border-color: #e9ecef;\r\n    color: var(--dark-color-link-hover-text);\r\n}\r\n\r\n.k-tabstrip-items-wrapper .k-item:active, .k-tabstrip-items-wrapper .k-item.k-state-active, .k-tabstrip-items-wrapper .k-item.k-state-selected {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-tabstrip-items-wrapper .k-item:focus, .k-tabstrip-items-wrapper .k-item.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-tabstrip-items-wrapper .k-item.k-tabstrip-dragging { box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.15); }\r\n\r\n.k-tabstrip-content,\r\n.k-tabstrip > .k-content {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-tabstrip-content:focus, .k-tabstrip-content.k-state-focused,\r\n.k-tabstrip > .k-content:focus,\r\n.k-tabstrip > .k-content.k-state-focused { outline-color: #ffffff; }\r\n\r\n.k-tabstrip-top > .k-tabstrip-items .k-item.k-state-hover,\r\n.k-tabstrip-top > .k-tabstrip-items .k-item.k-state-active { border-bottom-color: transparent; }\r\n\r\n.k-tabstrip-bottom > .k-tabstrip-items .k-item.k-state-hover,\r\n.k-tabstrip-bottom > .k-tabstrip-items .k-item.k-state-active { border-top-color: transparent; }\r\n\r\n.k-tabstrip-left > .k-tabstrip-items .k-item.k-state-hover,\r\n.k-tabstrip-left > .k-tabstrip-items .k-item.k-state-active { border-right-color: transparent; }\r\n\r\n.k-tabstrip-right > .k-tabstrip-items .k-item.k-state-hover,\r\n.k-tabstrip-right > .k-tabstrip-items .k-item.k-state-active { border-left-color: transparent; }\r\n\r\n.k-wizard-step:focus, .k-wizard-step.k-state-focused { outline-color: #656565; }\r\n\r\n.k-ie .k-wizard-step:focus,\r\n.k-ie .k-wizard-step.k-state-focused {\r\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);\r\n    outline: none;\r\n}\r\n\r\n.k-expander {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-expander.k-state-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-expander-header {\r\n    background-color: transparent;\r\n    color: var(--dark-color-base-text);\r\n    outline: none;\r\n}\r\n\r\n.k-expander-header:hover, .k-expander-header.k-state-hover { background-color: rgba(0, 0, 0, 0.04); }\r\n\r\n.k-expander-header.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-expander-title { color: var(--dark-color-primary); }\r\n\r\n.k-expander-sub-title { color: var(--dark-color-subtle-text); }\r\n\r\n.k-panelbar {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-panelbar > .k-item > .k-link,\r\n.k-panelbar > .k-panelbar-header > .k-link {\r\n    background-color: var(--dark-color-component-bg);\r\n    color: var(--dark-color-link-text);\r\n}\r\n\r\n.k-panelbar > .k-item > .k-link .k-icon,\r\n.k-panelbar > .k-item > .k-link .k-panelbar-item-icon,\r\n.k-panelbar > .k-panelbar-header > .k-link .k-icon,\r\n.k-panelbar > .k-panelbar-header > .k-link .k-panelbar-item-icon { color: var(--dark-color-base-text); }\r\n\r\n.k-panelbar > .k-item > .k-link:hover,\r\n.k-panelbar > .k-item > .k-link.k-state-hover,\r\n.k-panelbar > .k-panelbar-header > .k-link:hover,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-hover { background-color: #0a0a0a; }\r\n\r\n.k-panelbar > .k-item > .k-link:focus,\r\n.k-panelbar > .k-item > .k-link.k-state-focus,\r\n.k-panelbar > .k-item > .k-link.k-state-focused,\r\n.k-panelbar > .k-panelbar-header > .k-link:focus,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-focus,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-panelbar > .k-item > .k-link.k-state-selected,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-panelbar > .k-item > .k-link.k-state-selected .k-icon,\r\n.k-panelbar > .k-item > .k-link.k-state-selected .k-panelbar-item-icon,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-selected .k-icon,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-selected .k-panelbar-item-icon { color: inherit; }\r\n\r\n.k-panelbar > .k-item > .k-link.k-state-selected:hover,\r\n.k-panelbar > .k-item > .k-link.k-state-selected.k-state-hover,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-selected:hover,\r\n.k-panelbar > .k-panelbar-header > .k-link.k-state-selected.k-state-hover { background-color: #207afd; }\r\n\r\n.k-panelbar .k-group > .k-item > .k-link:hover,\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-hover,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link:hover,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-hover,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link:hover,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-hover,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:hover,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-hover { background-color: #141414; }\r\n\r\n.k-panelbar .k-group > .k-item > .k-link:focus,\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-focus,\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-focused,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link:focus,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-focus,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-focused,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link:focus,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-focus,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-focused,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:focus,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-focus,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-selected,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-selected:hover,\r\n.k-panelbar .k-group > .k-item > .k-link.k-state-selected.k-state-hover,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected:hover,\r\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-state-selected.k-state-hover,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected:hover,\r\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-state-selected.k-state-hover,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected:hover,\r\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-state-selected.k-state-hover { background-color: #207afd; }\r\n\r\n.k-splitter {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-splitbar {\r\n    background-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-splitbar:hover,\r\n.k-splitbar.k-state-hover,\r\n.k-splitbar-horizontal-hover,\r\n.k-splitbar-vertical-hover {\r\n    background-color: #2a2e32;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-splitbar:focus,\r\n.k-splitbar.k-state-focus,\r\n.k-splitbar.k-state-focused {\r\n    background: var(--dark-color-primary);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-ghost-splitbar { background-color: #2a2e32; }\r\n\r\n.k-tilelayout { background-color: #f8f9fa; }\r\n\r\n.k-tilelayout-item:focus,\r\n.k-tilelayout-item.k-state-focus,\r\n.k-tilelayout-item.k-state-focused { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-layout-item-hint {\r\n    background-color: rgba(255, 255, 255, 0.2);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-pane-wrapper,\r\n.k-view {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pane-wrapper .k-pane > .k-view > .k-content {\r\n    background-color: #050505;\r\n    background-position: 50% 50%;\r\n}\r\n\r\n.k-pane-wrapper .k-pane .k-grid-mobile .k-column-active + th.k-header { border-left-color: #ffffff; }\r\n\r\n.k-pane-wrapper .k-pane .k-grid-mobile .k-resize-handle-inner::before { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-nav-current { color: var(--dark-color-primary); }\r\n\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendadate { color: inherit; }\r\n\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-time-period,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendaweekday { color: var(--dark-color-subtle-text); }\r\n\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-wrap,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-datecolumn,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-group-cell,\r\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-all-day { background-color: #050505; }\r\n\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-item,\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-link,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-item,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-link,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-item,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-link,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-item,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-link { color: var(--dark-color-base-text); }\r\n\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-clear,\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-select-all,\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-delete,\r\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-resetSeries,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-clear,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-select-all,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-scheduler-delete,\r\n.k-pane-wrapper .k-pane .k-grid-column-menu .k-scheduler-resetSeries,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-clear,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-select-all,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-delete,\r\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-resetSeries,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-clear,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-select-all,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-delete,\r\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-resetSeries { color: var(--dark-color-primary); }\r\n\r\n.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-state-selected {\r\n    background: none;\r\n    color: var(--dark-color-selected-bg);\r\n}\r\n\r\n.k-columnmenu-item-wrapper + .k-columnmenu-item-wrapper {\r\n    border-top: 1px solid;\r\n    border-top-color: #495057;\r\n}\r\n\r\n.k-grid {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-grid td,\r\n.k-grid .k-grid-content,\r\n.k-grid .k-grid-header-locked,\r\n.k-grid .k-grid-content-locked { border-color: var(--dark-color-border); }\r\n\r\n.k-grid .k-alt { background-color: rgba(255, 255, 255, 0.04); }\r\n\r\n.k-grid tbody tr:not(.k-detail-row):hover,\r\n.k-grid tbody tr:not(.k-detail-row).k-state-hover { background-color: rgba(255, 255, 255, 0.08); }\r\n\r\n.k-grid th.k-state-selected,\r\n.k-grid td.k-state-selected,\r\n.k-grid tr.k-state-selected > td {\r\n    background-color: rgba(13, 110, 253, 0.25);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-grid td.k-state-focused,\r\n.k-grid th.k-state-focused,\r\n.k-grid th:focus,\r\n.k-grid .k-master-row > td:focus,\r\n.k-grid .k-grouping-row > td:focus,\r\n.k-grid .k-detail-row > td:focus,\r\n.k-grid .k-group-footer > td:focus,\r\n.k-grid .k-grid-pager.k-state-focused,\r\n.k-grid .k-grid-pager:focus { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08); }\r\n\r\n.k-grid col.k-sorted,\r\n.k-grid th.k-sorted { background-color: rgba(255, 255, 255, 0.02); }\r\n\r\n.k-grid .k-grid-header-locked,\r\n.k-grid .k-grid-content-locked,\r\n.k-grid .k-grid-header-locked .k-header,\r\n.k-grid .k-grid-content-locked td { border-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-grid .k-grid-header-locked .k-header { border-bottom-color: #495057; }\r\n\r\n.k-grid .k-grid-content-locked .k-group-footer td,\r\n.k-grid .k-grid-content-locked .k-group-cell { border-color: var(--dark-color-border); }\r\n\r\n.k-grid .k-grid-content-locked .k-grouping-row + tr td { border-top-color: #495057; }\r\n\r\n.k-grid .k-grid-content-locked .k-state-selected td { background-color: #031c3f; }\r\n\r\n.k-grid .k-grid-content-locked .k-state-selected.k-alt td { background-color: #031b3d; }\r\n\r\n.k-grid .k-grid-content-locked .k-state-selected:hover td,\r\n.k-grid .k-grid-content-locked .k-state-selected.k-state-hover td { background-color: #031a3b; }\r\n\r\n.k-grid[dir=\"rtl\"] th.k-hierarchy-cell,\r\n.k-grid[dir=\"rtl\"] td.k-hierarchy-cell, .k-grid.k-rtl th.k-hierarchy-cell,\r\n.k-grid.k-rtl td.k-hierarchy-cell { border-left-color: transparent; }\r\n\r\n.k-grid-toolbar { border-color: inherit; }\r\n\r\n.k-grouping-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-grouping-header .k-group-indicator {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-grid-header {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-grid-header .k-i-sort-asc-sm,\r\n.k-grid-header .k-i-sort-desc-sm,\r\n.k-grid-header .k-sort-order { color: var(--dark-color-primary); }\r\n\r\n.k-grid-header .k-grid-filter:focus, .k-grid-header .k-grid-filter.k-state-focus, .k-grid-header .k-grid-filter.k-state-border-down,\r\n.k-grid-header .k-header-column-menu:focus,\r\n.k-grid-header .k-header-column-menu.k-state-focus,\r\n.k-grid-header .k-header-column-menu.k-state-border-down,\r\n.k-grid-header .k-hierarchy-cell .k-icon:focus,\r\n.k-grid-header .k-hierarchy-cell .k-icon.k-state-focus,\r\n.k-grid-header .k-hierarchy-cell .k-icon.k-state-border-down { box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1); }\r\n\r\n.k-grid-header .k-grid-filter.k-state-active,\r\n.k-grid-header .k-header-column-menu.k-state-active,\r\n.k-grid-header .k-hierarchy-cell .k-icon.k-state-active {\r\n    background-color: var(--dark-color-primary);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-grid-header .k-grid-header-sticky,\r\n.k-grid-header .k-grid-header-sticky.k-sorted {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-left-color: rgba(255, 255, 255, 0.5);\r\n    border-right-color: rgba(255, 255, 255, 0.5);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-grid-footer .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-master-row .k-grid-content-sticky {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: rgba(255, 255, 255, 0.2);\r\n    border-top-color: #495057;\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-master-row .k-grid-row-sticky {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-bottom-color: rgba(255, 255, 255, 0.5);\r\n    border-top-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.k-master-row.k-alt .k-grid-content-sticky,\r\n.k-master-row.k-alt .k-grid-row-sticky { background-color: #3b3b3b; }\r\n\r\n.k-master-row.k-state-selected .k-grid-content-sticky,\r\n.k-master-row.k-state-selected .k-grid-row-sticky,\r\n.k-master-row td.k-grid-content-sticky.k-state-selected { background-color: #031c3f; }\r\n\r\n.k-master-row.k-state-selected.k-alt .k-grid-content-sticky,\r\n.k-master-row.k-state-selected.k-alt .k-grid-row-sticky,\r\n.k-master-row.k-alt td.k-grid-content-sticky.k-state-selected { background-color: #031b3d; }\r\n\r\n.k-master-row:hover .k-grid-content-sticky,\r\n.k-master-row:hover .k-grid-row-sticky,\r\n.k-master-row.k-state-hover .k-grid-content-sticky,\r\n.k-master-row.k-state-hover .k-grid-row-sticky { background-color: #434343; }\r\n\r\n.k-master-row.k-state-selected:hover .k-grid-content-sticky,\r\n.k-master-row.k-state-selected:hover .k-grid-row-sticky,\r\n.k-master-row.k-state-selected.k-state-hover .k-grid-content-sticky,\r\n.k-master-row.k-state-selected.k-state-hover .k-grid-row-sticky,\r\n.k-master-row:hover td.k-grid-content-sticky.k-state-selected,\r\n.k-master-row.k-state-hover td.k-grid-content-sticky.k-state-selected { background-color: #031a3b; }\r\n\r\nkendo-grid .k-grid-content-sticky {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-left-color: rgba(255, 255, 255, 0.5);\r\n    border-right-color: rgba(255, 255, 255, 0.5);\r\n    border-top-color: #495057;\r\n}\r\n\r\nkendo-grid .k-grid-content-sticky:hover, kendo-grid .k-grid-content-sticky.k-state-hover { background-color: #141414; }\r\n\r\nkendo-grid .k-grid-row-sticky td {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-bottom-color: rgba(255, 255, 255, 0.5);\r\n    border-top-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\nkendo-grid .k-grid-row-sticky td:hover td,\r\nkendo-grid .k-grid-row-sticky td.k-state-hover td { background-color: #141414; }\r\n\r\nkendo-grid .k-alt .k-grid-content-sticky,\r\nkendo-grid .k-grid-row-sticky.k-alt td { background-color: #0a0a0a; }\r\n\r\nkendo-grid tr.k-state-selected .k-grid-content-sticky,\r\nkendo-grid .k-state-selected.k-grid-row-sticky td,\r\nkendo-grid .k-grid-row-sticky td.k-state-selected,\r\nkendo-grid .k-state-selected.k-grid-content-sticky { background-color: #031c3f; }\r\n\r\nkendo-grid tr.k-state-selected.k-alt .k-grid-content-sticky,\r\nkendo-grid .k-state-selected.k-alt.k-grid-row-sticky td,\r\nkendo-grid .k-alt .k-state-selected.k-grid-content-sticky { background-color: #031b3d; }\r\n\r\nkendo-grid tr:hover .k-grid-content-sticky,\r\nkendo-grid tr.k-state-hover .k-grid-content-sticky,\r\nkendo-grid .k-grid-row-sticky:hover td,\r\nkendo-grid .k-grid-row-sticky.k-state-hover td,\r\nkendo-grid .k-grid-row-sticky.k-alt:hover td,\r\nkendo-grid .k-grid-row-sticky.k-alt.k-state-hover td,\r\nkendo-grid .k-alt:hover .k-grid-content-sticky,\r\nkendo-grid .k-alt.k-state-hover .k-grid-content-sticky { background-color: #141414; }\r\n\r\nkendo-grid tr.k-state-selected:hover .k-grid-content-sticky,\r\nkendo-grid tr.k-state-selected.k-state-hover .k-grid-content-sticky,\r\nkendo-grid .k-state-selected.k-grid-row-sticky:hover td,\r\nkendo-grid .k-state-selected.k-grid-row-sticky.k-state-hover td,\r\nkendo-grid .k-state-selected.k-alt.k-grid-row-sticky:hover td,\r\nkendo-grid .k-state-selected.k-alt.k-grid-row-sticky.k-state-hover td,\r\nkendo-grid tr.k-state-selected.k-alt:hover .k-grid-content-sticky,\r\nkendo-grid tr.k-state-selected.k-alt.k-state-hover .k-grid-content-sticky,\r\nkendo-grid .k-grid-row-sticky:hover td.k-state-selected,\r\nkendo-grid .k-grid-row-sticky.k-state-hover td.k-state-selected,\r\nkendo-grid tr:hover .k-grid-content-sticky.k-state-selected,\r\nkendo-grid tr.k-state-hover .k-grid-content-sticky.k-state-selected { background-color: #031a3b; }\r\n\r\n.k-grouping-row .k-grid-content-sticky { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-grouping-row:hover .k-grid-content-sticky,\r\n.k-grouping-row.k-state-hover .k-grid-content-sticky { background-color: #141414; }\r\n\r\n.k-group-footer td,\r\n.k-group-footer .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-group-footer:hover .k-grid-footer-sticky,\r\n.k-group-footer.k-state-hover .k-grid-footer-sticky { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-grid-footer {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-grid-footer .k-grid-footer-locked { border-color: inherit; }\r\n\r\n.k-grid-footer .k-grid-footer-sticky {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.k-grid-pager {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-grouping-row,\r\n.k-group-cell {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-column-list-item:hover,\r\n.k-columnmenu-item:hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-columnmenu-item:focus,\r\n.k-columnmenu-item.k-state-focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-column-list-wrapper { border-color: inherit; }\r\n\r\n.k-columnmenu-item.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-column-menu .k-menu:not(.k-context-menu) {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:hover, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:focus, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-column-menu-group-header-text {\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-check-all-wrap { border-color: var(--dark-color-border); }\r\n\r\n.k-grid-norecords-template {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-listview {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-listview-content > .k-state-focused { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-listview-content > .k-state-selected { background-color: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-spreadsheet {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-spreadsheet-top-corner,\r\n.k-spreadsheet-row-header,\r\n.k-spreadsheet-column-header {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-syntax-ref { color: #ff8822; }\r\n\r\n.k-syntax-num { color: #0099ff; }\r\n\r\n.k-syntax-str { color: #38b714; }\r\n\r\n.k-syntax-error { color: red; }\r\n\r\n.k-syntax-bool { color: #a9169c; }\r\n\r\n.k-syntax-paren-match { background-color: #caf200; }\r\n\r\n.k-spreadsheet-cell-editor {\r\n    background-color: var(--dark-color-component-bg);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-spreadsheet-merged-cell { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-spreadsheet .k-selection-full,\r\n.k-spreadsheet .k-selection-partial { background-color: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-spreadsheet-selection {\r\n    background-color: rgba(13, 110, 253, 0.25);\r\n    border-color: var(--dark-color-selected-bg);\r\n    box-shadow: inset 0 0 0 1px var(--dark-color-selected-bg);\r\n}\r\n\r\n.k-spreadsheet .k-single-selection::after {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: #000000;\r\n}\r\n\r\n.k-spreadsheet-active-cell {\r\n    background-color: var(--dark-color-component-bg);\r\n    box-shadow: inset 0 0 0 1px var(--dark-color-primary);\r\n}\r\n\r\n.k-spreadsheet-active-cell.k-right { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset -1px 0 0 1px var(--dark-color-primary); }\r\n\r\n.k-spreadsheet-active-cell.k-bottom { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset 0 -1px 0 1px var(--dark-color-primary); }\r\n\r\n.k-spreadsheet-active-cell.k-bottom.k-right { box-shadow: inset 0 0 0 1px var(--dark-color-primary), inset -1px -1px 0 1px var(--dark-color-primary); }\r\n\r\n.k-spreadsheet .k-auto-fill {\r\n    background-color: rgba(13, 110, 253, 0.25);\r\n    border-color: var(--dark-color-primary);\r\n    box-shadow: inset 0 0 0 1px var(--dark-color-primary);\r\n}\r\n\r\n.k-spreadsheet .k-auto-fill-punch { background-color: rgba(0, 0, 0, 0.5); }\r\n\r\n.k-spreadsheet .k-resize-handle,\r\n.k-spreadsheet .k-resize-hint-handle,\r\n.k-spreadsheet .k-resize-hint-marker { background-color: var(--dark-color-primary); }\r\n\r\n.k-spreadsheet-has-comment::after { border-color: var(--dark-color-primary) var(--dark-color-primary) transparent transparent; }\r\n\r\n.k-dirty { border-color: var(--dark-color-error) transparent transparent var(--dark-color-error); }\r\n\r\n.k-spreadsheet .k-filter-range { border-color: var(--dark-color-primary); }\r\n\r\n.k-spreadsheet-filter {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    box-shadow: inset 0 0 0 1px var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-spreadsheet-filter.k-state-active {\r\n    background-color: #4b545c;\r\n    border-color: #515a63;\r\n}\r\n\r\n.k-spreadsheet-filter:hover {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n}\r\n\r\n.k-spreadsheet-filter-menu > .k-menu .k-item.k-state-hover,\r\n.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-spreadsheet-insert-image-dialog { border-color: var(--dark-color-border); }\r\n\r\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-state-hovered { box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5); }\r\n\r\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,\r\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-state-hovered div { color: #000000; }\r\n\r\n.k-spreadsheet-drawing.k-spreadsheet-active-drawing { outline-color: var(--dark-color-primary); }\r\n\r\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n}\r\n\r\n.k-spreadsheet-drawing-anchor-cell { background: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-spreadsheet-popup .k-button:hover,\r\n.k-spreadsheet-popup .k-button.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-spreadsheet-popup .k-button:active,\r\n.k-spreadsheet-popup .k-button.k-state-active,\r\n.k-spreadsheet-popup .k-button.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-rtl .k-spreadsheet .k-spreadsheet-has-comment::after,\r\n.k-spreadsheet[dir=\"rtl\"] .k-spreadsheet-has-comment::after,\r\n[dir=\"rtl\"] .k-spreadsheet .k-spreadsheet-has-comment::after { border-color: var(--dark-color-primary) transparent transparent var(--dark-color-primary); }\r\n\r\n.k-rtl .k-spreadsheet .k-dirty,\r\n.k-spreadsheet[dir=\"rtl\"] .k-dirty,\r\n[dir=\"rtl\"] .k-spreadsheet .k-dirty { border-color: var(--dark-color-error) var(--dark-color-error) transparent transparent; }\r\n\r\n.k-pivotgrid {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pivotgrid-column-headers,\r\n.k-pivotgrid-row-headers,\r\n.k-pivotgrid-empty-cell {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pivotgrid-empty-cell { border-color: #666c72; }\r\n\r\n.k-pivotgrid-row-headers .k-pivotgrid-row .k-pivotgrid-cell:last-child { border-right-color: #666c72; }\r\n\r\n.k-pivotgrid-column-headers .k-pivotgrid-column-total:nth-last-of-type(2) .k-pivotgrid-cell:not(.k-pivotgrid-expanded),\r\n.k-pivotgrid-column-headers .k-pivotgrid-row:last-child { border-bottom-color: #666c72; }\r\n\r\n.k-pivotgrid-header-total,\r\n.k-pivotgrid-total {\r\n    background-color: #141414;\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pivotgrid-row-headers tbody > .k-pivotgrid-row.k-state-hover,\r\n.k-pivotgrid-row-headers tbody > .k-pivotgrid-row:hover,\r\n.k-pivotgrid-column-headers tbody > .k-pivotgrid-row.k-state-hover,\r\n.k-pivotgrid-column-headers tbody > .k-pivotgrid-row:hover,\r\n.k-pivotgrid-values tbody > .k-pivotgrid-row.k-state-hover,\r\n.k-pivotgrid-values tbody > .k-pivotgrid-row:hover { background-color: black; }\r\n\r\n.k-pivotgrid-cell.k-state-focus,\r\n.k-pivotgrid-cell:focus,\r\n.k-master-row > .k-pivotgrid-cell:focus,\r\n.k-grouping-row > .k-pivotgrid-cell:focus,\r\n.k-detail-row > .k-pivotgrid-cell:focus,\r\n.k-group-footer > .k-pivotgrid-cell:focus { box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.15); }\r\n\r\n.k-pivotgrid-cell.k-state-selected,\r\n.k-pivotgrid-row.k-state-selected > .k-pivotgrid-cell { background-color: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-pivotgrid-configurator-button,\r\n.k-pivotgrid-configurator-panel {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pivotgrid-configurator-header { color: var(--dark-color-base-text); }\r\n\r\n.k-pivotgrid-configurator-content .k-fields-list-wrapper { border-color: var(--dark-color-border); }\r\n\r\n.k-calculated-field {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-calculated-field-header { color: var(--dark-color-base-text); }\r\n\r\n.k-filter-menu .k-calculated-item { border-color: var(--dark-color-border); }\r\n\r\n.k-pivotgrid-configurator-content .k-form-field-wrapper { border-color: var(--dark-color-border); }\r\n\r\n.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay { box-shadow: -3px 0px 6px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-flex-row-reverse .k-pivotgrid-configurator-overlay { box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay { box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay { box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16); }\r\n\r\n.k-pivot {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pivot-table { border-color: var(--dark-color-border); }\r\n\r\n.k-pivot-rowheaders {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pivot-toolbar {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pivot-toolbar .k-empty { color: var(--dark-color-subtle-text); }\r\n\r\n.k-alt { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-pivot-toolbar,\r\n.k-pivot-table,\r\n.k-pivot-rowheaders > .k-grid td:first-child,\r\n.k-pivot-table .k-grid-header .k-header.k-first { border-color: var(--dark-color-border); }\r\n\r\n.k-header.k-alt { background-color: #2a2e32; }\r\n\r\n.k-pivot-layout .k-grid-footer {\r\n    background-color: var(--dark-color-base-bg);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-i-kpi-trend-increase,\r\n.k-i-kpi-trend-decrease,\r\n.k-i-kpi-trend-equal { color: inherit; }\r\n\r\n.k-i-kpi-status-hold { color: var(--dark-color-warning); }\r\n\r\n.k-i-kpi-status-deny { color: var(--dark-color-error); }\r\n\r\n.k-i-kpi-status-open { color: var(--dark-color-success); }\r\n\r\n.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields { border-color: var(--dark-color-border); }\r\n\r\n.k-treelist tr.k-footer,\r\n.k-treelist tr.k-footer-template { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-treelist tr.k-footer:hover,\r\n.k-treelist tr.k-footer-template:hover { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-treelist-scrollable .k-group-footer td,\r\n.k-treelist-scrollable .k-grouping-row td,\r\n.k-treelist-scrollable tbody .k-group-cell { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-filter { color: var(--dark-color-base-text); }\r\n\r\n.k-filter .k-filter-preview-field { color: var(--dark-color-primary); }\r\n\r\n.k-filter .k-filter-preview-operator { color: var(--dark-color-subtle-text); }\r\n\r\n.k-filter .k-filter-item::before,\r\n.k-filter .k-filter-toolbar::before,\r\n.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,\r\n.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after { background-color: #495057; }\r\n\r\n.k-filemanager {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-filemanager-breadcrumb { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-filemanager-listview .k-listview-item .k-file-icon { color: #adadad; }\r\n\r\n.k-filemanager-listview .k-listview-item.k-state-selected .k-file-icon {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n    color: inherit;\r\n}\r\n\r\n.k-filemanager-preview .k-file-icon { color: #adadad; }\r\n\r\n.k-taskboard-column {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: transparent;\r\n}\r\n\r\n.k-taskboard-column:focus,\r\n.k-taskboard-column.k-state-focus { border-color: #5c5e61; }\r\n\r\n.k-taskboard-column-header { color: var(--dark-color-base-text); }\r\n\r\n.k-taskboard-pane {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-taskboard-pane-header { color: var(--dark-color-base-text); }\r\n\r\n.k-taskboard-card {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-taskboard-card .k-card-title { color: var(--dark-color-primary); }\r\n\r\n.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-state-focus { color: #0b5cd5; }\r\n\r\n.k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-state-hover { color: #0b5cd5; }\r\n\r\n.k-taskboard-card:focus, .k-taskboard-card.k-state-focus {\r\n    border-color: #6a7075;\r\n    box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5);\r\n}\r\n\r\n.k-taskboard-card:hover, .k-taskboard-card.k-state-hover { border-color: #5b6268; }\r\n\r\n.k-taskboard-card.k-state-selected {\r\n    border-color: #b6d3fe;\r\n    box-shadow: none;\r\n}\r\n\r\n.k-taskboard-drag-placeholder {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n    border-color: var(--dark-color-border);\r\n}\r\n\r\n.k-editor-content > .ProseMirror .k-placeholder::before { color: #ced4da; }\r\n\r\n.k-editor {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\nkendo-editor.k-readonly .k-editor-content.k-state-focused { outline-color: #ffffff; }\r\n\r\n.k-editor-inline .k-table,\r\n.k-editor-inline .k-table td { border-color: var(--dark-color-subtle-text); }\r\n\r\n.k-editor-inline .k-element-resize-handle-wrapper {\r\n    background-color: #ffffff;\r\n    border-color: #000000;\r\n}\r\n\r\n.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker { background-color: #00b0ff; }\r\n\r\n.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker { background-color: #00b0ff; }\r\n\r\n.k-editor-inline:hover, .k-editor-inline.k-state-active { border-color: var(--dark-color-border); }\r\n\r\n.k-editor-resize-handle {\r\n    background-color: #ffffff;\r\n    border-color: #000000;\r\n}\r\n\r\n.ProseMirror-selectednode { outline-color: #8cf; }\r\n\r\n.k-ct-popup .k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    border-color: #207afd;\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-editor-content .k-text-selected, .k-editor-content::selection {\r\n    background-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-editor-content .k-text-highlighted { background-color: #cfe2ff; }\r\n\r\n.k-imageeditor {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-imageeditor-content { background-color: #c6c6c6; }\r\n\r\n.k-imageeditor-canvas { background: linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09) 0), white; }\r\n\r\n.k-imageeditor-action-pane { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-imageeditor-crop { border-color: white; }\r\n\r\n.k-imageeditor-crop-overlay { background-color: rgba(0, 0, 0, 0.3); }\r\n\r\n.k-gantt {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {\r\n    background-color: #495057;\r\n    border-color: #666c72;\r\n}\r\n\r\n.k-gantt .k-treelist-scrollable .k-task-milestone.k-state-selected .k-task-milestone-content {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: #207afd;\r\n}\r\n\r\n.k-gantt .k-gantt-dependencies-svg polyline {\r\n    fill: none;\r\n    stroke: gray;\r\n}\r\n\r\n.k-gantt .k-gantt-dependencies-svg polyline.k-state-selected { stroke: var(--dark-color-selected-bg); }\r\n\r\n.k-gantt-footer { box-shadow: none; }\r\n\r\n.k-gantt-treelist .k-treelist,\r\n.k-gantt-treelist .k-grid-content { background-color: transparent; }\r\n\r\n.k-gantt .k-nonwork-hour { background-color: rgba(255, 255, 255, 0.025); }\r\n\r\n.k-task-dot::before { background-color: #ffffff; }\r\n\r\n.k-task-dot:hover::before,\r\n.k-task-dot.k-state-hover::before {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-task-milestone {\r\n    background-color: #495057;\r\n    border-color: #666c72;\r\n}\r\n\r\n.k-task-milestone.k-task-delayed { background-image: repeating-linear-gradient(90deg, #000000, #000000 2px, var(--dark-color-error) 2px, var(--dark-color-error) 4px); }\r\n\r\n.k-task-milestone.k-task-advanced { background-color: var(--dark-color-success); }\r\n\r\n.k-task-milestone.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    background-image: none;\r\n    border-color: #207afd;\r\n}\r\n\r\n.k-task-summary { color: gray; }\r\n\r\n.k-task-summary.k-task-delayed { color: #ea868f; }\r\n\r\n.k-task-summary.k-task-advanced { color: #75b798; }\r\n\r\n.k-task-summary-complete { color: var(--dark-color-base-text); }\r\n\r\n.k-task-delayed .k-task-summary-complete { color: var(--dark-color-error); }\r\n\r\n.k-task-advanced .k-task-summary-complete { color: var(--dark-color-success); }\r\n\r\n.k-task-summary.k-state-selected { color: #07377f; }\r\n\r\n.k-task-summary.k-state-selected .k-task-summary-complete { color: var(--dark-color-selected-bg); }\r\n\r\n.k-task-single {\r\n    background-color: #495057;\r\n    border-color: var(--dark-color-secondary);\r\n    color: white;\r\n}\r\n\r\n.k-task-single.k-task-delayed { background-color: #ea868f; }\r\n\r\n.k-task-single.k-task-advanced { background-color: #75b798; }\r\n\r\n.k-task-single .k-task-complete { background-color: var(--dark-color-secondary); }\r\n\r\n.k-task-delayed .k-task-complete { background-color: var(--dark-color-error); }\r\n\r\n.k-task-advanced .k-task-complete { background-color: var(--dark-color-success); }\r\n\r\n.k-task-single.k-state-selected {\r\n    background-color: #07377f;\r\n    border-color: var(--dark-color-selected-bg);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-task-single.k-state-selected .k-task-complete { background-color: var(--dark-color-selected-bg); }\r\n\r\n.k-gantt-line { color: gray; }\r\n\r\n.k-gantt-line.k-state-selected { color: var(--dark-color-selected-bg); }\r\n\r\n.k-task-planned .k-task-moment {\r\n    background-color: transparent;\r\n    border-color: var(--dark-color-primary);\r\n}\r\n\r\n.k-task-planned .k-task-duration { background-color: var(--dark-color-primary); }\r\n\r\n.k-task-planned:hover .k-task-moment { background-color: var(--dark-color-primary); }\r\n\r\n.k-task-offset { background-image: repeating-linear-gradient(135deg, #000000, #000000 2px, var(--dark-color-error) 2px, var(--dark-color-error) 4px); }\r\n\r\n.k-task-offset .k-resize-e::before { border-color: #000000; }\r\n\r\n.k-task-offset .k-task-actions { color: #000000; }\r\n\r\n.k-task-offset:hover { background-image: repeating-linear-gradient(135deg, #000000, #000000 2px, #ea868f 2px, #ea868f 4px); }\r\n\r\n.k-pdf-export .k-task-offset { background-color: var(--dark-color-error); }\r\n\r\n.k-offset-tooltip-delayed { background-color: var(--dark-color-error); }\r\n\r\n.k-planned-tooltip { background-color: var(--dark-color-primary); }\r\n\r\n.k-gantt-tooltip-validation::before { background-color: #656565; }\r\n\r\n.k-gantt-tooltip-valid::before { background-color: var(--dark-color-success); }\r\n\r\n.k-gantt-tooltip-invalid::before { background-color: var(--dark-color-error); }\r\n\r\n.k-scheduler {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-current-time { background: #ff0000; }\r\n\r\n.k-current-time.k-current-time-arrow-left { border-right-color: #ff0000; }\r\n\r\n.k-current-time.k-current-time-arrow-right { border-left-color: #ff0000; }\r\n\r\n.k-current-time.k-current-time-arrow-down { border-top-color: #ff0000; }\r\n\r\n.k-scheduler-toolbar {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-scheduler-footer {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-scheduler-header { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-scheduler-header-wrap { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-scheduler-nonwork,\r\n.k-scheduler .k-nonwork-hour { background-color: #0a0a0a; }\r\n\r\n.k-scheduler-other-month,\r\n.k-scheduler .k-other-month { background-color: #0a0a0a; }\r\n\r\n.k-scheduler-layout td.k-state-selected,\r\n.k-scheduler-layout .k-scheduler-cell.k-state-selected { background-color: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-scheduler-layout-flex .k-scheduler-head,\r\n.k-scheduler-layout-flex .k-sticky-cell { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-event {\r\n    background-color: #3485fd;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-event.k-state-selected {\r\n    background-color: var(--dark-color-selected-bg);\r\n    box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.5);\r\n    color: var(--dark-color-selected-text);\r\n}\r\n\r\n.k-event-inverse { color: black; }\r\n\r\n.k-event-ongoing { box-shadow: inset 0px 0px 0px 1px #ff0000; }\r\n\r\n.k-scheduler-marquee::before,\r\n.k-scheduler-marquee::after { border-color: var(--dark-color-primary); }\r\n\r\n.k-scheduler-edit-dialog .k-dialog-buttongroup { border-color: var(--dark-color-border); }\r\n\r\n.k-scheduler-agendaview .k-scheduler-content tr:hover,\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover,\r\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover,\r\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-state-hover {\r\n    background-color: var(--dark-color-hovered-bg);\r\n    border-color: #444a4f;\r\n    color: var(--dark-color-hovered-text);\r\n}\r\n\r\n.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-datecolumn,\r\n.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-groupcolumn,\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover .k-scheduler-datecolumn,\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-hover .k-scheduler-groupcolumn {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected { background-color: rgba(13, 110, 253, 0.25); }\r\n\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected .k-scheduler-datecolumn,\r\n.k-scheduler-agendaview .k-scheduler-content tr.k-state-selected .k-scheduler-groupcolumn { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-scheduler-yearview .k-day-indicator { background-color: var(--dark-color-primary); }\r\n\r\n.k-scheduler-yearview .k-state-selected .k-day-indicator { background-color: white; }\r\n\r\n.k-tooltip.k-scheduler-tooltip {\r\n    background-color: white;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-tooltip.k-scheduler-tooltip .k-callout { color: white; }\r\n\r\n.k-chat {\r\n    background-color: var(--dark-color-body-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-body-text);\r\n}\r\n\r\n.k-chat .k-timestamp { color: var(--dark-color-subtle-text); }\r\n\r\n.k-chat .k-bubble {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-chat .k-bubble a { color: var(--dark-color-primary); }\r\n\r\n.k-chat .k-bubble a:hover { color: var(--dark-color-link-hover-text); }\r\n\r\n.k-chat .k-alt .k-bubble {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-chat .k-quick-reply {\r\n    background-color: transparent;\r\n    border-color: var(--dark-color-primary);\r\n    color: var(--dark-color-primary);\r\n}\r\n\r\n.k-chat .k-quick-reply:hover {\r\n    background-color: var(--dark-color-primary);\r\n    border-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-chat-toolbar,\r\n.k-chat .k-toolbar-box {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: inherit;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-mediaplayer {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-mediaplayer-titlebar {\r\n    background-image: linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0));\r\n    color: #000000;\r\n    text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.k-timeline .k-timeline-flag {\r\n    background-color: var(--dark-color-primary);\r\n    color: white;\r\n}\r\n\r\n.k-timeline .k-timeline-circle { background-color: var(--dark-color-primary); }\r\n\r\n.k-timeline .k-timeline-card .k-card-header {\r\n    background-color: var(--dark-color-component-bg);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-timeline .k-timeline-card .k-card-body { scrollbar-color: #495057 #000000; }\r\n\r\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-track { background: #000000; }\r\n\r\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb { background: #495057; }\r\n\r\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb:hover { background: #444a4f; }\r\n\r\n.k-timeline .k-timeline-date { color: var(--dark-color-base-text); }\r\n\r\n.k-timeline .k-timeline-arrow.k-state-disabled {\r\n    background-color: #22262a;\r\n    border-color: #22262a;\r\n    color: #a6a6a6;\r\n}\r\n\r\n.k-timeline-vertical::after,\r\n.k-timeline-horizontal .k-timeline-track-wrap::after {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n}\r\n\r\n.k-timeline-horizontal .k-timeline-flag::after { background-color: var(--dark-color-primary); }\r\n\r\n.k-timeline-track-item.k-state-focus .k-timeline-circle { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5); }\r\n\r\n.k-pdf-viewer {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-pdf-viewer .k-canvas { background-color: #050505; }\r\n\r\n.k-pdf-viewer .k-page {\r\n    background-color: white;\r\n    border-color: var(--dark-color-border);\r\n    box-shadow: 0 0 15px #495057;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-pdf-viewer .k-search-highlight { background-color: #ffffff; }\r\n\r\n.km-touch-scrollbar { background-color: #333333; }\r\n\r\nkendo-scrollview.k-scrollview-wrap,\r\n.k-scrollview {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-dark kendo-scrollview-pager,\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-nav-wrap,\r\n.k-scrollview.k-scrollview-dark kendo-scrollview-pager,\r\n.k-scrollview.k-scrollview-dark .k-scrollview-nav-wrap { background-color: rgba(0, 0, 0, 0.4); }\r\n\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-next,\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-dark .k-scrollview-prev,\r\n.k-scrollview.k-scrollview-dark .k-scrollview-next,\r\n.k-scrollview.k-scrollview-dark .k-scrollview-prev { color: rgba(0, 0, 0, 0.4); }\r\n\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-light kendo-scrollview-pager,\r\nkendo-scrollview.k-scrollview-wrap.k-scrollview-light .k-scrollview-nav-wrap,\r\n.k-scrollview.k-scrollview-light kendo-scrollview-pager,\r\n.k-scrollview.k-scrollview-light .k-scrollview-nav-wrap { background-color: rgba(255, 255, 255, 0.4); }\r\n\r\n.k-scrollview:focus,\r\n.k-scrollview-wrap:focus { outline: none; }\r\n\r\n.k-scrollview-next,\r\n.k-scrollview-prev {\r\n    background-color: rgba(0, 0, 0, 0);\r\n    color: white;\r\n    text-shadow: rgba(0, 0, 0, 0.3) 0 0 15px;\r\n}\r\n\r\n.k-scrollview-next:focus, .k-scrollview-next.k-state-focus,\r\n.k-scrollview-prev:focus,\r\n.k-scrollview-prev.k-state-focus { color: white; }\r\n\r\n.k-scrollview-next:focus .k-icon::before, .k-scrollview-next.k-state-focus .k-icon::before,\r\n.k-scrollview-prev:focus .k-icon::before,\r\n.k-scrollview-prev.k-state-focus .k-icon::before { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-scrollview-next:hover, .k-scrollview-next.k-state-hover,\r\n.k-scrollview-prev:hover,\r\n.k-scrollview-prev.k-state-hover { color: white; }\r\n\r\n.k-scrollview-pageable > .k-button,\r\n.k-scrollview-nav > .k-link {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n}\r\n\r\n.k-scrollview-pageable > .k-button.k-primary,\r\n.k-scrollview-nav > .k-link.k-primary {\r\n    background: var(--dark-color-primary);\r\n    border: var(--dark-color-primary);\r\n}\r\n\r\n.k-scrollview-pageable > .k-button:focus, .k-scrollview-pageable > .k-button.k-state-focused,\r\n.k-scrollview-nav > .k-link:focus,\r\n.k-scrollview-nav > .k-link.k-state-focused { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-scrollview-nav > .k-link:hover,\r\n.k-scrollview-nav > .k-link.k-state-hover { box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13); }\r\n\r\n.k-scrollview-pageable > .k-button { box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.08); }\r\n\r\n.k-var--accent { background-color: var(--dark-color-primary); }\r\n\r\n.k-var--accent-contrast { background-color: white; }\r\n\r\n.k-var--primary { background-color: var(--dark-color-primary); }\r\n\r\n.k-var--primary-contrast { background-color: white; }\r\n\r\n.k-var--base { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-var--background { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-var--border-radius { margin-top: 0.25rem; }\r\n\r\n.k-var--normal-background { background-color: var(--dark-color-base-bg); }\r\n\r\n.k-var--normal-text-color { background-color: #ffffff; }\r\n\r\n.k-var--hover-background { background-color: var(--dark-color-hovered-bg); }\r\n\r\n.k-var--hover-text-color { background-color: #ffffff; }\r\n\r\n.k-var--selected-background { background-color: var(--dark-color-selected-bg); }\r\n\r\n.k-var--selected-text-color { background-color: #ffffff; }\r\n\r\n.k-var--success { background-color: var(--dark-color-success); }\r\n\r\n.k-var--info { background-color: var(--dark-color-info); }\r\n\r\n.k-var--warning { background-color: var(--dark-color-warning); }\r\n\r\n.k-var--error { background-color: var(--dark-color-error); }\r\n\r\n.k-var--series-a { background-color: var(--dark-color-series-a); }\r\n\r\n.k-var--series-b { background-color: var(--dark-color-series-b); }\r\n\r\n.k-var--series-c { background-color: var(--dark-color-series-c); }\r\n\r\n.k-var--series-d { background-color: var(--dark-color-series-d); }\r\n\r\n.k-var--series-e { background-color: var(--dark-color-series-e); }\r\n\r\n.k-var--series-f { background-color: var(--dark-color-series-f); }\r\n\r\n.k-var--series-1 { background-color: var(--dark-color-series-a); }\r\n\r\n.k-var--series-2 { background-color: var(--dark-color-series-b); }\r\n\r\n.k-var--series-3 { background-color: var(--dark-color-series-c); }\r\n\r\n.k-var--series-4 { background-color: var(--dark-color-series-d); }\r\n\r\n.k-var--series-5 { background-color: var(--dark-color-series-e); }\r\n\r\n.k-var--series-6 { background-color: var(--dark-color-series-f); }\r\n\r\n.k-var--series-7 { background-color: #4a92fe; }\r\n\r\n.k-var--series-8 { background-color: #9371d1; }\r\n\r\n.k-var--series-9 { background-color: #58d7b1; }\r\n\r\n.k-var--series-10 { background-color: #53a57f; }\r\n\r\n.k-var--series-11 { background-color: #ffd145; }\r\n\r\n.k-var--series-12 { background-color: #e56874; }\r\n\r\n.k-var--series-13 { background-color: #0a53be; }\r\n\r\n.k-var--series-14 { background-color: #533291; }\r\n\r\n.k-var--series-15 { background-color: #189771; }\r\n\r\n.k-var--series-16 { background-color: #13653f; }\r\n\r\n.k-var--series-17 { background-color: #bf9105; }\r\n\r\n.k-var--series-18 { background-color: #a52834; }\r\n\r\n.k-var--series-19 { background-color: #86b7fe; }\r\n\r\n.k-var--series-20 { background-color: #b7a1e0; }\r\n\r\n.k-var--series-21 { background-color: #90e4cb; }\r\n\r\n.k-var--series-22 { background-color: #8cc3aa; }\r\n\r\n.k-var--series-23 { background-color: #ffe083; }\r\n\r\n.k-var--series-24 { background-color: #ee9aa2; }\r\n\r\n.k-var--series-25 { background-color: #07377f; }\r\n\r\n.k-var--series-26 { background-color: #382161; }\r\n\r\n.k-var--series-27 { background-color: #10654c; }\r\n\r\n.k-var--series-28 { background-color: #0d442a; }\r\n\r\n.k-var--series-29 { background-color: #806104; }\r\n\r\n.k-var--series-30 { background-color: #6e1b23; }\r\n\r\n.k-var--gauge-pointer { background-color: var(--dark-color-primary); }\r\n\r\n.k-var--gauge-track { background-color: #141414; }\r\n\r\n.k-var--chart-inactive { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-var--chart-major-lines { background-color: rgba(255, 255, 255, 0.08); }\r\n\r\n.k-var--chart-minor-lines { background-color: rgba(255, 255, 255, 0.04); }\r\n\r\n.k-var--chart-notes-background { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-var--chart-notes-border { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-var--chart-notes-lines { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-var--chart-crosshair-background { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-var--chart-error-bars-background { background-color: rgba(255, 255, 255, 0.5); }\r\n\r\n.k-chart,\r\n.k-sparkline,\r\n.k-stockchart {\r\n    background-color: transparent;\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-chart .k-popup,\r\n.k-sparkline .k-popup,\r\n.k-stockchart .k-popup { background: transparent; }\r\n\r\n.k-chart-tooltip { color: var(--dark-color-base-text); }\r\n\r\n.k-chart-tooltip-inverse { color: #000000; }\r\n\r\n.k-chart-crosshair-tooltip,\r\n.k-chart-shared-tooltip {\r\n    background-color: #141414;\r\n    border-color: rgba(255, 255, 255, 0.08);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-selection {\r\n    border-color: rgba(255, 255, 255, 0.08);\r\n    box-shadow: inset 0 1px 7px rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.k-selection-bg { background-color: transparent; }\r\n\r\n.k-handle {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n    cursor: e-resize;\r\n}\r\n\r\n.k-handle:hover {\r\n    background-color: #454d55;\r\n    border-color: #4b545c;\r\n}\r\n\r\n.k-handle div { background-color: transparent; }\r\n\r\n.k-mask { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-treemap {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-treemap .k-treemap-title {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-treemap .k-leaf { color: #000000; }\r\n\r\n.k-treemap .k-leaf.k-inverse { color: #ffffff; }\r\n\r\n.k-treemap .k-leaf.k-state-hover { box-shadow: inset 0 0 0 3px #495057; }\r\n\r\n.k-map {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-map .k-navigator {\r\n    background-color: var(--dark-color-kendo-button-bg);\r\n    border-color: var(--dark-color-kendo-button-bg);\r\n    color: var(--dark-color-kendo-button-text);\r\n}\r\n\r\n.k-map .k-marker { color: var(--dark-color-primary); }\r\n\r\n.k-map .k-attribution { background-color: rgba(0, 0, 0, 0.8); }\r\n\r\n.k-orgchart {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: var(--dark-color-border);\r\n    color: var(--dark-color-component-text);\r\n}\r\n\r\n.k-orgchart-card:focus, .k-orgchart-card.k-state-focus { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-orgchart-node-group-container {\r\n    background-color: var(--dark-color-base-bg);\r\n    border-color: #33363a;\r\n    color: var(--dark-color-base-text);\r\n}\r\n\r\n.k-orgchart-node-group-container:focus,\r\n.k-orgchart-node-group-container.k-state-focus,\r\n.k-orgchart-node-group-container.k-state-focused { box-shadow: 0 0 0 3px rgba(73, 80, 87, 0.5); }\r\n\r\n.k-orgchart-node-group-subtitle { color: var(--dark-color-subtle-text); }\r\n\r\n.k-orgchart-line-h,\r\n.k-orgchart-line-v { color: #33363a; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
